let addressTH = [
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "พระบรมมหาราชวัง",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "วังบูรพาภิรมย์",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "วัดราชบพิธ",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "สำราญราษฎร์",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "ศาลเจ้าพ่อเสือ",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "เสาชิงช้า",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "บวรนิเวศ",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "ตลาดยอด",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "ชนะสงคราม",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "บ้านพานถม",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "บางขุนพรหม",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระนคร",
    "sub-district": "วัดสามพระยา",
    postcode: 10200,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดุสิต",
    "sub-district": "ดุสิต",
    postcode: 10300,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดุสิต",
    "sub-district": "วชิรพยาบาล",
    postcode: 10300,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดุสิต",
    "sub-district": "สวนจิตรลดา",
    postcode: 10300,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดุสิต",
    "sub-district": "สี่แยกมหานาค",
    postcode: 10300,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดุสิต",
    "sub-district": "ถนนนครไชยศรี",
    postcode: 10300,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "กระทุ่มราย",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "หนองจอก",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "คลองสิบ",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "คลองสิบสอง",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "โคกแฝด",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "คู้ฝั่งเหนือ",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "ลำผักชี",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองจอก",
    "sub-district": "ลำต้อยติ่ง",
    postcode: 10530,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางรัก",
    "sub-district": "มหาพฤฒาราม",
    postcode: 10500,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางรัก",
    "sub-district": "สีลม",
    postcode: 10500,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางรัก",
    "sub-district": "สุริยวงศ์",
    postcode: 10500,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางรัก",
    "sub-district": "บางรัก",
    postcode: 10500,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางรัก",
    "sub-district": "สี่พระยา",
    postcode: 10500,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางเขน",
    "sub-district": "อนุสาวรีย์",
    postcode: 10220,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางเขน",
    "sub-district": "ท่าแร้ง",
    postcode: 10220,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกะปิ",
    "sub-district": "คลองจั่น",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกะปิ",
    "sub-district": "หัวหมาก",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตปทุมวัน",
    "sub-district": "รองเมือง",
    postcode: 10330,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตปทุมวัน",
    "sub-district": "วังใหม่",
    postcode: 10330,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตปทุมวัน",
    "sub-district": "ปทุมวัน",
    postcode: 10330,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตปทุมวัน",
    "sub-district": "ลุมพินี",
    postcode: 10330,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตป้อมปราบศัตรูพ่าย",
    "sub-district": "ป้อมปราบ",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตป้อมปราบศัตรูพ่าย",
    "sub-district": "วัดเทพศิรินทร์",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตป้อมปราบศัตรูพ่าย",
    "sub-district": "คลองมหานาค",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตป้อมปราบศัตรูพ่าย",
    "sub-district": "บ้านบาตร",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตป้อมปราบศัตรูพ่าย",
    "sub-district": "วัดโสมนัส",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพระโขนง",
    "sub-district": "บางจาก",
    postcode: 10260,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตมีนบุรี",
    "sub-district": "มีนบุรี",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตมีนบุรี",
    "sub-district": "แสนแสบ",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "ลาดกระบัง",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "คลองสองต้นนุ่น",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "คลองสามประเวศ",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "ลำปลาทิว",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "ทับยาว",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดกระบัง",
    "sub-district": "ขุมทอง",
    postcode: 10520,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตยานนาวา",
    "sub-district": "ช่องนนทรี",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตยานนาวา",
    "sub-district": "บางโพงพาง",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสัมพันธวงศ์",
    "sub-district": "จักรวรรดิ",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสัมพันธวงศ์",
    "sub-district": "สัมพันธวงศ์",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสัมพันธวงศ์",
    "sub-district": "ตลาดน้อย",
    postcode: 10100,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพญาไท",
    "sub-district": "สามเสนใน",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "วัดกัลยาณ์",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "หิรัญรูจี",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "บางยี่เรือ",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "บุคคโล",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "ตลาดพลู",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "ดาวคะนอง",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตธนบุรี",
    "sub-district": "สำเหร่",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกใหญ่",
    "sub-district": "วัดอรุณ",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกใหญ่",
    "sub-district": "วัดท่าพระ",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตห้วยขวาง",
    "sub-district": "ห้วยขวาง",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตห้วยขวาง",
    "sub-district": "บางกะปิ",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตห้วยขวาง",
    "sub-district": "สามเสนนอก",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสาน",
    "sub-district": "สมเด็จเจ้าพระยา",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสาน",
    "sub-district": "คลองสาน",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสาน",
    "sub-district": "บางลำภูล่าง",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสาน",
    "sub-district": "คลองต้นไทร",
    postcode: 10600,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "คลองชักพระ",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "ตลิ่งชัน",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "ฉิมพลี",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "บางพรม",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "บางระมาด",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตตลิ่งชัน",
    "sub-district": "บางเชือกหนัง",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกน้อย",
    "sub-district": "ศิริราช",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกน้อย",
    "sub-district": "บ้านช่างหล่อ",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกน้อย",
    "sub-district": "บางขุนนนท์",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกน้อย",
    "sub-district": "บางขุนศรี",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางกอกน้อย",
    "sub-district": "อรุณอมรินทร์",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางขุนเทียน",
    "sub-district": "ท่าข้าม",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางขุนเทียน",
    "sub-district": "แสมดำ",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "บางหว้า",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "บางด้วน",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "บางจาก",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "บางแวก",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "คลองขวาง",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "ปากคลองภาษีเจริญ",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตภาษีเจริญ",
    "sub-district": "คูหาสวรรค์",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองแขม",
    "sub-district": "หนองแขม",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหนองแขม",
    "sub-district": "หนองค้างพลู",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราษฎร์บูรณะ",
    "sub-district": "ราษฎร์บูรณะ",
    postcode: 10140,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราษฎร์บูรณะ",
    "sub-district": "บางปะกอก",
    postcode: 10140,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางพลัด",
    "sub-district": "บางพลัด",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางพลัด",
    "sub-district": "บางอ้อ",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางพลัด",
    "sub-district": "บางบำหรุ",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางพลัด",
    "sub-district": "บางยี่ขัน",
    postcode: 10700,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดินแดง",
    "sub-district": "ดินแดง",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดินแดง",
    "sub-district": "รัชดาภิเษก",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบึงกุ่ม",
    "sub-district": "คลองกุ่ม",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบึงกุ่ม",
    "sub-district": "นวมินทร์",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบึงกุ่ม",
    "sub-district": "นวลจันทร์",
    postcode: 10230,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสาทร",
    "sub-district": "ทุ่งวัดดอน",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสาทร",
    "sub-district": "ยานนาวา",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสาทร",
    "sub-district": "ทุ่งมหาเมฆ",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางซื่อ",
    "sub-district": "บางซื่อ",
    postcode: 10800,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางซื่อ",
    "sub-district": "วงศ์สว่าง",
    postcode: 10800,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจตุจักร",
    "sub-district": "ลาดยาว",
    postcode: 10900,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจตุจักร",
    "sub-district": "เสนานิคม",
    postcode: 10900,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจตุจักร",
    "sub-district": "จันทรเกษม",
    postcode: 10900,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจตุจักร",
    "sub-district": "จอมพล",
    postcode: 10900,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจตุจักร",
    "sub-district": "จตุจักร",
    postcode: 10900,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางคอแหลม",
    "sub-district": "บางคอแหลม",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางคอแหลม",
    "sub-district": "วัดพระยาไกร",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางคอแหลม",
    "sub-district": "บางโคล่",
    postcode: 10120,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตประเวศ",
    "sub-district": "ประเวศ",
    postcode: 10250,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตประเวศ",
    "sub-district": "หนองบอน",
    postcode: 10250,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตประเวศ",
    "sub-district": "ดอกไม้",
    postcode: 10250,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองเตย",
    "sub-district": "คลองเตย",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองเตย",
    "sub-district": "คลองตัน",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองเตย",
    "sub-district": "พระโขนง",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสวนหลวง",
    "sub-district": "สวนหลวง",
    postcode: 10250,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจอมทอง",
    "sub-district": "บางขุนเทียน",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจอมทอง",
    "sub-district": "บางค้อ",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจอมทอง",
    "sub-district": "บางมด",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตจอมทอง",
    "sub-district": "จอมทอง",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "คลองบางบอน",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "คลองบางพาน",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "บางบอนเหนือ",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "บางบอนใต้",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "คลองบางพราน",
    postcode: 10150,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดอนเมือง",
    "sub-district": "สีกัน",
    postcode: 10210,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดอนเมือง",
    "sub-district": "ดอนเมือง",
    postcode: 10210,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตดอนเมือง",
    "sub-district": "สนามบิน",
    postcode: 10210,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราชเทวี",
    "sub-district": "ทุ่งพญาไท",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตพญาไท",
    "sub-district": "พญาไท",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราชเทวี",
    "sub-district": "ถนนพญาไท",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราชเทวี",
    "sub-district": "ถนนเพชรบุรี",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตราชเทวี",
    "sub-district": "มักกะสัน",
    postcode: 10400,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดพร้าว",
    "sub-district": "ลาดพร้าว",
    postcode: 10230,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตลาดพร้าว",
    "sub-district": "จรเข้บัว",
    postcode: 10230,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวัฒนา",
    "sub-district": "คลองเตยเหนือ",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวัฒนา",
    "sub-district": "คลองตันเหนือ",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวัฒนา",
    "sub-district": "พระโขนงเหนือ",
    postcode: 10110,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางแค",
    "sub-district": "บางแค",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางแค",
    "sub-district": "บางแคเหนือ",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางแค",
    "sub-district": "บางไผ่",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางแค",
    "sub-district": "หลักสอง",
    postcode: 10160,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหลักสี่",
    "sub-district": "ทุ่งสองห้อง",
    postcode: 10210,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตหลักสี่",
    "sub-district": "ตลาดบางเขน",
    postcode: 10210,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสายไหม",
    "sub-district": "สายไหม",
    postcode: 10220,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสายไหม",
    "sub-district": "ออเงิน",
    postcode: 10220,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสายไหม",
    "sub-district": "คลองถนน",
    postcode: 10220,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคันนายาว",
    "sub-district": "คันนายาว",
    postcode: 10230,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคันนายาว",
    "sub-district": "รามอินทรา",
    postcode: 10230,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสะพานสูง",
    "sub-district": "ราษฎร์พัฒนา",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสะพานสูง",
    "sub-district": "สะพานสูง",
    postcode: 10240,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตสะพานสูง",
    "sub-district": "ทับช้าง",
    postcode: 10250,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวังทองหลาง",
    "sub-district": "วังทองหลาง",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวังทองหลาง",
    "sub-district": "สะพานสอง",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวังทองหลาง",
    "sub-district": "คลองเจ้าคุณสิงห์",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตวังทองหลาง",
    "sub-district": "พลับพลา",
    postcode: 10310,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสามวา",
    "sub-district": "สามวาตะวันตก",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสามวา",
    "sub-district": "สามวาตะวันออก",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสามวา",
    "sub-district": "บางชัน",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสามวา",
    "sub-district": "ทรายกองดิน",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตคลองสามวา",
    "sub-district": "ทรายกองดินใต้",
    postcode: 10510,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางนา",
    "sub-district": "บางนา",
    postcode: 10260,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางนา",
    "sub-district": "บางนาใต้",
    postcode: 10260,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตทวีวัฒนา",
    "sub-district": "ทวีวัฒนา",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตทวีวัฒนา",
    "sub-district": "ศาลาธรรมสพน์",
    postcode: 10170,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตทุ่งครุ",
    "sub-district": "บางมด",
    postcode: 10140,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตทุ่งครุ",
    "sub-district": "ทุ่งครุ",
    postcode: 10140,
  },
  {
    province: "กรุงเทพมหานคร",
    district: "เขตบางบอน",
    "sub-district": "บางบอน",
    postcode: 10150,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "ปากน้ำ",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "สำโรงเหนือ",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางเมือง",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "ท้ายบ้าน",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางปูใหม่",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "แพรกษา",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางโปรง",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางปู",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางด้วน",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "บางเมืองใหม่",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "เทพารักษ์",
    postcode: 10270,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "ท้ายบ้านใหม่",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "เมืองสมุทรปราการ",
    "sub-district": "แพรกษาใหม่",
    postcode: 10280,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "บางบ่อ",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "บ้านระกาศ",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "บางพลีน้อย",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "บางเพรียง",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "คลองด่าน",
    postcode: 10550,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "คลองสวน",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "เปร็ง",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางบ่อ",
    "sub-district": "คลองนิยมยาตรา",
    postcode: 10560,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "บางพลีใหญ่",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "บางแก้ว",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "บางปลา",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "บางโฉลง",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "ราชาเทวะ",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางพลี",
    "sub-district": "หนองปรือ",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "ตลาด",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางพึ่ง",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางจาก",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางครุ",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางหญ้าแพรก",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางหัวเสือ",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "สำโรงใต้",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางยอ",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางกะเจ้า",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางน้ำผึ้ง",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางกระสอบ",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "บางกอบัว",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "ทรงคนอง",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "สำโรง",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระประแดง",
    "sub-district": "สำโรงกลาง",
    postcode: 10130,
  },
  {
    province: "สมุทรปราการ",
    district: "พระสมุทรเจดีย์",
    "sub-district": "นาเกลือ",
    postcode: 10290,
  },
  {
    province: "สมุทรปราการ",
    district: "พระสมุทรเจดีย์",
    "sub-district": "บ้านคลองสวน",
    postcode: 10290,
  },
  {
    province: "สมุทรปราการ",
    district: "พระสมุทรเจดีย์",
    "sub-district": "แหลมฟ้าผ่า",
    postcode: 10290,
  },
  {
    province: "สมุทรปราการ",
    district: "พระสมุทรเจดีย์",
    "sub-district": "ปากคลองบางปลากด",
    postcode: 10290,
  },
  {
    province: "สมุทรปราการ",
    district: "พระสมุทรเจดีย์",
    "sub-district": "ในคลองบางปลากด",
    postcode: 10290,
  },
  {
    province: "สมุทรปราการ",
    district: "บางเสาธง",
    "sub-district": "บางเสาธง",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางเสาธง",
    "sub-district": "ศีรษะจรเข้น้อย",
    postcode: 10540,
  },
  {
    province: "สมุทรปราการ",
    district: "บางเสาธง",
    "sub-district": "ศีรษะจรเข้ใหญ่",
    postcode: 10540,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "สวนใหญ่",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "ตลาดขวัญ",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางเขน",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางกระสอ",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "ท่าทราย",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางไผ่",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางศรีเมือง",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางกร่าง",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "ไทรม้า",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "เมืองนนทบุรี",
    "sub-district": "บางรักน้อย",
    postcode: 11000,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "วัดชลอ",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "บางกรวย",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "บางสีทอง",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "บางขนุน",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "บางขุนกอง",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "บางคูเวียง",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "มหาสวัสดิ์",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "ปลายบาง",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางกรวย",
    "sub-district": "ศาลากลาง",
    postcode: 11130,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "บางม่วง",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "บางแม่นาง",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "บางเลน",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "เสาธงหิน",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "บางใหญ่",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางใหญ่",
    "sub-district": "บ้านใหม่",
    postcode: 11140,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "โสนลอย",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "บางบัวทอง",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "บางรักใหญ่",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "บางคูรัด",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "ละหาร",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "ลำโพ",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "พิมลราช",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "บางบัวทอง",
    "sub-district": "บางรักพัฒนา",
    postcode: 11110,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "ไทรน้อย",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "ราษฎร์นิยม",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "หนองเพรางาย",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "ไทรใหญ่",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "ขุนศรี",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "คลองขวาง",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ไทรน้อย",
    "sub-district": "ทวีวัฒนา",
    postcode: 11150,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "ปากเกร็ด",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "บางตลาด",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "บ้านใหม่",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "บางพูด",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "บางตะไนย์",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "คลองพระอุดม",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "ท่าอิฐ",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "เกาะเกร็ด",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "อ้อมเกร็ด",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "คลองข่อย",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "บางพลับ",
    postcode: 11120,
  },
  {
    province: "นนทบุรี",
    district: "ปากเกร็ด",
    "sub-district": "คลองเกลือ",
    postcode: 11120,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางปรอก",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บ้านใหม่",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บ้านกลาง",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บ้านฉาง",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บ้านกระแชง",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางขะแยง",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางคูวัด",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางหลวง",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางเดื่อ",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางพูด",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางพูน",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "บางกะดี",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "สวนพริกไทย",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "เมืองปทุมธานี",
    "sub-district": "หลักหก",
    postcode: 12000,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองหนึ่ง",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองสอง",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองสาม",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองสี่",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองห้า",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองหก",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "คลองหลวง",
    "sub-district": "คลองเจ็ด",
    postcode: 12120,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "ประชาธิปัตย์",
    postcode: 12130,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "บึงยี่โถ",
    postcode: 12130,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "รังสิต",
    postcode: 12110,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "ลำผักกูด",
    postcode: 12110,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "บึงสนั่น",
    postcode: 12110,
  },
  {
    province: "ปทุมธานี",
    district: "ธัญบุรี",
    "sub-district": "บึงน้ำรักษ์",
    postcode: 12110,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "บึงบา",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "บึงบอน",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "บึงกาสาม",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "บึงชำอ้อ",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "หนองสามวัง",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "ศาลาครุ",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "หนองเสือ",
    "sub-district": "นพรัตน์",
    postcode: 12170,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "ระแหง",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "ลาดหลุมแก้ว",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "คูบางหลวง",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "คูขวาง",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "คลองพระอุดม",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "บ่อเงิน",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลาดหลุมแก้ว",
    "sub-district": "หน้าไม้",
    postcode: 12140,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "คูคต",
    postcode: 12130,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "ลาดสวาย",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "บึงคำพร้อย",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "ลำลูกกา",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "บึงทองหลาง",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "ลำไทร",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "บึงคอไห",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "ลำลูกกา",
    "sub-district": "พืชอุดม",
    postcode: 12150,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "บางเตย",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "คลองควาย",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "สามโคก",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "กระแชง",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "บางโพธิ์เหนือ",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "เชียงรากใหญ่",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "บ้านปทุม",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "บ้านงิ้ว",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "เชียงรากน้อย",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "บางกระบือ",
    postcode: 12160,
  },
  {
    province: "ปทุมธานี",
    district: "สามโคก",
    "sub-district": "ท้ายเกาะ",
    postcode: 12160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ประตูชัย",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "กะมัง",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "หอรัตนไชย",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "หัวรอ",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ท่าวาสุกรี",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ไผ่ลิง",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ปากกราน",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ภูเขาทอง",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "สำเภาล่ม",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "สวนพริก",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "คลองตะเคียน",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "วัดตูม",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "หันตรา",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "ลุมพลี",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "บ้านใหม่",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "บ้านเกาะ",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "คลองสวนพลู",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "คลองสระบัว",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "เกาะเรียน",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "บ้านป้อม",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "พระนครศรีอยุธยา",
    "sub-district": "บ้านรุน",
    postcode: 13000,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "ท่าเรือ",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "จำปา",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "ท่าหลวง",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "บ้านร่อม",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "ศาลาลอย",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "วังแดง",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "โพธิ์เอน",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "ปากท่า",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "หนองขนาก",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ท่าเรือ",
    "sub-district": "ท่าเจ้าสนุก",
    postcode: 13130,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "นครหลวง",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "ท่าช้าง",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "บ่อโพง",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "บ้านชุ้ง",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "ปากจั่น",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "บางระกำ",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "บางพระครู",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "แม่ลา",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "หนองปลิง",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "คลองสะแก",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "สามไถ",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "นครหลวง",
    "sub-district": "พระนอน",
    postcode: 13260,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บางไทร",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บางพลี",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "สนามชัย",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บ้านแป้ง",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "หน้าไม้",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บางยี่โท",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "แคออก",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "แคตก",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ช่างเหล็ก",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "กระแชง",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บ้านกลึง",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ช้างน้อย",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ห่อหมก",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ไผ่พระ",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "กกแก้วบูรพา",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ไม้ตรา",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บ้านม้า",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "บ้านเกาะ",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ราชคราม",
    postcode: 13290,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "ช้างใหญ่",
    postcode: 13290,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "โพแตง",
    postcode: 13290,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "เชียงรากน้อย",
    postcode: 13290,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางไทร",
    "sub-district": "โคกช้าง",
    postcode: 13190,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บางบาล",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "วัดยม",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "ไทรน้อย",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "สะพานไทย",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "มหาพราหมณ์",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "กบเจา",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บ้านคลัง",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "พระขาว",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "น้ำเต้า",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "ทางช้าง",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "วัดตะกู",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บางหลวง",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บางหลวงโดด",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บางหัก",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บางชะนี",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางบาล",
    "sub-district": "บ้านกุ่ม",
    postcode: 13250,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านเลน",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "เชียงรากน้อย",
    postcode: 13180,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านโพ",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านกรด",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บางกระสั้น",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "คลองจิก",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านหว้า",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "วัดยม",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บางประแดง",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "สามเรือน",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "เกาะเกิด",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านพลับ",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านแป้ง",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "คุ้งลาน",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "ตลิ่งชัน",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "บ้านสร้าง",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "ตลาดเกรียบ",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะอิน",
    "sub-district": "ขนอนหลวง",
    postcode: 13160,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บางปะหัน",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ขยาย",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บางเดื่อ",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "เสาธง",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ทางกลาง",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บางเพลิง",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "หันสัง",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บางนางร้า",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ตานิม",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ทับน้ำ",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บ้านม้า",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ขวัญเมือง",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บ้านลี่",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "โพธิ์สามต้น",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "พุทเลา",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "ตาลเอน",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางปะหัน",
    "sub-district": "บ้านขล้อ",
    postcode: 13220,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ผักไห่",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "อมฤต",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "บ้านแค",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ลาดน้ำเค็ม",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ตาลาน",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ท่าดินแดง",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ดอนลาน",
    postcode: 13280,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "นาคู",
    postcode: 13280,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "กุฎี",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ลำตะเคียน",
    postcode: 13280,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "โคกช้าง",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "จักราช",
    postcode: 13280,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "หนองน้ำใหญ่",
    postcode: 13280,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "ลาดชิด",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "หน้าโคก",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ผักไห่",
    "sub-district": "บ้านใหญ่",
    postcode: 13120,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "ภาชี",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "โคกม่วง",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "ระโสม",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "หนองน้ำใส",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "ดอนหญ้านาง",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "ไผ่ล้อม",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "กระจิว",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ภาชี",
    "sub-district": "พระแก้ว",
    postcode: 13140,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "ลาดบัวหลวง",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "หลักชัย",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "สามเมือง",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "พระยาบันลือ",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "สิงหนาท",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "คู้สลอด",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "ลาดบัวหลวง",
    "sub-district": "คลองพระยาบันลือ",
    postcode: 13230,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "ลำตาเสา",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "บ่อตาโล่",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "วังน้อย",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "ลำไทร",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "สนับทึบ",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "พยอม",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "หันตะเภา",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "วังจุฬา",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "ข้าวงาม",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "วังน้อย",
    "sub-district": "ชะแมบ",
    postcode: 13170,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "เสนา",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บ้านแพน",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "เจ้าเจ็ด",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "สามกอ",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บางนมโค",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "หัวเวียง",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "มารวิชัย",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บ้านโพธิ์",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "รางจรเข้",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บ้านกระทุ่ม",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บ้านแถว",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "ชายนา",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "สามตุ่ม",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "ลาดงา",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "ดอนทอง",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "บ้านหลวง",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "เสนา",
    "sub-district": "เจ้าเสด็จ",
    postcode: 13110,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "บางซ้าย",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "แก้วฟ้า",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "เต่าเล่า",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "ปลายกลัด",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "เทพมงคล",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บางซ้าย",
    "sub-district": "วังพัฒนา",
    postcode: 13270,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "คานหาม",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "บ้านช้าง",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "สามบัณฑิต",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "บ้านหีบ",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "หนองไม้ซุง",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "อุทัย",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "เสนา",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "หนองน้ำส้ม",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "โพสาวหาญ",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "ธนู",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "อุทัย",
    "sub-district": "ข้าวเม่า",
    postcode: 13210,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "หัวไผ่",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "กะทุ่ม",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "มหาราช",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "น้ำเต้า",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "บางนา",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "โรงช้าง",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "เจ้าปลุก",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "พิตเพียน",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "บ้านนา",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "บ้านขวาง",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "ท่าตอ",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "มหาราช",
    "sub-district": "บ้านใหม่",
    postcode: 13150,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บ้านแพรก",
    "sub-district": "บ้านแพรก",
    postcode: 13240,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บ้านแพรก",
    "sub-district": "บ้านใหม่",
    postcode: 13240,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บ้านแพรก",
    "sub-district": "สำพะเนียง",
    postcode: 13240,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บ้านแพรก",
    "sub-district": "คลองน้อย",
    postcode: 13240,
  },
  {
    province: "พระนครศรีอยุธยา",
    district: "บ้านแพรก",
    "sub-district": "สองห้อง",
    postcode: 13240,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "ตลาดหลวง",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "บางแก้ว",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "ศาลาแดง",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "ป่างิ้ว",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "บ้านแห",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "ตลาดกรวด",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "มหาดไทย",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "บ้านอิฐ",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "หัวไผ่",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "จำปาหล่อ",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "โพสะ",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "บ้านรี",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "คลองวัว",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "เมืองอ่างทอง",
    "sub-district": "ย่านซื่อ",
    postcode: 14000,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "จรเข้ร้อง",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ไชยภูมิ",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ชัยฤทธิ์",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "เทวราช",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ราชสถิตย์",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ไชโย",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "หลักฟ้า",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ชะไว",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ไชโย",
    "sub-district": "ตรีณรงค์",
    postcode: 14140,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "บางปลากด",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "ป่าโมก",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "สายทอง",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "โรงช้าง",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "บางเสด็จ",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "นรสิงห์",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "เอกราช",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "ป่าโมก",
    "sub-district": "โผงเผง",
    postcode: 14130,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "อ่างแก้ว",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "อินทประมูล",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "บางพลับ",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "หนองแม่ไก่",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "รำมะสัก",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "บางระกำ",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "โพธิ์รังนก",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "องครักษ์",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "โคกพุทรา",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "ยางช้าย",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "บ่อแร่",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "ทางพระ",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "สามง่าม",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "บางเจ้าฉ่า",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "โพธิ์ทอง",
    "sub-district": "คำหยาด",
    postcode: 14120,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "แสวงหา",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "ศรีพราน",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "บ้านพราน",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "วังน้ำเย็น",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "สีบัวทอง",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "ห้วยไผ่",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "แสวงหา",
    "sub-district": "จำลอง",
    postcode: 14150,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ไผ่จำศิล",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ศาลเจ้าโรงทอง",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ไผ่ดำพัฒนา",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "สาวร้องไห้",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ท่าช้าง",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ยี่ล้น",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "บางจัก",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ห้วยคันแหลน",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "คลองขนาก",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ไผ่วง",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "สี่ร้อย",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ม่วงเตี้ย",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "หัวตะพาน",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "หลักแก้ว",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "วิเศษชัยชาญ",
    "sub-district": "ตลาดใหม่",
    postcode: 14110,
  },
  {
    province: "อ่างทอง",
    district: "สามโก้",
    "sub-district": "สามโก้",
    postcode: 14160,
  },
  {
    province: "อ่างทอง",
    district: "สามโก้",
    "sub-district": "ราษฎรพัฒนา",
    postcode: 14160,
  },
  {
    province: "อ่างทอง",
    district: "สามโก้",
    "sub-district": "อบทม",
    postcode: 14160,
  },
  {
    province: "อ่างทอง",
    district: "สามโก้",
    "sub-district": "โพธิ์ม่วงพันธ์",
    postcode: 14160,
  },
  {
    province: "อ่างทอง",
    district: "สามโก้",
    "sub-district": "มงคลธรรมนิมิต",
    postcode: 14160,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ทะเลชุบศร",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ท่าหิน",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "กกโก",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โก่งธนู",
    postcode: 13240,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "เขาพระงาม",
    postcode: 15160,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "เขาสามยอด",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โคกกะเทียม",
    postcode: 15160,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โคกลำพาน",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โคกตูม",
    postcode: 15210,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "งิ้วราย",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ดอนโพธิ์",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ตะลุง",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ท่าแค",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ท่าศาลา",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "นิคมสร้างตนเอง",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "บางขันหมาก",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "บ้านข่อย",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ท้ายตลาด",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ป่าตาล",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "พรหมมาสตร์",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โพธิ์เก้าต้น",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "โพธิ์ตรุ",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "สี่คลอง",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "เมืองลพบุรี",
    "sub-district": "ถนนใหญ่",
    postcode: 15000,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "พัฒนานิคม",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "ช่องสาริกา",
    postcode: 15220,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "มะนาวหวาน",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "ดีลัง",
    postcode: 15220,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "โคกสลุง",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "ชอนน้อย",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "หนองบัว",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "ห้วยขุนราม",
    postcode: 18220,
  },
  {
    province: "ลพบุรี",
    district: "พัฒนานิคม",
    "sub-district": "น้ำสุด",
    postcode: 15140,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "โคกสำโรง",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "เกาะแก้ว",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "ถลุงเหล็ก",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "หลุมข้าว",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "ห้วยโป่ง",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "คลองเกตุ",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "สะแกราบ",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "เพนียด",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "วังเพลิง",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "ดงมะรุม",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "วังขอนขว้าง",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "วังจั่น",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "โคกสำโรง",
    "sub-district": "หนองแขม",
    postcode: 15120,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ลำนารายณ์",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ชัยนารายณ์",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ศิลาทิพย์",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ห้วยหิน",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ม่วงค่อม",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "บัวชุม",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ท่าดินดำ",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "มะกอกหวาน",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ซับตะเคียน",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "นาโสม",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "หนองยายโต๊ะ",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "เกาะรัง",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ท่ามะนาว",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "นิคมลำนารายณ์",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "ชัยบาดาล",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "บ้านใหม่สามัคคี",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ชัยบาดาล",
    "sub-district": "เขาแหลม",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "ท่าวุ้ง",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "บางคู้",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "โพตลาดแก้ว",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "บางลี่",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "บางงา",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "โคกสลุด",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "เขาสมอคอน",
    postcode: 15180,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "หัวสำโรง",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "ลาดสาลี่",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "บ้านเบิก",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "ท่าวุ้ง",
    "sub-district": "มุจลินท์",
    postcode: 15150,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "ไผ่ใหญ่",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บ้านทราย",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บ้านกล้วย",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "ดงพลับ",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บ้านชี",
    postcode: 15180,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "พุคา",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "หินปัก",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บางพึ่ง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "หนองทรายขาว",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บางกะพี้",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "หนองเต่า",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "โพนทอง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บางขาม",
    postcode: 15180,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "ดอนดึง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "ชอนม่วง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "หนองกระเบียน",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "สายห้วยแก้ว",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "มหาสอน",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "บ้านหมี่",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "เชียงงา",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "หนองเมือง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "บ้านหมี่",
    "sub-district": "สนามแจง",
    postcode: 15110,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "ท่าหลวง",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "แก่งผักกูด",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "ซับจำปา",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "หนองผักแว่น",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "ทะเลวังวัด",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "ท่าหลวง",
    "sub-district": "หัวลำ",
    postcode: 15230,
  },
  {
    province: "ลพบุรี",
    district: "สระโบสถ์",
    "sub-district": "สระโบสถ์",
    postcode: 15240,
  },
  {
    province: "ลพบุรี",
    district: "สระโบสถ์",
    "sub-district": "มหาโพธิ",
    postcode: 15240,
  },
  {
    province: "ลพบุรี",
    district: "สระโบสถ์",
    "sub-district": "ทุ่งท่าช้าง",
    postcode: 15240,
  },
  {
    province: "ลพบุรี",
    district: "สระโบสถ์",
    "sub-district": "ห้วยใหญ่",
    postcode: 15240,
  },
  {
    province: "ลพบุรี",
    district: "สระโบสถ์",
    "sub-district": "นิยมชัย",
    postcode: 15240,
  },
  {
    province: "ลพบุรี",
    district: "โคกเจริญ",
    "sub-district": "โคกเจริญ",
    postcode: 15250,
  },
  {
    province: "ลพบุรี",
    district: "โคกเจริญ",
    "sub-district": "ยางราก",
    postcode: 15250,
  },
  {
    province: "ลพบุรี",
    district: "โคกเจริญ",
    "sub-district": "หนองมะค่า",
    postcode: 15250,
  },
  {
    province: "ลพบุรี",
    district: "โคกเจริญ",
    "sub-district": "วังทอง",
    postcode: 15250,
  },
  {
    province: "ลพบุรี",
    district: "โคกเจริญ",
    "sub-district": "โคกแสมสาร",
    postcode: 15250,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "ลำสนธิ",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "ซับสมบูรณ์",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "หนองรี",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "กุดตาเพชร",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "เขารวก",
    postcode: 15190,
  },
  {
    province: "ลพบุรี",
    district: "ลำสนธิ",
    "sub-district": "เขาน้อย",
    postcode: 15130,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "หนองม่วง",
    postcode: 15170,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "บ่อทอง",
    postcode: 15170,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "ดงดินแดง",
    postcode: 15170,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "ชอนสมบูรณ์",
    postcode: 15170,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "ยางโทน",
    postcode: 15170,
  },
  {
    province: "ลพบุรี",
    district: "หนองม่วง",
    "sub-district": "ชอนสารเดช",
    postcode: 15170,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "บางพุทรา",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "บางมัญ",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "โพกรวม",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "ม่วงหมู่",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "หัวไผ่",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "ต้นโพธิ์",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "จักรสีห์",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "เมืองสิงห์บุรี",
    "sub-district": "บางกระบือ",
    postcode: 16000,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "สิงห์",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "ไม้ดัด",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "เชิงกลัด",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "โพชนไก่",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "แม่ลา",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "บ้านจ่า",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "พักทัน",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "บางระจัน",
    "sub-district": "สระแจง",
    postcode: 16130,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "โพทะเล",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "บางระจัน",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "โพสังโฆ",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "ท่าข้าม",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "คอทราย",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "ค่ายบางระจัน",
    "sub-district": "หนองกระทุ่ม",
    postcode: 16150,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "พระงาม",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "พรหมบุรี",
    postcode: 16160,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "บางน้ำเชี่ยว",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "บ้านหม้อ",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "บ้านแป้ง",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "หัวป่า",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "พรหมบุรี",
    "sub-district": "โรงช้าง",
    postcode: 16120,
  },
  {
    province: "สิงห์บุรี",
    district: "ท่าช้าง",
    "sub-district": "ถอนสมอ",
    postcode: 16140,
  },
  {
    province: "สิงห์บุรี",
    district: "ท่าช้าง",
    "sub-district": "โพประจักษ์",
    postcode: 16140,
  },
  {
    province: "สิงห์บุรี",
    district: "ท่าช้าง",
    "sub-district": "วิหารขาว",
    postcode: 16140,
  },
  {
    province: "สิงห์บุรี",
    district: "ท่าช้าง",
    "sub-district": "พิกุลทอง",
    postcode: 16140,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "อินทร์บุรี",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ประศุก",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ทับยา",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "งิ้วราย",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ชีน้ำร้าย",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ท่างาม",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "น้ำตาล",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ทองเอน",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "ห้วยชัน",
    postcode: 16110,
  },
  {
    province: "สิงห์บุรี",
    district: "อินทร์บุรี",
    "sub-district": "โพธิ์ชัย",
    postcode: 16110,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "ในเมือง",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "บ้านกล้วย",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "ท่าชัย",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "ชัยนาท",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "เขาท่าพระ",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "หาดท่าเสา",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "ธรรมามูล",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "เสือโฮก",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "เมืองชัยนาท",
    "sub-district": "นางลือ",
    postcode: 17000,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "คุ้งสำเภา",
    postcode: 17110,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "วัดโคก",
    postcode: 17110,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "ศิลาดาน",
    postcode: 17110,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "ท่าฉนวน",
    postcode: 17110,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "หางน้ำสาคร",
    postcode: 17170,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "ไร่พัฒนา",
    postcode: 17170,
  },
  {
    province: "ชัยนาท",
    district: "มโนรมย์",
    "sub-district": "อู่ตะเภา",
    postcode: 17170,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "วัดสิงห์",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "มะขามเฒ่า",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "หนองน้อย",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "หนองบัว",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "หนองขุ่น",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "บ่อแร่",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "วัดสิงห์",
    "sub-district": "วังหมัน",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "สรรพยา",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "ตลุก",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "เขาแก้ว",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "โพนางดำตก",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "โพนางดำออก",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "บางหลวง",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรพยา",
    "sub-district": "หาดอาษา",
    postcode: 17150,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "แพรกศรีราชา",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "เที่ยงแท้",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "ห้วยกรด",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "โพงาม",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "บางขุด",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "ดงคอน",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "ดอนกำ",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "สรรคบุรี",
    "sub-district": "ห้วยกรดพัฒนา",
    postcode: 17140,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "หันคา",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "บ้านเชี่ยน",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "ไพรนกยูง",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "หนองแซง",
    postcode: 17160,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "ห้วยงู",
    postcode: 17160,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "วังไก่เถื่อน",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "เด่นใหญ่",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "หันคา",
    "sub-district": "สามง่ามท่าโบสถ์",
    postcode: 17160,
  },
  {
    province: "ชัยนาท",
    district: "หนองมะโมง",
    "sub-district": "หนองมะโมง",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "หนองมะโมง",
    "sub-district": "วังตะเคียน",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "หนองมะโมง",
    "sub-district": "สะพานหิน",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "หนองมะโมง",
    "sub-district": "กุดจอก",
    postcode: 17120,
  },
  {
    province: "ชัยนาท",
    district: "เนินขาม",
    "sub-district": "เนินขาม",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "เนินขาม",
    "sub-district": "กะบกเตี้ย",
    postcode: 17130,
  },
  {
    province: "ชัยนาท",
    district: "เนินขาม",
    "sub-district": "สุขเดือนห้า",
    postcode: 17130,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "ปากเพรียว",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "ดาวเรือง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "นาโฉง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "โคกสว่าง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "หนองโน",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "หนองยาว",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "ปากข้าวสาร",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "หนองปลาไหล",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "กุดนกเปล้า",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "ตลิ่งชัน",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เมืองสระบุรี",
    "sub-district": "ตะกุด",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "แก่งคอย",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ทับกวาง",
    postcode: 18260,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ตาลเดี่ยว",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ห้วยแห้ง",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ท่าคล้อ",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "หินซ้อน",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "บ้านธาตุ",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "บ้านป่า",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ท่าตูม",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ชะอม",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "สองคอน",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "เตาปูน",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ชำผักแพว",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "แก่งคอย",
    "sub-district": "ท่ามะปราง",
    postcode: 18110,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองแค",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "กุ่มหัก",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "คชสิทธิ์",
    postcode: 18250,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "โคกตูม",
    postcode: 18250,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "โคกแย้",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "บัวลอย",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "ไผ่ต่ำ",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "โพนทอง",
    postcode: 18250,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "ห้วยขมิ้น",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "ห้วยทราย",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองไข่น้ำ",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองแขม",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองจิก",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองจรเข้",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองนาก",
    postcode: 18230,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองปลาหมอ",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองปลิง",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "หนองแค",
    "sub-district": "หนองโรง",
    postcode: 18140,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "หนองหมู",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "บ้านลำ",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "คลองเรือ",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "วิหารแดง",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "หนองสรวง",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "วิหารแดง",
    "sub-district": "เจริญธรรม",
    postcode: 18150,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "หนองแซง",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "หนองควายโซ",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "หนองหัวโพ",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "หนองสีดา",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "หนองกบ",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "ไก่เส่า",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "โคกสะอาด",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "ม่วงหวาน",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "หนองแซง",
    "sub-district": "เขาดิน",
    postcode: 18170,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "บ้านหมอ",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "บางโขมด",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "สร่างโศก",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "ตลาดน้อย",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "หรเทพ",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "โคกใหญ่",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "ไผ่ขวาง",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "บ้านครัว",
    postcode: 18270,
  },
  {
    province: "สระบุรี",
    district: "บ้านหมอ",
    "sub-district": "หนองบัว",
    postcode: 18130,
  },
  {
    province: "สระบุรี",
    district: "ดอนพุด",
    "sub-district": "ดอนพุด",
    postcode: 18210,
  },
  {
    province: "สระบุรี",
    district: "ดอนพุด",
    "sub-district": "ไผ่หลิ่ว",
    postcode: 18210,
  },
  {
    province: "สระบุรี",
    district: "ดอนพุด",
    "sub-district": "บ้านหลวง",
    postcode: 18210,
  },
  {
    province: "สระบุรี",
    district: "ดอนพุด",
    "sub-district": "ดงตะงาว",
    postcode: 18210,
  },
  {
    province: "สระบุรี",
    district: "หนองโดน",
    "sub-district": "หนองโดน",
    postcode: 18190,
  },
  {
    province: "สระบุรี",
    district: "หนองโดน",
    "sub-district": "บ้านกลับ",
    postcode: 18190,
  },
  {
    province: "สระบุรี",
    district: "หนองโดน",
    "sub-district": "ดอนทอง",
    postcode: 18190,
  },
  {
    province: "สระบุรี",
    district: "หนองโดน",
    "sub-district": "บ้านโปร่ง",
    postcode: 18190,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "พระพุทธบาท",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "ขุนโขลน",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "ธารเกษม",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "นายาว",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "พุคำจาน",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "เขาวง",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "ห้วยป่าหวาย",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "พุกร่าง",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "พระพุทธบาท",
    "sub-district": "หนองแก",
    postcode: 18120,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "เสาไห้",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "บ้านยาง",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "หัวปลวก",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "งิ้วงาม",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "ศาลารีไทย",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "ต้นตาล",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "ท่าช้าง",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "พระยาทด",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "ม่วงงาม",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "เริงราง",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "เมืองเก่า",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "เสาไห้",
    "sub-district": "สวนดอกไม้",
    postcode: 18160,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "มวกเหล็ก",
    postcode: 18180,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "มิตรภาพ",
    postcode: 18180,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "หนองย่างเสือ",
    postcode: 18180,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "ลำสมพุง",
    postcode: 30130,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "ลำพญากลาง",
    postcode: 30130,
  },
  {
    province: "สระบุรี",
    district: "มวกเหล็ก",
    "sub-district": "ซับสนุ่น",
    postcode: 18220,
  },
  {
    province: "สระบุรี",
    district: "วังม่วง",
    "sub-district": "แสลงพัน",
    postcode: 18220,
  },
  {
    province: "สระบุรี",
    district: "วังม่วง",
    "sub-district": "คำพราน",
    postcode: 18220,
  },
  {
    province: "สระบุรี",
    district: "วังม่วง",
    "sub-district": "วังม่วง",
    postcode: 18220,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "เขาดินพัฒนา",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "บ้านแก้ง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ผึ้งรวง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "พุแค",
    postcode: 18240,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ห้วยบง",
    postcode: 18000,
  },
  {
    province: "สระบุรี",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "หน้าพระลาน",
    postcode: 18240,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "บางปลาสร้อย",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "มะขามหย่ง",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "บ้านโขด",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "แสนสุข",
    postcode: 20130,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "บ้านสวน",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "หนองรี",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "นาป่า",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "หนองข้างคอก",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "ดอนหัวฬ่อ",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "หนองไม้แดง",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "บางทราย",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "คลองตำหรุ",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "เหมือง",
    postcode: 20130,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "บ้านปึก",
    postcode: 20130,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "ห้วยกะปิ",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "เสม็ด",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "อ่างศิลา",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "เมืองชลบุรี",
    "sub-district": "สำนักบก",
    postcode: 20000,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "บ้านบึง",
    postcode: 20170,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "คลองกิ่ว",
    postcode: 20220,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "มาบไผ่",
    postcode: 20170,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "หนองซ้ำซาก",
    postcode: 20170,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "หนองบอนแดง",
    postcode: 20170,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "หนองชาก",
    postcode: 20170,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "หนองอิรุณ",
    postcode: 20220,
  },
  {
    province: "ชลบุรี",
    district: "บ้านบึง",
    "sub-district": "หนองไผ่แก้ว",
    postcode: 20220,
  },
  {
    province: "ชลบุรี",
    district: "หนองใหญ่",
    "sub-district": "หนองใหญ่",
    postcode: 20190,
  },
  {
    province: "ชลบุรี",
    district: "หนองใหญ่",
    "sub-district": "คลองพลู",
    postcode: 20190,
  },
  {
    province: "ชลบุรี",
    district: "หนองใหญ่",
    "sub-district": "หนองเสือช้าง",
    postcode: 20190,
  },
  {
    province: "ชลบุรี",
    district: "หนองใหญ่",
    "sub-district": "ห้างสูง",
    postcode: 20190,
  },
  {
    province: "ชลบุรี",
    district: "หนองใหญ่",
    "sub-district": "เขาซก",
    postcode: 20190,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "บางละมุง",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "หนองปรือ",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "หนองปลาไหล",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "โป่ง",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "เขาไม้แก้ว",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "ห้วยใหญ่",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "ตะเคียนเตี้ย",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "บางละมุง",
    "sub-district": "นาเกลือ",
    postcode: 20150,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "พานทอง",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "หนองตำลึง",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "มาบโป่ง",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "หนองกะขะ",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "หนองหงษ์",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "โคกขี้หนอน",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "บ้านเก่า",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "หน้าประดู่",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "บางนาง",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "เกาะลอย",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พานทอง",
    "sub-district": "บางหัก",
    postcode: 20160,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "พนัสนิคม",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หน้าพระธาตุ",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "วัดหลวง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "บ้านเซิด",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "นาเริก",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หมอนนาง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "สระสี่เหลี่ยม",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "วัดโบสถ์",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "กุฎโง้ง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หัวถนน",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "ท่าข้าม",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หนองปรือ",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หนองขยาด",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "ทุ่งขวาง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "หนองเหียง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "นาวังหิน",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "บ้านช้าง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "โคกเพลาะ",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "ไร่หลักทอง",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "พนัสนิคม",
    "sub-district": "นามะตูม",
    postcode: 20140,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "ศรีราชา",
    postcode: 20110,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "สุรศักดิ์",
    postcode: 20110,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "ทุ่งสุขลา",
    postcode: 20230,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "บึง",
    postcode: 20230,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "หนองขาม",
    postcode: 20230,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "หนองขาม",
    postcode: 20110,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "เขาคันทรง",
    postcode: 20110,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "บางพระ",
    postcode: 20110,
  },
  {
    province: "ชลบุรี",
    district: "ศรีราชา",
    "sub-district": "บ่อวิน",
    postcode: 20230,
  },
  {
    province: "ชลบุรี",
    district: "เกาะสีชัง",
    "sub-district": "ท่าเทววงษ์",
    postcode: 20120,
  },
  {
    province: "ชลบุรี",
    district: "สัตหีบ",
    "sub-district": "สัตหีบ",
    postcode: 20180,
  },
  {
    province: "ชลบุรี",
    district: "สัตหีบ",
    "sub-district": "นาจอมเทียน",
    postcode: 20250,
  },
  {
    province: "ชลบุรี",
    district: "สัตหีบ",
    "sub-district": "พลูตาหลวง",
    postcode: 20180,
  },
  {
    province: "ชลบุรี",
    district: "สัตหีบ",
    "sub-district": "บางเสร่",
    postcode: 20250,
  },
  {
    province: "ชลบุรี",
    district: "สัตหีบ",
    "sub-district": "แสมสาร",
    postcode: 20180,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "บ่อทอง",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "วัดสุวรรณ",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "บ่อกวางทอง",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "ธาตุทอง",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "เกษตรสุวรรณ",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "บ่อทอง",
    "sub-district": "พลวงทอง",
    postcode: 20270,
  },
  {
    province: "ชลบุรี",
    district: "เกาะจันทร์",
    "sub-district": "เกาะจันทร์",
    postcode: 20240,
  },
  {
    province: "ชลบุรี",
    district: "เกาะจันทร์",
    "sub-district": "ท่าบุญมี",
    postcode: 20240,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "ท่าประดู่",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "เชิงเนิน",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "ตะพง",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "ปากน้ำ",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "เพ",
    postcode: 21160,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "แกลง",
    postcode: 21160,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "บ้านแลง",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "นาตาขวัญ",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "เนินพระ",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "กะเฉด",
    postcode: 21100,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "ทับมา",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "น้ำคอก",
    postcode: 21000,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "ห้วยโป่ง",
    postcode: 21150,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "มาบตาพุด",
    postcode: 21150,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "เนินพระ",
    postcode: 21150,
  },
  {
    province: "ระยอง",
    district: "เมืองระยอง",
    "sub-district": "สำนักทอง",
    postcode: 21100,
  },
  {
    province: "ระยอง",
    district: "บ้านฉาง",
    "sub-district": "สำนักท้อน",
    postcode: 21130,
  },
  {
    province: "ระยอง",
    district: "บ้านฉาง",
    "sub-district": "พลา",
    postcode: 21130,
  },
  {
    province: "ระยอง",
    district: "บ้านฉาง",
    "sub-district": "บ้านฉาง",
    postcode: 21130,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ทางเกวียน",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "วังหว้า",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ชากโดน",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "เนินฆ้อ",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "กร่ำ",
    postcode: 21190,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ชากพง",
    postcode: 21190,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "กระแสบน",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "บ้านนา",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ทุ่งควายกิน",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "กองดิน",
    postcode: 22160,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "คลองปูน",
    postcode: 21170,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "พังราด",
    postcode: 21170,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ปากน้ำกระแส",
    postcode: 21170,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "ห้วยยาง",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "แกลง",
    "sub-district": "สองสลึง",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "วังจันทร์",
    "sub-district": "วังจันทร์",
    postcode: 21210,
  },
  {
    province: "ระยอง",
    district: "วังจันทร์",
    "sub-district": "ชุมแสง",
    postcode: 21210,
  },
  {
    province: "ระยอง",
    district: "วังจันทร์",
    "sub-district": "ป่ายุบใน",
    postcode: 21210,
  },
  {
    province: "ระยอง",
    district: "วังจันทร์",
    "sub-district": "พลงตาเอี่ยม",
    postcode: 21210,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "บ้านค่าย",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "หนองละลอก",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "หนองตะพาน",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "ตาขัน",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "บางบุตร",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "หนองบัว",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "บ้านค่าย",
    "sub-district": "ชากบก",
    postcode: 21120,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "ปลวกแดง",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "ตาสิทธิ์",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "ละหาร",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "แม่น้ำคู้",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "มาบยางพร",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "ปลวกแดง",
    "sub-district": "หนองไร่",
    postcode: 21140,
  },
  {
    province: "ระยอง",
    district: "เขาชะเมา",
    "sub-district": "น้ำเป็น",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "เขาชะเมา",
    "sub-district": "ห้วยทับมอญ",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "เขาชะเมา",
    "sub-district": "ชำฆ้อ",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "เขาชะเมา",
    "sub-district": "เขาน้อย",
    postcode: 21110,
  },
  {
    province: "ระยอง",
    district: "นิคมพัฒนา",
    "sub-district": "นิคมพัฒนา",
    postcode: 21180,
  },
  {
    province: "ระยอง",
    district: "นิคมพัฒนา",
    "sub-district": "มาบข่า",
    postcode: 21180,
  },
  {
    province: "ระยอง",
    district: "นิคมพัฒนา",
    "sub-district": "พนานิคม",
    postcode: 21180,
  },
  {
    province: "ระยอง",
    district: "นิคมพัฒนา",
    "sub-district": "มะขามคู่",
    postcode: 21180,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "ตลาด",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "วัดใหม่",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "คลองนารายณ์",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "เกาะขวาง",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "คมบาง",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "ท่าช้าง",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "จันทนิมิต",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "บางกะจะ",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "แสลง",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "หนองบัว",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "เมืองจันทบุรี",
    "sub-district": "พลับพลา",
    postcode: 22000,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "ขลุง",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "บ่อ",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "เกวียนหัก",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "ตะปอน",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "บางชัน",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "วันยาว",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "ซึ้ง",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "มาบไพ",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "วังสรรพรส",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "ตรอกนอง",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "ตกพรม",
    postcode: 22110,
  },
  {
    province: "จันทบุรี",
    district: "ขลุง",
    "sub-district": "บ่อเวฬุ",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "ท่าใหม่",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "ยายร้า",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "สีพยา",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "บ่อพุ",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "พลอยแหวน",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "เขาวัว",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "เขาบายศรี",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "สองพี่น้อง",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "ทุ่งเบญจา",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "รำพัน",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "โขมง",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "ตะกาดเง้า",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "คลองขุด",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "ท่าใหม่",
    "sub-district": "เขาแก้ว",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "โป่งน้ำร้อน",
    "sub-district": "ทับไทร",
    postcode: 22140,
  },
  {
    province: "จันทบุรี",
    district: "โป่งน้ำร้อน",
    "sub-district": "โป่งน้ำร้อน",
    postcode: 22140,
  },
  {
    province: "จันทบุรี",
    district: "โป่งน้ำร้อน",
    "sub-district": "หนองตาคง",
    postcode: 22140,
  },
  {
    province: "จันทบุรี",
    district: "โป่งน้ำร้อน",
    "sub-district": "เทพนิมิต",
    postcode: 22140,
  },
  {
    province: "จันทบุรี",
    district: "โป่งน้ำร้อน",
    "sub-district": "คลองใหญ่",
    postcode: 22140,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "มะขาม",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "ท่าหลวง",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "ปัถวี",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "วังแซ้ม",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "ฉมัน",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "มะขาม",
    "sub-district": "อ่างคีรี",
    postcode: 22150,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "ปากน้ำแหลมสิงห์",
    postcode: 22130,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "เกาะเปริด",
    postcode: 22130,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "หนองชิ่ม",
    postcode: 22130,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "พลิ้ว",
    postcode: 22190,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "คลองน้ำเค็ม",
    postcode: 22190,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "บางสระเก้า",
    postcode: 22190,
  },
  {
    province: "จันทบุรี",
    district: "แหลมสิงห์",
    "sub-district": "บางกะไชย",
    postcode: 22120,
  },
  {
    province: "จันทบุรี",
    district: "สอยดาว",
    "sub-district": "ปะตง",
    postcode: 22180,
  },
  {
    province: "จันทบุรี",
    district: "สอยดาว",
    "sub-district": "ทุ่งขนาน",
    postcode: 22180,
  },
  {
    province: "จันทบุรี",
    district: "สอยดาว",
    "sub-district": "ทับช้าง",
    postcode: 22180,
  },
  {
    province: "จันทบุรี",
    district: "สอยดาว",
    "sub-district": "ทรายขาว",
    postcode: 22180,
  },
  {
    province: "จันทบุรี",
    district: "สอยดาว",
    "sub-district": "สะตอน",
    postcode: 22180,
  },
  {
    province: "จันทบุรี",
    district: "แก่งหางแมว",
    "sub-district": "แก่งหางแมว",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "แก่งหางแมว",
    "sub-district": "ขุนซ่อง",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "แก่งหางแมว",
    "sub-district": "สามพี่น้อง",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "แก่งหางแมว",
    "sub-district": "พวา",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "แก่งหางแมว",
    "sub-district": "เขาวงกต",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "นายายอาม",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "วังโตนด",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "กระแจะ",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "สนามไชย",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "ช้างข้าม",
    postcode: 22160,
  },
  {
    province: "จันทบุรี",
    district: "นายายอาม",
    "sub-district": "วังใหม่",
    postcode: 22170,
  },
  {
    province: "จันทบุรี",
    district: "เขาคิชฌกูฏ",
    "sub-district": "ชากไทย",
    postcode: 22210,
  },
  {
    province: "จันทบุรี",
    district: "เขาคิชฌกูฏ",
    "sub-district": "พลวง",
    postcode: 22210,
  },
  {
    province: "จันทบุรี",
    district: "เขาคิชฌกูฏ",
    "sub-district": "ตะเคียนทอง",
    postcode: 22210,
  },
  {
    province: "จันทบุรี",
    district: "เขาคิชฌกูฏ",
    "sub-district": "คลองพลู",
    postcode: 22210,
  },
  {
    province: "จันทบุรี",
    district: "เขาคิชฌกูฏ",
    "sub-district": "จันทเขลม",
    postcode: 22210,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "บางพระ",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "หนองเสม็ด",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "หนองโสน",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "หนองคันทรง",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ห้วงน้ำขาว",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "อ่าวใหญ่",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "วังกระแจะ",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ห้วยแร้ง",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "เนินทราย",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ท่าพริก",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ท่ากุ่ม",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ตะกาง",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "ชำราก",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เมืองตราด",
    "sub-district": "แหลมกลัด",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "คลองใหญ่",
    "sub-district": "คลองใหญ่",
    postcode: 23110,
  },
  {
    province: "ตราด",
    district: "คลองใหญ่",
    "sub-district": "ไม้รูด",
    postcode: 23110,
  },
  {
    province: "ตราด",
    district: "คลองใหญ่",
    "sub-district": "หาดเล็ก",
    postcode: 23110,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "เขาสมิง",
    postcode: 23130,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "แสนตุ้ง",
    postcode: 23150,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "วังตะเคียน",
    postcode: 23130,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "ท่าโสม",
    postcode: 23150,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "สะตอ",
    postcode: 23150,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "ประณีต",
    postcode: 23150,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "เทพนิมิต",
    postcode: 23150,
  },
  {
    province: "ตราด",
    district: "เขาสมิง",
    "sub-district": "ทุ่งนนทรี",
    postcode: 23130,
  },
  {
    province: "ตราด",
    district: "บ่อไร่",
    "sub-district": "บ่อพลอย",
    postcode: 23140,
  },
  {
    province: "ตราด",
    district: "บ่อไร่",
    "sub-district": "ช้างทูน",
    postcode: 23140,
  },
  {
    province: "ตราด",
    district: "บ่อไร่",
    "sub-district": "ด่านชุมพล",
    postcode: 23140,
  },
  {
    province: "ตราด",
    district: "บ่อไร่",
    "sub-district": "หนองบอน",
    postcode: 23140,
  },
  {
    province: "ตราด",
    district: "บ่อไร่",
    "sub-district": "นนทรีย์",
    postcode: 23140,
  },
  {
    province: "ตราด",
    district: "แหลมงอบ",
    "sub-district": "แหลมงอบ",
    postcode: 23120,
  },
  {
    province: "ตราด",
    district: "แหลมงอบ",
    "sub-district": "น้ำเชี่ยว",
    postcode: 23120,
  },
  {
    province: "ตราด",
    district: "แหลมงอบ",
    "sub-district": "บางปิด",
    postcode: 23120,
  },
  {
    province: "ตราด",
    district: "แหลมงอบ",
    "sub-district": "คลองใหญ่",
    postcode: 23120,
  },
  {
    province: "ตราด",
    district: "เกาะกูด",
    "sub-district": "เกาะหมาก",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เกาะกูด",
    "sub-district": "เกาะกูด",
    postcode: 23000,
  },
  {
    province: "ตราด",
    district: "เกาะช้าง",
    "sub-district": "เกาะช้าง",
    postcode: 23170,
  },
  {
    province: "ตราด",
    district: "เกาะช้าง",
    "sub-district": "เกาะช้างใต้",
    postcode: 23170,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "หน้าเมือง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "ท่าไข่",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บ้านใหม่",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองนา",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางตีนเป็ด",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางไผ่",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองจุกกระเฌอ",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางแก้ว",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางขวัญ",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองนครเนื่องเขต",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "วังตะเคียน",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "โสธร",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางพระ",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางกะไห",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "หนามแดง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองเปรง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองอุดมชลจร",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "คลองหลวงแพ่ง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "เมืองฉะเชิงเทรา",
    "sub-district": "บางเตย",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "บางคล้า",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "บางสวน",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "บางกระเจ็ด",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "ปากน้ำ",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "ท่าทองหลาง",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "สาวชะโงก",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "เสม็ดเหนือ",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "เสม็ดใต้",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางคล้า",
    "sub-district": "หัวไทร",
    postcode: 24110,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "บางน้ำเปรี้ยว",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "บางขนาก",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "สิงโตทอง",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "หมอนทอง",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "บึงน้ำรักษ์",
    postcode: 24170,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "ดอนเกาะกา",
    postcode: 24170,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "โยธะกา",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "ดอนฉิมพลี",
    postcode: 24170,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "ศาลาแดง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางน้ำเปรี้ยว",
    "sub-district": "โพรงอากาศ",
    postcode: 24150,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "บางปะกง",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "ท่าสะอ้าน",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "บางวัว",
    postcode: 24180,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "บางสมัคร",
    postcode: 24180,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "บางผึ้ง",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "บางเกลือ",
    postcode: 24180,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "สองคลอง",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "หนองจอก",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "พิมพา",
    postcode: 24180,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "ท่าข้าม",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "หอมศีล",
    postcode: 24180,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บางปะกง",
    "sub-district": "เขาดิน",
    postcode: 24130,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "บ้านโพธิ์",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "เกาะไร่",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "คลองขุด",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "คลองบ้านโพธิ์",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "คลองประเวศ",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "ดอนทราย",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "เทพราช",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "ท่าพลับ",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "หนองตีนนก",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "หนองบัว",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "บางซ่อน",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "บางกรูด",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "แหลมประดู่",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "ลาดขวาง",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "สนามจันทร์",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "แสนภูดาษ",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "บ้านโพธิ์",
    "sub-district": "สิบเอ็ดศอก",
    postcode: 24140,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "เกาะขนุน",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "บ้านซ่อง",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "พนมสารคาม",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "เมืองเก่า",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "หนองยาว",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "ท่าถ่าน",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "หนองแหน",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "พนมสารคาม",
    "sub-district": "เขาหินซ้อน",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "ราชสาส์น",
    "sub-district": "บางคา",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "ราชสาส์น",
    "sub-district": "เมืองใหม่",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "ราชสาส์น",
    "sub-district": "ดงน้อย",
    postcode: 24120,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "สนามชัยเขต",
    "sub-district": "คู้ยายหมี",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "สนามชัยเขต",
    "sub-district": "ท่ากระดาน",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "สนามชัยเขต",
    "sub-district": "ทุ่งพระยา",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "สนามชัยเขต",
    "sub-district": "ลาดกระทิง",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "แปลงยาว",
    "sub-district": "แปลงยาว",
    postcode: 24190,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "แปลงยาว",
    "sub-district": "วังเย็น",
    postcode: 24190,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "แปลงยาว",
    "sub-district": "หัวสำโรง",
    postcode: 24190,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "แปลงยาว",
    "sub-district": "หนองไม้แก่น",
    postcode: 24190,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "ท่าตะเกียบ",
    "sub-district": "ท่าตะเกียบ",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "ท่าตะเกียบ",
    "sub-district": "คลองตะเกรา",
    postcode: 24160,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "คลองเขื่อน",
    "sub-district": "ก้อนแก้ว",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "คลองเขื่อน",
    "sub-district": "คลองเขื่อน",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "คลองเขื่อน",
    "sub-district": "บางเล่า",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "คลองเขื่อน",
    "sub-district": "บางโรง",
    postcode: 24000,
  },
  {
    province: "ฉะเชิงเทรา",
    district: "คลองเขื่อน",
    "sub-district": "บางตลาด",
    postcode: 24110,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "หน้าเมือง",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "รอบเมือง",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "วัดโบสถ์",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "บางเดชะ",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "ท่างาม",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "บางบริบูรณ์",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "ดงพระราม",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "บ้านพระ",
    postcode: 25230,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "โคกไม้ลาย",
    postcode: 25230,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "ไม้เค็ด",
    postcode: 25230,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "ดงขี้เหล็ก",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "เนินหอม",
    postcode: 25230,
  },
  {
    province: "ปราจีนบุรี",
    district: "เมืองปราจีนบุรี",
    "sub-district": "โนนห้อม",
    postcode: 25000,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "กบินทร์",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "เมืองเก่า",
    postcode: 25240,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "วังดาล",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "นนทรี",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "ย่านรี",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "วังตะเคียน",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "หาดนางแก้ว",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "ลาดตะเคียน",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "บ้านนา",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "บ่อทอง",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "หนองกี่",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "นาแขม",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "เขาไม้แก้ว",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "กบินทร์บุรี",
    "sub-district": "วังท่าช้าง",
    postcode: 25110,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "นาดี",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "สำพันตา",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "สะพานหิน",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "ทุ่งโพธิ์",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "แก่งดินสอ",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "นาดี",
    "sub-district": "บุพราหมณ์",
    postcode: 25220,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บ้านสร้าง",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางกระเบา",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางเตย",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางยาง",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางแตน",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางพลวง",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางปลาร้า",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "บางขาม",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "บ้านสร้าง",
    "sub-district": "กระทุ่มแพ้ว",
    postcode: 25150,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "ประจันตคาม",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "เกาะลอย",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "บ้านหอย",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "หนองแสง",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "ดงบัง",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "คำโตนด",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "บุฝ้าย",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "หนองแก้ว",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ประจันตคาม",
    "sub-district": "โพธิ์งาม",
    postcode: 25130,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "ศรีมหาโพธิ",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "สัมพันธ์",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "บ้านทาม",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "ท่าตูม",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "บางกุ้ง",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "ดงกระทงยาม",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "หนองโพรง",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "หัวหว้า",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "หาดยาง",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมหาโพธิ",
    "sub-district": "กรอกสมบูรณ์",
    postcode: 25140,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมโหสถ",
    "sub-district": "โคกปีบ",
    postcode: 25190,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมโหสถ",
    "sub-district": "โคกไทย",
    postcode: 25190,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมโหสถ",
    "sub-district": "คู้ลำพัน",
    postcode: 25190,
  },
  {
    province: "ปราจีนบุรี",
    district: "ศรีมโหสถ",
    "sub-district": "ไผ่ชะเลือด",
    postcode: 25190,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "นครนายก",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ท่าช้าง",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "บ้านใหญ่",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "วังกระโจม",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ท่าทราย",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ดอนยอ",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ศรีจุฬา",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ดงละคร",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "ศรีนาวา",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "สาริกา",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "หินตั้ง",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "เขาพระ",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "เมืองนครนายก",
    "sub-district": "พรหมณี",
    postcode: 26000,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "เกาะหวาย",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "เกาะโพธิ์",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "ปากพลี",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "โคกกรวด",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "ท่าเรือ",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "หนองแสง",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "ปากพลี",
    "sub-district": "นาหินลาด",
    postcode: 26130,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "บ้านนา",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "บ้านพร้าว",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "บ้านพริก",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "อาษา",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "ทองหลาง",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "บางอ้อ",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "พิกุลออก",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "ป่าขะ",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "เขาเพิ่ม",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "บ้านนา",
    "sub-district": "ศรีกะอาง",
    postcode: 26110,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "พระอาจารย์",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "บึงศาล",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "ศีรษะกระบือ",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "โพธิ์แทน",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "บางสมบูรณ์",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "ทรายมูล",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "บางปลากด",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "บางลูกเสือ",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "องครักษ์",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "ชุมพล",
    postcode: 26120,
  },
  {
    province: "นครนายก",
    district: "องครักษ์",
    "sub-district": "คลองใหญ่",
    postcode: 26120,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "สระแก้ว",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "บ้านแก้ง",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "ศาลาลำดวน",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "โคกปี่ฆ้อง",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "ท่าแยก",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "ท่าเกษม",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "สระขวัญ",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เมืองสระแก้ว",
    "sub-district": "หนองบอน",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "คลองหาด",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "ไทยอุดม",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "ซับมะกรูด",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "ไทรเดี่ยว",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "คลองไก่เถื่อน",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "เบญจขร",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "คลองหาด",
    "sub-district": "ไทรทอง",
    postcode: 27260,
  },
  {
    province: "สระแก้ว",
    district: "ตาพระยา",
    "sub-district": "ตาพระยา",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "ตาพระยา",
    "sub-district": "ทัพเสด็จ",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "ตาพระยา",
    "sub-district": "ทัพราช",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "ตาพระยา",
    "sub-district": "ทัพไทย",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "ตาพระยา",
    "sub-district": "โคคลาน",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "วังน้ำเย็น",
    "sub-district": "วังน้ำเย็น",
    postcode: 27210,
  },
  {
    province: "สระแก้ว",
    district: "วังน้ำเย็น",
    "sub-district": "ตาหลังใน",
    postcode: 27210,
  },
  {
    province: "สระแก้ว",
    district: "วังน้ำเย็น",
    "sub-district": "คลองหินปูน",
    postcode: 27210,
  },
  {
    province: "สระแก้ว",
    district: "วังน้ำเย็น",
    "sub-district": "ทุ่งมหาเจริญ",
    postcode: 27210,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "วัฒนานคร",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "ท่าเกวียน",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "ผักขะ",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "โนนหมากเค็ง",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "หนองน้ำใส",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "ช่องกุ่ม",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "หนองแวง",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "แซร์ออ",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "หนองหมากฝ้าย",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "หนองตะเคียนบอน",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "วัฒนานคร",
    "sub-district": "ห้วยโจด",
    postcode: 27160,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "อรัญประเทศ",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "เมืองไผ่",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "หันทราย",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "คลองน้ำใส",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "ท่าข้าม",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "ป่าไร่",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "ทับพริก",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "บ้านใหม่หนองไทร",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "ผ่านศึก",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "หนองสังข์",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "คลองทับจันทร์",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "ฟากห้วย",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "อรัญประเทศ",
    "sub-district": "บ้านด่าน",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "เขาฉกรรจ์",
    "sub-district": "เขาฉกรรจ์",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เขาฉกรรจ์",
    "sub-district": "หนองหว้า",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เขาฉกรรจ์",
    "sub-district": "พระเพลิง",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "เขาฉกรรจ์",
    "sub-district": "เขาสามสิบ",
    postcode: 27000,
  },
  {
    province: "สระแก้ว",
    district: "โคกสูง",
    "sub-district": "โคกสูง",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "โคกสูง",
    "sub-district": "หนองม่วง",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "โคกสูง",
    "sub-district": "หนองแวง",
    postcode: 27180,
  },
  {
    province: "สระแก้ว",
    district: "โคกสูง",
    "sub-district": "โนนหมากมุ่น",
    postcode: 27120,
  },
  {
    province: "สระแก้ว",
    district: "วังสมบูรณ์",
    "sub-district": "วังสมบูรณ์",
    postcode: 27250,
  },
  {
    province: "สระแก้ว",
    district: "วังสมบูรณ์",
    "sub-district": "วังใหม่",
    postcode: 27250,
  },
  {
    province: "สระแก้ว",
    district: "วังสมบูรณ์",
    "sub-district": "วังทอง",
    postcode: 27250,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "ในเมือง",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "โพธิ์กลาง",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองจะบก",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "โคกสูง",
    postcode: 30310,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "มะเริง",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองระเวียง",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "ปรุใหญ่",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หมื่นไวย",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "พลกรัง",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองไผ่ล้อม",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หัวทะเล",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "บ้านเกาะ",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "บ้านใหม่",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "พุดซา",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "บ้านโพธิ์",
    postcode: 30310,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "จอหอ",
    postcode: 30310,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "โคกกรวด",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "ไชยมงคล",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองบัวศาลา",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "สุรนารี",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "สีมุม",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "ตลาด",
    postcode: 30310,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "พะเนา",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองกระทุ่ม",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองนครราชสีมา",
    "sub-district": "หนองไข่น้ำ",
    postcode: 30310,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "แชะ",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "เฉลียง",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "ครบุรี",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "โคกกระชาย",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "จระเข้หิน",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "มาบตะโกเอน",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "อรพิมพ์",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "บ้านใหม่",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "ลำเพียก",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "ครบุรีใต้",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "ตะแบกบาน",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "ครบุรี",
    "sub-district": "สระว่านพระยา",
    postcode: 30250,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "เสิงสาง",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "สระตะเคียน",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "โนนสมบูรณ์",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "กุดโบสถ์",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "สุขไพบูลย์",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "เสิงสาง",
    "sub-district": "บ้านราษฎร์",
    postcode: 30330,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "เมืองคง",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "คูขาด",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "เทพาลัย",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "ตาจั่น",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "บ้านปรางค์",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "หนองมะนาว",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "หนองบัว",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "โนนเต็ง",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "ดอนใหญ่",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "คง",
    "sub-district": "ขามสมบูรณ์",
    postcode: 30260,
  },
  {
    province: "นครราชสีมา",
    district: "บ้านเหลื่อม",
    "sub-district": "บ้านเหลื่อม",
    postcode: 30350,
  },
  {
    province: "นครราชสีมา",
    district: "บ้านเหลื่อม",
    "sub-district": "วังโพธิ์",
    postcode: 30350,
  },
  {
    province: "นครราชสีมา",
    district: "บ้านเหลื่อม",
    "sub-district": "โคกกระเบื้อง",
    postcode: 30350,
  },
  {
    province: "นครราชสีมา",
    district: "บ้านเหลื่อม",
    "sub-district": "ช่อระกา",
    postcode: 30350,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "จักราช",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "ทองหลาง",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "สีสุก",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "หนองขาม",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "หนองพลวง",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "ศรีละกอ",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "คลองเมือง",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "จักราช",
    "sub-district": "หินโคน",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "กระโทก",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "พลับพลา",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ท่าอ่าง",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ทุ่งอรุณ",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ท่าลาดขาว",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ท่าจะหลุง",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ท่าเยี่ยม",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "โชคชัย",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ละลมใหม่พัฒนา",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "โชคชัย",
    "sub-district": "ด่านเกวียน",
    postcode: 30190,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "กุดพิมาน",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "ด่านขุนทด",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "ด่านนอก",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "ด่านใน",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "ตะเคียน",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "บ้านเก่า",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "บ้านแปรง",
    postcode: 36220,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "พันชนะ",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "สระจรเข้",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "หนองกราด",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "หนองบัวตะเกียด",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "หนองบัวละคร",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "หินดาด",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "ห้วยบง",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "โนนเมืองพัฒนา",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "ด่านขุนทด",
    "sub-district": "หนองไทร",
    postcode: 36220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "โนนไทย",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "ด่านจาก",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "กำปัง",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "สำโรง",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "ค้างพลู",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "บ้านวัง",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "บัลลังก์",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "สายออ",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "ถนนโพธิ์",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนไทย",
    "sub-district": "มะค่า",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "โนนสูง",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ใหม่",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "โตนด",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "บิง",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ดอนชมพู",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ธารปราสาท",
    postcode: 30420,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "หลุมข้าว",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "มะค่า",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "พลสงคราม",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "จันอัด",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ขามเฒ่า",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ด่านคล้า",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ลำคอหงษ์",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "เมืองปราสาท",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ดอนหวาย",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "โนนสูง",
    "sub-district": "ลำมูล",
    postcode: 30160,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "ขามสะแกแสง",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "โนนเมือง",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "เมืองนาท",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "ชีวึก",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "พะงาด",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "หนองหัวฟาน",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "ขามสะแกแสง",
    "sub-district": "เมืองเกษตร",
    postcode: 30290,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "บัวใหญ่",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "ห้วยยาง",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "เสมาใหญ่",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "ดอนตะหนิน",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "หนองบัวสะอาด",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "โนนทองหลาง",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "กุดจอก",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "ด่านช้าง",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "ขุนทอง",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวใหญ่",
    "sub-district": "หนองแจ้งใหญ่",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "ประทาย",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "กระทุ่มราย",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "วังไม้แดง",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "ตลาดไทร",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "หนองพลวง",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "หนองค่าย",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "หันห้วยทราย",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "ดอนมัน",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "นางรำ",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "โนนเพ็ด",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "ทุ่งสว่าง",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "โคกกลาง",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ประทาย",
    "sub-district": "เมืองโดน",
    postcode: 30180,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "เมืองปัก",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ตะคุ",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "โคกไทย",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "สำโรง",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ตะขบ",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "นกออก",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ดอน",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ตูม",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "งิ้ว",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "สะแกราช",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ลำนางแก้ว",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ภูหลวง",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "ธงชัยเหนือ",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "สุขเกษม",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "เกษมทรัพย์",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "ปักธงชัย",
    "sub-district": "บ่อปลาทอง",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "ในเมือง",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "สัมฤทธิ์",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "โบสถ์",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "กระเบื้องใหญ่",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "ท่าหลวง",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "รังกาใหญ่",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "ชีวาน",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "นิคมสร้างตนเอง",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "กระชอน",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "ดงใหญ่",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "ธารละหลอด",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "พิมาย",
    "sub-district": "หนองระเวียง",
    postcode: 30110,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "ห้วยแถลง",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "ทับสวาย",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "เมืองพลับพลา",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "หลุ่งตะเคียน",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "หินดาด",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "งิ้ว",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "กงรถ",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "หลุ่งประดู่",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "ตะโก",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ห้วยแถลง",
    "sub-district": "ห้วยแคน",
    postcode: 30240,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "ชุมพวง",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "ประสุข",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "ท่าลาด",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "สาหร่าย",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "ตลาดไทร",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "โนนรัง",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "หนองหลัก",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "โนนตูม",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ชุมพวง",
    "sub-district": "โนนยอ",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "สูงเนิน",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "เสมา",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "โคราช",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "บุ่งขี้เหล็ก",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "โนนค่า",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "โค้งยาง",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "มะเกลือเก่า",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "มะเกลือใหม่",
    postcode: 30170,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "นากลาง",
    postcode: 30380,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "หนองตะไก้",
    postcode: 30380,
  },
  {
    province: "นครราชสีมา",
    district: "สูงเนิน",
    "sub-district": "กุดจิก",
    postcode: 30380,
  },
  {
    province: "นครราชสีมา",
    district: "ขามทะเลสอ",
    "sub-district": "ขามทะเลสอ",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "ขามทะเลสอ",
    "sub-district": "โป่งแดง",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "ขามทะเลสอ",
    "sub-district": "พันดุง",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "ขามทะเลสอ",
    "sub-district": "หนองสรวง",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "ขามทะเลสอ",
    "sub-district": "บึงอ้อ",
    postcode: 30280,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "สีคิ้ว",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "บ้านหัน",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "กฤษณา",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "ลาดบัวขาว",
    postcode: 30340,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "หนองหญ้าขาว",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "กุดน้อย",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "หนองน้ำใส",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "วังโรงใหญ่",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "มิตรภาพ",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "คลองไผ่",
    postcode: 30340,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "ดอนเมือง",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "สีคิ้ว",
    "sub-district": "หนองบัวน้อย",
    postcode: 30140,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "ปากช่อง",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "กลางดง",
    postcode: 30320,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "จันทึก",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "วังกะทะ",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "หมูสี",
    postcode: 30450,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "หนองสาหร่าย",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "ขนงพระ",
    postcode: 30450,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "โป่งตาลอง",
    postcode: 30450,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "คลองม่วง",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "หนองน้ำแดง",
    postcode: 30450,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "วังไทร",
    postcode: 30130,
  },
  {
    province: "นครราชสีมา",
    district: "ปากช่อง",
    "sub-district": "พญาเย็น",
    postcode: 30320,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "หนองบุนนาก",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "สารภี",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "ไทยเจริญ",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "หนองหัวแรต",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "แหลมทอง",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "หนองตะไก้",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "ลุงเขว้า",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "หนองไม้ไผ่",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "หนองบุญมาก",
    "sub-district": "บ้านใหม่",
    postcode: 30410,
  },
  {
    province: "นครราชสีมา",
    district: "แก้งสนามนาง",
    "sub-district": "แก้งสนามนาง",
    postcode: 30440,
  },
  {
    province: "นครราชสีมา",
    district: "แก้งสนามนาง",
    "sub-district": "โนนสำราญ",
    postcode: 30440,
  },
  {
    province: "นครราชสีมา",
    district: "แก้งสนามนาง",
    "sub-district": "บึงพะไล",
    postcode: 30440,
  },
  {
    province: "นครราชสีมา",
    district: "แก้งสนามนาง",
    "sub-district": "สีสุก",
    postcode: 30440,
  },
  {
    province: "นครราชสีมา",
    district: "แก้งสนามนาง",
    "sub-district": "บึงสำโรง",
    postcode: 30440,
  },
  {
    province: "นครราชสีมา",
    district: "โนนแดง",
    "sub-district": "โนนแดง",
    postcode: 30360,
  },
  {
    province: "นครราชสีมา",
    district: "โนนแดง",
    "sub-district": "โนนตาเถร",
    postcode: 30360,
  },
  {
    province: "นครราชสีมา",
    district: "โนนแดง",
    "sub-district": "สำพะเนียง",
    postcode: 30360,
  },
  {
    province: "นครราชสีมา",
    district: "โนนแดง",
    "sub-district": "วังหิน",
    postcode: 30360,
  },
  {
    province: "นครราชสีมา",
    district: "โนนแดง",
    "sub-district": "ดอนยาวใหญ่",
    postcode: 30360,
  },
  {
    province: "นครราชสีมา",
    district: "วังน้ำเขียว",
    "sub-district": "วังน้ำเขียว",
    postcode: 30370,
  },
  {
    province: "นครราชสีมา",
    district: "วังน้ำเขียว",
    "sub-district": "วังหมี",
    postcode: 30370,
  },
  {
    province: "นครราชสีมา",
    district: "วังน้ำเขียว",
    "sub-district": "ระเริง",
    postcode: 30150,
  },
  {
    province: "นครราชสีมา",
    district: "วังน้ำเขียว",
    "sub-district": "อุดมทรัพย์",
    postcode: 30370,
  },
  {
    province: "นครราชสีมา",
    district: "วังน้ำเขียว",
    "sub-district": "ไทยสามัคคี",
    postcode: 30370,
  },
  {
    province: "นครราชสีมา",
    district: "เทพารักษ์",
    "sub-district": "สำนักตะคร้อ",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "เทพารักษ์",
    "sub-district": "หนองแวง",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "เทพารักษ์",
    "sub-district": "บึงปรือ",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "เทพารักษ์",
    "sub-district": "วังยายทอง",
    postcode: 30210,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองยาง",
    "sub-district": "เมืองยาง",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองยาง",
    "sub-district": "กระเบื้องนอก",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองยาง",
    "sub-district": "ละหานปลาค้าว",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "เมืองยาง",
    "sub-district": "โนนอุดม",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "พระทองคำ",
    "sub-district": "สระพระ",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "พระทองคำ",
    "sub-district": "มาบกราด",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "พระทองคำ",
    "sub-district": "พังเทียม",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "พระทองคำ",
    "sub-district": "ทัพรั้ง",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "พระทองคำ",
    "sub-district": "หนองหอย",
    postcode: 30220,
  },
  {
    province: "นครราชสีมา",
    district: "ลำทะเมนชัย",
    "sub-district": "ขุย",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ลำทะเมนชัย",
    "sub-district": "บ้านยาง",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ลำทะเมนชัย",
    "sub-district": "ช่องแมว",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "ลำทะเมนชัย",
    "sub-district": "ไพล",
    postcode: 30270,
  },
  {
    province: "นครราชสีมา",
    district: "บัวลาย",
    "sub-district": "เมืองพะไล",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวลาย",
    "sub-district": "โนนจาน",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวลาย",
    "sub-district": "บัวลาย",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "บัวลาย",
    "sub-district": "หนองหว้า",
    postcode: 30120,
  },
  {
    province: "นครราชสีมา",
    district: "สีดา",
    "sub-district": "สีดา",
    postcode: 30430,
  },
  {
    province: "นครราชสีมา",
    district: "สีดา",
    "sub-district": "โพนทอง",
    postcode: 30430,
  },
  {
    province: "นครราชสีมา",
    district: "สีดา",
    "sub-district": "โนนประดู่",
    postcode: 30430,
  },
  {
    province: "นครราชสีมา",
    district: "สีดา",
    "sub-district": "สามเมือง",
    postcode: 30430,
  },
  {
    province: "นครราชสีมา",
    district: "สีดา",
    "sub-district": "หนองตาดใหญ่",
    postcode: 30430,
  },
  {
    province: "นครราชสีมา",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ช้างทอง",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ท่าช้าง",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "พระพุทธ",
    postcode: 30230,
  },
  {
    province: "นครราชสีมา",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "หนองงูเหลือม",
    postcode: 30000,
  },
  {
    province: "นครราชสีมา",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "หนองยาง",
    postcode: 30230,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "ในเมือง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "อิสาณ",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "เสม็ด",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "บ้านบัว",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "สะแกโพรง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "สวายจีก",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "บ้านยาง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "พระครู",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "ถลุงเหล็ก",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "หนองตาด",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "ลุมปุ๊ก",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "สองห้อง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "บัวทอง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "ชุมเห็ด",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "หลักเขต",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "สะแกซำ",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "กลันทา",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "กระสัง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "เมืองบุรีรัมย์",
    "sub-district": "เมืองฝาง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "คูเมือง",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "ปะเคียบ",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "บ้านแพ",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "พรสำราญ",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "หินเหล็กไฟ",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "ตูมใหญ่",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "คูเมือง",
    "sub-district": "หนองขมาร",
    postcode: 31190,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "กระสัง",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "ลำดวน",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "สองชั้น",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "สูงเนิน",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "หนองเต็ง",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "เมืองไผ่",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "ชุมแสง",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "บ้านปรือ",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "ห้วยสำราญ",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "กันทรารมย์",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "กระสัง",
    "sub-district": "ศรีภูมิ",
    postcode: 31160,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "นางรอง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "สะเดา",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ชุมแสง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หนองโบสถ์",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หนองกง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ถนนหัก",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หนองไทร",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ก้านเหลือง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "บ้านสิงห์",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ลำไทรโยง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ทรัพย์พระยา",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หนองยายพิมพ์",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หัวถนน",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "ทุ่งแสงทอง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "นางรอง",
    "sub-district": "หนองโสน",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "หนองกี่",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "เย้ยปราสาท",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "เมืองไผ่",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "ดอนอะราง",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "โคกสว่าง",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "ทุ่งกระตาดพัฒนา",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "ทุ่งกระเต็น",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "ท่าโพธิ์ชัย",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "โคกสูง",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองกี่",
    "sub-district": "บุกระสัง",
    postcode: 31210,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "ละหานทราย",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "ตาจง",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "สำโรงใหม่",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "หนองแวง",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "หนองตะครอง",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ละหานทราย",
    "sub-district": "โคกว่าน",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ประโคนชัย",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "แสลงโทน",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "บ้านไทร",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ละเวี้ย",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "จรเข้มาก",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ปังกู",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "โคกย่าง",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "โคกม้า",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ไพศาล",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ตะโกตาพิ",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "เขาคอก",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "หนองบอน",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "โคกมะขาม",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "โคกตูม",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "ประทัดบุ",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "ประโคนชัย",
    "sub-district": "สี่เหลี่ยม",
    postcode: 31140,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "บ้านกรวด",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "โนนเจริญ",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "หนองไม้งาม",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "ปราสาท",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "สายตะกู",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "หินลาด",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "บึงเจริญ",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "จันทบเพชร",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านกรวด",
    "sub-district": "เขาดินเหนือ",
    postcode: 31180,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "พุทไธสง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "มะเฟือง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "บ้านจาน",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "บ้านเป้า",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "บ้านแวง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "บ้านยาง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "พุทไธสง",
    "sub-district": "หายโศก",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "ลำปลายมาศ",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "หนองคู",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "แสลงพัน",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "ทะเมนชัย",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "ตลาดโพธิ์",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "หนองกะทิง",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "โคกกลาง",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "โคกสะอาด",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "เมืองแฝก",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "บ้านยาง",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "ผไทรินทร์",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "โคกล่าม",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "หินโคน",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "หนองบัวโคก",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "บุโพธิ์",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "ลำปลายมาศ",
    "sub-district": "หนองโดน",
    postcode: 31130,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "สตึก",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "นิคม",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "ทุ่งวัง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "เมืองแก",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "หนองใหญ่",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "ร่อนทอง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "ดอนมนต์",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "ชุมแสง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "ท่าม่วง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "สะแก",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "สนามชัย",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "สตึก",
    "sub-district": "กระสัง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "ปะคำ",
    "sub-district": "ปะคำ",
    postcode: 31220,
  },
  {
    province: "บุรีรัมย์",
    district: "ปะคำ",
    "sub-district": "ไทยเจริญ",
    postcode: 31220,
  },
  {
    province: "บุรีรัมย์",
    district: "ปะคำ",
    "sub-district": "หนองบัว",
    postcode: 31220,
  },
  {
    province: "บุรีรัมย์",
    district: "ปะคำ",
    "sub-district": "โคกมะม่วง",
    postcode: 31220,
  },
  {
    province: "บุรีรัมย์",
    district: "ปะคำ",
    "sub-district": "หูทำนบ",
    postcode: 31220,
  },
  {
    province: "บุรีรัมย์",
    district: "นาโพธิ์",
    "sub-district": "นาโพธิ์",
    postcode: 31230,
  },
  {
    province: "บุรีรัมย์",
    district: "นาโพธิ์",
    "sub-district": "บ้านคู",
    postcode: 31230,
  },
  {
    province: "บุรีรัมย์",
    district: "นาโพธิ์",
    "sub-district": "บ้านดู่",
    postcode: 31230,
  },
  {
    province: "บุรีรัมย์",
    district: "นาโพธิ์",
    "sub-district": "ดอนกอก",
    postcode: 31230,
  },
  {
    province: "บุรีรัมย์",
    district: "นาโพธิ์",
    "sub-district": "ศรีสว่าง",
    postcode: 31230,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "สระแก้ว",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "ห้วยหิน",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "ไทยสามัคคี",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "หนองชัยศรี",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "เสาเดียว",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "เมืองฝ้าย",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "หนองหงส์",
    "sub-district": "สระทอง",
    postcode: 31240,
  },
  {
    province: "บุรีรัมย์",
    district: "พลับพลาชัย",
    "sub-district": "จันดุม",
    postcode: 31250,
  },
  {
    province: "บุรีรัมย์",
    district: "พลับพลาชัย",
    "sub-district": "โคกขมิ้น",
    postcode: 31250,
  },
  {
    province: "บุรีรัมย์",
    district: "พลับพลาชัย",
    "sub-district": "ป่าชัน",
    postcode: 31250,
  },
  {
    province: "บุรีรัมย์",
    district: "พลับพลาชัย",
    "sub-district": "สะเดา",
    postcode: 31250,
  },
  {
    province: "บุรีรัมย์",
    district: "พลับพลาชัย",
    "sub-district": "สำโรง",
    postcode: 31250,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "ห้วยราช",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "สามแวง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "ตาเสา",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "บ้านตะโก",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "สนวน",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "โคกเหล็ก",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "เมืองโพธิ์",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "ห้วยราช",
    "sub-district": "ห้วยราชา",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนสุวรรณ",
    "sub-district": "โนนสุวรรณ",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนสุวรรณ",
    "sub-district": "ทุ่งจังหัน",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนสุวรรณ",
    "sub-district": "โกรกแก้ว",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนสุวรรณ",
    "sub-district": "ดงอีจาน",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "ชำนิ",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "หนองปล่อง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "เมืองยาง",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "ช่อผกา",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "ละลวด",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "ชำนิ",
    "sub-district": "โคกสนวน",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านใหม่ไชยพจน์",
    "sub-district": "หนองแวง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านใหม่ไชยพจน์",
    "sub-district": "ทองหลาง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านใหม่ไชยพจน์",
    "sub-district": "แดงใหญ่",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านใหม่ไชยพจน์",
    "sub-district": "กู่สวนแตง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านใหม่ไชยพจน์",
    "sub-district": "หนองเยือง",
    postcode: 31120,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนดินแดง",
    "sub-district": "โนนดินแดง",
    postcode: 31260,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนดินแดง",
    "sub-district": "ส้มป่อย",
    postcode: 31260,
  },
  {
    province: "บุรีรัมย์",
    district: "โนนดินแดง",
    "sub-district": "ลำนางรอง",
    postcode: 31260,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านด่าน",
    "sub-district": "บ้านด่าน",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านด่าน",
    "sub-district": "ปราสาท",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านด่าน",
    "sub-district": "วังเหนือ",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "บ้านด่าน",
    "sub-district": "โนนขวาง",
    postcode: 31000,
  },
  {
    province: "บุรีรัมย์",
    district: "แคนดง",
    "sub-district": "แคนดง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "แคนดง",
    "sub-district": "ดงพลอง",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "แคนดง",
    "sub-district": "สระบัว",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "แคนดง",
    "sub-district": "หัวฝาย",
    postcode: 31150,
  },
  {
    province: "บุรีรัมย์",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "เจริญสุข",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ตาเป๊ก",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "อีสานเขต",
    postcode: 31110,
  },
  {
    province: "บุรีรัมย์",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ถาวร",
    postcode: 31170,
  },
  {
    province: "บุรีรัมย์",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ยายแย้มวัฒนา",
    postcode: 31170,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ในเมือง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ตั้งใจ",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "เพี้ยราม",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "นาดี",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ท่าสว่าง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "สลักได",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ตาอ็อง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "สำโรง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "แกใหญ่",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "นอกเมือง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "คอโค",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "สวาย",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "เฉนียง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "เทนมีย์",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "นาบัว",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "เมืองที",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ราม",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "บุฤาษี",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "ตระแสง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "แสลงพันธ์",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เมืองสุรินทร์",
    "sub-district": "กาเกาะ",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "ชุมพลบุรี",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "นาหนองไผ่",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "ไพรขลา",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "ศรีณรงค์",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "ยะวึก",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "เมืองบัว",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "สระขุด",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "กระเบื้อง",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ชุมพลบุรี",
    "sub-district": "หนองเรือ",
    postcode: 32190,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "ท่าตูม",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "กระโพ",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "พรมเทพ",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "โพนครก",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "เมืองแก",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "บะ",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "หนองบัว",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "บัวโคก",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "หนองเมธี",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "ท่าตูม",
    "sub-district": "ทุ่งกุลา",
    postcode: 32120,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "จอมพระ",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "เมืองลีง",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "กระหาด",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "บุแกรง",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "หนองสนิท",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "บ้านผือ",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "ลุ่มระวี",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "ชุมแสง",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "จอมพระ",
    "sub-district": "เป็นสุข",
    postcode: 32180,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "กังแอน",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ทมอ",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ไพล",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ปรือ",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ทุ่งมน",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ตาเบา",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "หนองใหญ่",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "โคกยาง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "โคกสะอาด",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "บ้านไทร",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "โชคนาสาม",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "เชื้อเพลิง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ปราสาททนง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ตานี",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "บ้านพลวง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "กันตวจระมวล",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "สมุด",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ปราสาท",
    "sub-district": "ประทัดบุ",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "กาบเชิง",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "คูตัน",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "ด่าน",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "แนงมุด",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "โคกตะเคียน",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "กาบเชิง",
    "sub-district": "ตะเคียน",
    postcode: 32210,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "รัตนบุรี",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "ธาตุ",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "แก",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "ดอนแรด",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "หนองบัวทอง",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "หนองบัวบาน",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "ไผ่",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "เบิด",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "น้ำเขียว",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "กุดขาคีม",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "ยางสว่าง",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "รัตนบุรี",
    "sub-district": "ทับใหญ่",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "สนม",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "โพนโก",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "หนองระฆัง",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "นานวน",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "แคน",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "หัวงัว",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "สนม",
    "sub-district": "หนองอียอ",
    postcode: 32160,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ระแงง",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ตรึม",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "จารพัต",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ยาง",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "แตล",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "หนองบัว",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "คาละแมะ",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "หนองเหล็ก",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "หนองขวาว",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ช่างปี่",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "กุดหวาย",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ขวาวใหญ่",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "นารุ่ง",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ตรมไพร",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "ศีขรภูมิ",
    "sub-district": "ผักไหม",
    postcode: 32110,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "สังขะ",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "ขอนแตก",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "ดม",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "พระแก้ว",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "บ้านจารย์",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "กระเทียม",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "สะกาด",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "ตาตุม",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "ทับทัน",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "ตาคง",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "บ้านชบ",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "สังขะ",
    "sub-district": "เทพรักษา",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "ลำดวน",
    "sub-district": "ลำดวน",
    postcode: 32220,
  },
  {
    province: "สุรินทร์",
    district: "ลำดวน",
    "sub-district": "โชคเหนือ",
    postcode: 32220,
  },
  {
    province: "สุรินทร์",
    district: "ลำดวน",
    "sub-district": "อู่โลก",
    postcode: 32220,
  },
  {
    province: "สุรินทร์",
    district: "ลำดวน",
    "sub-district": "ตรำดม",
    postcode: 32220,
  },
  {
    province: "สุรินทร์",
    district: "ลำดวน",
    "sub-district": "ตระเปียงเตีย",
    postcode: 32220,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "สำโรงทาบ",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "หนองไผ่ล้อม",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "กระออม",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "หนองฮะ",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "ศรีสุข",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "เกาะแก้ว",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "หมื่นศรี",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "เสม็จ",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "สะโน",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "สำโรงทาบ",
    "sub-district": "ประดู่",
    postcode: 32170,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "บัวเชด",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "สะเดา",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "จรัส",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "ตาวัง",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "อาโพน",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "บัวเชด",
    "sub-district": "สำเภาลูน",
    postcode: 32230,
  },
  {
    province: "สุรินทร์",
    district: "พนมดงรัก",
    "sub-district": "บักได",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "พนมดงรัก",
    "sub-district": "โคกกลาง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "พนมดงรัก",
    "sub-district": "จีกแดก",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "พนมดงรัก",
    "sub-district": "ตาเมียง",
    postcode: 32140,
  },
  {
    province: "สุรินทร์",
    district: "ศรีณรงค์",
    "sub-district": "ณรงค์",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "ศรีณรงค์",
    "sub-district": "แจนแวน",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "ศรีณรงค์",
    "sub-district": "ตรวจ",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "ศรีณรงค์",
    "sub-district": "หนองแวง",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "ศรีณรงค์",
    "sub-district": "ศรีสุข",
    postcode: 32150,
  },
  {
    province: "สุรินทร์",
    district: "เขวาสินรินทร์",
    "sub-district": "เขวาสินรินทร์",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เขวาสินรินทร์",
    "sub-district": "บึง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เขวาสินรินทร์",
    "sub-district": "ตากูก",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เขวาสินรินทร์",
    "sub-district": "ปราสาททอง",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "เขวาสินรินทร์",
    "sub-district": "บ้านแร่",
    postcode: 32000,
  },
  {
    province: "สุรินทร์",
    district: "โนนนารายณ์",
    "sub-district": "หนองหลวง",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "โนนนารายณ์",
    "sub-district": "คำผง",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "โนนนารายณ์",
    "sub-district": "โนน",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "โนนนารายณ์",
    "sub-district": "ระเวียง",
    postcode: 32130,
  },
  {
    province: "สุรินทร์",
    district: "โนนนารายณ์",
    "sub-district": "หนองเทพ",
    postcode: 32130,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "เมืองเหนือ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "เมืองใต้",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "คูซอด",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "ซำ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "จาน",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "ตะดอบ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หนองครก",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "โพนข่า",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "โพนค้อ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "โพนเขวา",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หญ้าปล้อง",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "ทุ่ม",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หนองไฮ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หนองแก้ว",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "น้ำคำ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "โพธิ์",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หมากเขียบ",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองศรีสะเกษ",
    "sub-district": "หนองไผ่",
    postcode: 33000,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "ยางชุมน้อย",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "ลิ้นฟ้า",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "คอนกาม",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "โนนคูณ",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "กุดเมืองฮาม",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "บึงบอน",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "ยางชุมน้อย",
    "sub-district": "ยางชุมใหญ่",
    postcode: 33190,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ดูน",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "โนนสัง",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "หนองหัวช้าง",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ยาง",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "หนองแวง",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "หนองแก้ว",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ทาม",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ละทาย",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "เมืองน้อย",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "อีปาด",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "บัวน้อย",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "หนองบัว",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ดู่",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "ผักแพว",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "จาน",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรารมย์",
    "sub-district": "คำเนียม",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "บึงมะลู",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "กุดเสลา",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "เมือง",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "สังเม็ก",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "น้ำอ้อม",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ละลาย",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "รุง",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ตระกาจ",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "จานใหญ่",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ภูเงิน",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ชำ",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "กระแชง",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "โนนสำราญ",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "หนองหญ้าลาด",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "เสาธงชัย",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ขนุน",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "สวนกล้วย",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "เวียงเหนือ",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ทุ่งใหญ่",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "กันทรลักษ์",
    "sub-district": "ภูผาหมอก",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "กันทรารมย์",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "จะกง",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ใจดี",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ดองกำเม็ด",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "โสน",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ปรือใหญ่",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "สะเดาใหญ่",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ตาอุด",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ห้วยเหนือ",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ห้วยใต้",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "หัวเสือ",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ตะเคียน",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "นิคมพัฒนา",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "โคกเพชร",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ปราสาท",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "สำโรงตาเจ็น",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ห้วยสำราญ",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "กฤษณา",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ลมศักดิ์",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "หนองฉลอง",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ศรีตระกูล",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุขันธ์",
    "sub-district": "ศรีสะอาด",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "ไพรบึง",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "ดินแดง",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "ปราสาทเยอ",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "สำโรงพลัน",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "สุขสวัสดิ์",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ไพรบึง",
    "sub-district": "โนนปูน",
    postcode: 33180,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "พิมาย",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "กู่",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "หนองเชียงทูน",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "ตูม",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "สมอ",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "โพธิ์ศรี",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "สำโรงปราสาท",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "ดู่",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "สวาย",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ปรางค์กู่",
    "sub-district": "พิมายเหนือ",
    postcode: 33170,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "สิ",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "บักดอง",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "พราน",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "โพธิ์วงศ์",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "ไพร",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "กระหวัน",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "ขุนหาญ",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "โนนสูง",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "กันทรอม",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "ภูฝ้าย",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "โพธิ์กระสังข์",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ขุนหาญ",
    "sub-district": "ห้วยจันทร์",
    postcode: 33150,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "เมืองคง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "เมืองแคน",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "หนองแค",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "จิกสังข์ทอง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "ด่าน",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "ดู่",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "หนองอึ่ง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "บัวหุ่ง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "ไผ่",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "ส้มป่อย",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "หนองหมี",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "หว้านคำ",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ราษีไศล",
    "sub-district": "สร้างปี่",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "กำแพง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "อี่หล่ำ",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "ก้านเหลือง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "ทุ่งไชย",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "สำโรง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "แขม",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "หนองไฮ",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "ขะยูง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "ตาเกษ",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "หัวช้าง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "รังแร้ง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "แต้",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "แข้",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "โพธิ์ชัย",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "ปะอาว",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "หนองห้าง",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "สระกำแพงใหญ่",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "โคกหล่าม",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "อุทุมพรพิสัย",
    "sub-district": "โคกจาน",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "บึงบูรพ์",
    "sub-district": "เป๊าะ",
    postcode: 33220,
  },
  {
    province: "ศรีสะเกษ",
    district: "บึงบูรพ์",
    "sub-district": "บึงบูรพ์",
    postcode: 33220,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "ห้วยทับทัน",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "เมืองหลวง",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "กล้วยกว้าง",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "ผักไหม",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "จานแสนไชย",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "ห้วยทับทัน",
    "sub-district": "ปราสาท",
    postcode: 33210,
  },
  {
    province: "ศรีสะเกษ",
    district: "โนนคูณ",
    "sub-district": "โนนค้อ",
    postcode: 33250,
  },
  {
    province: "ศรีสะเกษ",
    district: "โนนคูณ",
    "sub-district": "บก",
    postcode: 33250,
  },
  {
    province: "ศรีสะเกษ",
    district: "โนนคูณ",
    "sub-district": "โพธิ์",
    postcode: 33250,
  },
  {
    province: "ศรีสะเกษ",
    district: "โนนคูณ",
    "sub-district": "หนองกุง",
    postcode: 33250,
  },
  {
    province: "ศรีสะเกษ",
    district: "โนนคูณ",
    "sub-district": "เหล่ากวาง",
    postcode: 33250,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "ศรีแก้ว",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "พิงพวย",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "สระเยาว์",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "ตูม",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "เสื่องข้าว",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "ศรีโนนงาม",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศรีรัตนะ",
    "sub-district": "สะพุง",
    postcode: 33240,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "น้ำเกลี้ยง",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "ละเอาะ",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "ตองปิด",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "เขิน",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "รุ่งระวี",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "น้ำเกลี้ยง",
    "sub-district": "คูบ",
    postcode: 33130,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "บุสูง",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "ธาตุ",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "ดวนใหญ่",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "บ่อแก้ว",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "ศรีสำราญ",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "ทุ่งสว่าง",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "วังหิน",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "วังหิน",
    "sub-district": "โพนยาง",
    postcode: 33270,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "โคกตาล",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ห้วยตามอญ",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ห้วยตึ๊กชู",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ละลม",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ตะเคียนราม",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ดงรัก",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "ภูสิงห์",
    "sub-district": "ไพรพัฒนา",
    postcode: 33140,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองจันทร์",
    "sub-district": "เมืองจันทร์",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองจันทร์",
    "sub-district": "ตาโกน",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "เมืองจันทร์",
    "sub-district": "หนองใหญ่",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "เบญจลักษ์",
    "sub-district": "เสียว",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "เบญจลักษ์",
    "sub-district": "หนองหว้า",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "เบญจลักษ์",
    "sub-district": "หนองงูเหลือม",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "เบญจลักษ์",
    "sub-district": "หนองฮาง",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "เบญจลักษ์",
    "sub-district": "ท่าคล้อ",
    postcode: 33110,
  },
  {
    province: "ศรีสะเกษ",
    district: "พยุห์",
    "sub-district": "พยุห์",
    postcode: 33230,
  },
  {
    province: "ศรีสะเกษ",
    district: "พยุห์",
    "sub-district": "พรหมสวัสดิ์",
    postcode: 33230,
  },
  {
    province: "ศรีสะเกษ",
    district: "พยุห์",
    "sub-district": "ตำแย",
    postcode: 33230,
  },
  {
    province: "ศรีสะเกษ",
    district: "พยุห์",
    "sub-district": "โนนเพ็ก",
    postcode: 33230,
  },
  {
    province: "ศรีสะเกษ",
    district: "พยุห์",
    "sub-district": "หนองค้า",
    postcode: 33230,
  },
  {
    province: "ศรีสะเกษ",
    district: "โพธิ์ศรีสุวรรณ",
    "sub-district": "โดด",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "โพธิ์ศรีสุวรรณ",
    "sub-district": "เสียว",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "โพธิ์ศรีสุวรรณ",
    "sub-district": "หนองม้า",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "โพธิ์ศรีสุวรรณ",
    "sub-district": "ผือใหญ่",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "โพธิ์ศรีสุวรรณ",
    "sub-district": "อีเซ",
    postcode: 33120,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศิลาลาด",
    "sub-district": "กุง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศิลาลาด",
    "sub-district": "คลีกลิ้ง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศิลาลาด",
    "sub-district": "หนองบัวดง",
    postcode: 33160,
  },
  {
    province: "ศรีสะเกษ",
    district: "ศิลาลาด",
    "sub-district": "โจดม่วง",
    postcode: 33160,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ในเมือง",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "หัวเรือ",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "หนองขอน",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ปทุม",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ขามใหญ่",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "แจระแม",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "หนองบ่อ",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ไร่น้อย",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "กระโสบ",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "กุดลาด",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ขี้เหล็ก",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เมืองอุบลราชธานี",
    "sub-district": "ปะอาว",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "นาคำ",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "แก้งกอก",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "เอือดใหญ่",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "วาริน",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "ลาดควาย",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "สงยาง",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "ตะบ่าย",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "คำไหล",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "หนามแท่ง",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "นาเลิน",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "ศรีเมืองใหม่",
    "sub-district": "ดอนใหญ่",
    postcode: 34250,
  },
  {
    province: "อุบลราชธานี",
    district: "โขงเจียม",
    "sub-district": "โขงเจียม",
    postcode: 34220,
  },
  {
    province: "อุบลราชธานี",
    district: "โขงเจียม",
    "sub-district": "ห้วยยาง",
    postcode: 34220,
  },
  {
    province: "อุบลราชธานี",
    district: "โขงเจียม",
    "sub-district": "นาโพธิ์กลาง",
    postcode: 34220,
  },
  {
    province: "อุบลราชธานี",
    district: "โขงเจียม",
    "sub-district": "หนองแสงใหญ่",
    postcode: 34220,
  },
  {
    province: "อุบลราชธานี",
    district: "โขงเจียม",
    "sub-district": "ห้วยไผ่",
    postcode: 34220,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "เขื่องใน",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "สร้างถ่อ",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ค้อทอง",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ก่อเอ้",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "หัวดอน",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ชีทวน",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ท่าไห",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "นาคำใหญ่",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "แดงหม้อ",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ธาตุน้อย",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "บ้านไทย",
    postcode: 34320,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "บ้านกอก",
    postcode: 34320,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "กลางใหญ่",
    postcode: 34320,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "โนนรัง",
    postcode: 34320,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ยางขี้นก",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "ศรีสุข",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "สหธาตุ",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขื่องใน",
    "sub-district": "หนองเหล่า",
    postcode: 34150,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "เขมราฐ",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "ขามป้อม",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "เจียด",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "หนองผือ",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "นาแวง",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "แก้งเหนือ",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "หนองนกทา",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "หนองสิม",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เขมราฐ",
    "sub-district": "หัวนา",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "เมืองเดช",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "นาส่วง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "นาเจริญ",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "ทุ่งเทิง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "สมสะอาด",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "กุดประทาย",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "ตบหู",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "กลาง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "แก้ง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "ท่าโพธิ์ศรี",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "บัวงาม",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "คำครั่ง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "นากระแซง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "โพนงาม",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "ป่าโมง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "เดชอุดม",
    "sub-district": "โนนสมบูรณ์",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "นาจะหลวย",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "โนนสมบูรณ์",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "พรสวรรค์",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "บ้านตูม",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "โสกแสง",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "นาจะหลวย",
    "sub-district": "โนนสวรรค์",
    postcode: 34280,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "โซง",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "ยาง",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "โดมประดิษฐ์",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "บุเปือย",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "สีวิเชียร",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "ยางใหญ่",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำยืน",
    "sub-district": "เก่าขาม",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "โพนงาม",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "ห้วยข่า",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "คอแลน",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "นาโพธิ์",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "หนองสะโน",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "โนนค้อ",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "บัวงาม",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "บุณฑริก",
    "sub-district": "บ้านแมด",
    postcode: 34230,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ขุหลุ",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "กระเดียน",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "เกษม",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "กุศกร",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ขามเปี้ย",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "คอนสาย",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "โคกจาน",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "นาพิน",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "นาสะไม",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "โนนกุง",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ตระการ",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ตากแดด",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ไหล่ทุ่ง",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "เป้า",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "เซเป็ด",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "สะพือ",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "หนองเต่า",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ถ้ำแข้",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ท่าหลวง",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "ห้วยฝ้ายพัฒนา",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "กุดยาลวน",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "บ้านแดง",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "ตระการพืชผล",
    "sub-district": "คำเจริญ",
    postcode: 34130,
  },
  {
    province: "อุบลราชธานี",
    district: "กุดข้าวปุ้น",
    "sub-district": "ข้าวปุ้น",
    postcode: 34270,
  },
  {
    province: "อุบลราชธานี",
    district: "กุดข้าวปุ้น",
    "sub-district": "โนนสวาง",
    postcode: 34270,
  },
  {
    province: "อุบลราชธานี",
    district: "กุดข้าวปุ้น",
    "sub-district": "แก่งเค็ง",
    postcode: 34270,
  },
  {
    province: "อุบลราชธานี",
    district: "กุดข้าวปุ้น",
    "sub-district": "กาบิน",
    postcode: 34270,
  },
  {
    province: "อุบลราชธานี",
    district: "กุดข้าวปุ้น",
    "sub-district": "หนองทันน้ำ",
    postcode: 34270,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "ม่วงสามสิบ",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "เหล่าบก",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "ดุมใหญ่",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "หนองช้างใหญ่",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "หนองเมือง",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "เตย",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "ยางสักกระโพหลุ่ม",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "หนองไข่นก",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "หนองเหล่า",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "หนองฮาง",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "ยางโยภาพ",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "ไผ่ใหญ่",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "นาเลิง",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "ม่วงสามสิบ",
    "sub-district": "โพนแพง",
    postcode: 34140,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "วารินชำราบ",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "ธาตุ",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "ท่าลาด",
    postcode: 34310,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "โนนโหนน",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "คูเมือง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "สระสมิง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "คำน้ำแซบ",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "บุ่งหวาย",
    postcode: 34310,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "คำขวาง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "โพธิ์ใหญ่",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "แสนสุข",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "หนองกินเพล",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "โนนผึ้ง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "เมืองศรีไค",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "ห้วยขะยูง",
    postcode: 34310,
  },
  {
    province: "อุบลราชธานี",
    district: "วารินชำราบ",
    "sub-district": "บุ่งไหม",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "พิบูล",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "กุดชมภู",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "ดอนจิก",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "ทรายมูล",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "นาโพธิ์",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "โนนกลาง",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "โพธิ์ไทร",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "โพธิ์ศรี",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "ระเว",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "ไร่ใต้",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "หนองบัวฮี",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "อ่างศิลา",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "โนนกาหลง",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "พิบูลมังสาหาร",
    "sub-district": "บ้านแขม",
    postcode: 34110,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "ตาลสุม",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "สำโรง",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "จิกเทิง",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "หนองกุง",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "นาคาย",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "ตาลสุม",
    "sub-district": "คำหว้า",
    postcode: 34330,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "โพธิ์ไทร",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "ม่วงใหญ่",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "สำโรง",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "สองคอน",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "สารภี",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "โพธิ์ไทร",
    "sub-district": "เหล่างาม",
    postcode: 34340,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "สำโรง",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "โคกก่อง",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "หนองไฮ",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "ค้อน้อย",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "โนนกาเล็น",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "โคกสว่าง",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "โนนกลาง",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "บอน",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "สำโรง",
    "sub-district": "ขามป้อม",
    postcode: 34360,
  },
  {
    province: "อุบลราชธานี",
    district: "ดอนมดแดง",
    "sub-district": "ดอนมดแดง",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "ดอนมดแดง",
    "sub-district": "เหล่าแดง",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "ดอนมดแดง",
    "sub-district": "ท่าเมือง",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "ดอนมดแดง",
    "sub-district": "คำไฮใหญ่",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "คันไร่",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "ช่องเม็ก",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "โนนก่อ",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "นิคมสร้างตนเองลำโดมน้อย",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "ฝางคำ",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "สิรินธร",
    "sub-district": "คำเขื่อนแก้ว",
    postcode: 34350,
  },
  {
    province: "อุบลราชธานี",
    district: "ทุ่งศรีอุดม",
    "sub-district": "หนองอ้ม",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "ทุ่งศรีอุดม",
    "sub-district": "นาเกษม",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "ทุ่งศรีอุดม",
    "sub-district": "กุดเรือ",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "ทุ่งศรีอุดม",
    "sub-district": "โคกชำแระ",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "ทุ่งศรีอุดม",
    "sub-district": "นาห่อม",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "นาเยีย",
    "sub-district": "นาเยีย",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "นาเยีย",
    "sub-district": "นาดี",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "นาเยีย",
    "sub-district": "นาเรือง",
    postcode: 34160,
  },
  {
    province: "อุบลราชธานี",
    district: "นาตาล",
    "sub-district": "นาตาล",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "นาตาล",
    "sub-district": "พะลาน",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "นาตาล",
    "sub-district": "กองโพน",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "นาตาล",
    "sub-district": "พังเคน",
    postcode: 34170,
  },
  {
    province: "อุบลราชธานี",
    district: "เหล่าเสือโก้ก",
    "sub-district": "เหล่าเสือโก้ก",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เหล่าเสือโก้ก",
    "sub-district": "โพนเมือง",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เหล่าเสือโก้ก",
    "sub-district": "แพงใหญ่",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "เหล่าเสือโก้ก",
    "sub-district": "หนองบก",
    postcode: 34000,
  },
  {
    province: "อุบลราชธานี",
    district: "สว่างวีระวงศ์",
    "sub-district": "แก่งโดม",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "สว่างวีระวงศ์",
    "sub-district": "ท่าช้าง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "สว่างวีระวงศ์",
    "sub-district": "บุ่งมะแลง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "สว่างวีระวงศ์",
    "sub-district": "สว่าง",
    postcode: 34190,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำขุ่น",
    "sub-district": "ตาเกา",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำขุ่น",
    "sub-district": "ไพบูลย์",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำขุ่น",
    "sub-district": "ขี้เหล็ก",
    postcode: 34260,
  },
  {
    province: "อุบลราชธานี",
    district: "น้ำขุ่น",
    "sub-district": "โคกสะอาด",
    postcode: 34260,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ในเมือง",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "น้ำคำใหญ่",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ตาดทอง",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "สำราญ",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ค้อเหนือ",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ดู่ทุ่ง",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "เดิด",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ขั้นไดใหญ่",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ทุ่งแต้",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "สิงห์",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "นาสะไมย์",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "เขื่องคำ",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "หนองหิน",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "หนองคู",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ขุมเงิน",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "ทุ่งนางโอก",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "หนองเรือ",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "เมืองยโสธร",
    "sub-district": "หนองเป็ด",
    postcode: 35000,
  },
  {
    province: "ยโสธร",
    district: "ทรายมูล",
    "sub-district": "ทรายมูล",
    postcode: 35170,
  },
  {
    province: "ยโสธร",
    district: "ทรายมูล",
    "sub-district": "ดู่ลาด",
    postcode: 35170,
  },
  {
    province: "ยโสธร",
    district: "ทรายมูล",
    "sub-district": "ดงมะไฟ",
    postcode: 35170,
  },
  {
    province: "ยโสธร",
    district: "ทรายมูล",
    "sub-district": "นาเวียง",
    postcode: 35170,
  },
  {
    province: "ยโสธร",
    district: "ทรายมูล",
    "sub-district": "ไผ่",
    postcode: 35170,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "กุดชุม",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "โนนเปือย",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "กำแมด",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "นาโส่",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "ห้วยแก้ง",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "หนองหมี",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "โพนงาม",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "คำน้ำสร้าง",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "กุดชุม",
    "sub-district": "หนองแหน",
    postcode: 35140,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "ลุมพุก",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "ย่อ",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "สงเปือย",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "โพนทัน",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "ทุ่งมน",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "นาคำ",
    postcode: 35180,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "ดงแคนใหญ่",
    postcode: 35180,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "กู่จาน",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "นาแก",
    postcode: 35180,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "กุดกุง",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "เหล่าไฮ",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "แคนน้อย",
    postcode: 35180,
  },
  {
    province: "ยโสธร",
    district: "คำเขื่อนแก้ว",
    "sub-district": "ดงเจริญ",
    postcode: 35110,
  },
  {
    province: "ยโสธร",
    district: "ป่าติ้ว",
    "sub-district": "โพธิ์ไทร",
    postcode: 35150,
  },
  {
    province: "ยโสธร",
    district: "ป่าติ้ว",
    "sub-district": "กระจาย",
    postcode: 35150,
  },
  {
    province: "ยโสธร",
    district: "ป่าติ้ว",
    "sub-district": "โคกนาโก",
    postcode: 35150,
  },
  {
    province: "ยโสธร",
    district: "ป่าติ้ว",
    "sub-district": "เชียงเพ็ง",
    postcode: 35150,
  },
  {
    province: "ยโสธร",
    district: "ป่าติ้ว",
    "sub-district": "ศรีฐาน",
    postcode: 35150,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "ฟ้าหยาด",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "หัวเมือง",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "คูเมือง",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "ผือฮี",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "บากเรือ",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "ม่วง",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "โนนทราย",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "บึงแก",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "พระเสาร์",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "มหาชนะชัย",
    "sub-district": "สงยาง",
    postcode: 35130,
  },
  {
    province: "ยโสธร",
    district: "ค้อวัง",
    "sub-district": "ฟ้าห่วน",
    postcode: 35160,
  },
  {
    province: "ยโสธร",
    district: "ค้อวัง",
    "sub-district": "กุดน้ำใส",
    postcode: 35160,
  },
  {
    province: "ยโสธร",
    district: "ค้อวัง",
    "sub-district": "น้ำอ้อม",
    postcode: 35160,
  },
  {
    province: "ยโสธร",
    district: "ค้อวัง",
    "sub-district": "ค้อวัง",
    postcode: 35160,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "บุ่งค้า",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "สวาท",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "ห้องแซง",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "สามัคคี",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "กุดเชียงหมี",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "สามแยก",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "กุดแห่",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "โคกสำราญ",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "สร้างมิ่ง",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "เลิงนกทา",
    "sub-district": "ศรีแก้ว",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "ไทยเจริญ",
    "sub-district": "ไทยเจริญ",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "ไทยเจริญ",
    "sub-district": "น้ำคำ",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "ไทยเจริญ",
    "sub-district": "ส้มผ่อ",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "ไทยเจริญ",
    "sub-district": "คำเตย",
    postcode: 35120,
  },
  {
    province: "ยโสธร",
    district: "ไทยเจริญ",
    "sub-district": "คำไผ่",
    postcode: 35120,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ในเมือง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "รอบเมือง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "โพนทอง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "นาฝาย",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "บ้านค่าย",
    postcode: 36240,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "กุดตุ้ม",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ชีลอง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "บ้านเล่า",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "นาเสียว",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "หนองนาแซง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ลาดใหญ่",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "หนองไผ่",
    postcode: 36240,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ท่าหินโงม",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ห้วยต้อน",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ห้วยบง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "โนนสำราญ",
    postcode: 36240,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "โคกสูง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "บุ่งคล้า",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "เมืองชัยภูมิ",
    "sub-district": "ซับสีทอง",
    postcode: 36000,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "บ้านเขว้า",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "ตลาดแร้ง",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "ลุ่มลำชี",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "ชีบน",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "ภูแลนคา",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านเขว้า",
    "sub-district": "โนนแดง",
    postcode: 36170,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "คอนสวรรค์",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "ยางหวาย",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "ช่องสามหมอ",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "โนนสะอาด",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "ห้วยไร่",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "บ้านโสก",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "โคกมั่งงอย",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "หนองขาม",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสวรรค์",
    "sub-district": "ศรีสำราญ",
    postcode: 36140,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "บ้านยาง",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "บ้านหัน",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "บ้านเดื่อ",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "บ้านเป้า",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "กุดเลาะ",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "โนนกอก",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "สระโพนทอง",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "หนองข่า",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "หนองโพนงาม",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "บ้านบัว",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "เกษตรสมบูรณ์",
    "sub-district": "โนนทอง",
    postcode: 36120,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "หนองบัวแดง",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "กุดชุมแสง",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "ถ้ำวัวแดง",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "นางแดด",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "หนองแวง",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "คูเมือง",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "ท่าใหญ่",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวแดง",
    "sub-district": "วังชมภู",
    postcode: 36210,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "บ้านกอก",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "หนองบัวบาน",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "บ้านขาม",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "กุดน้ำใส",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "หนองโดน",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "ละหาน",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "หนองบัวใหญ่",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "หนองบัวโคก",
    postcode: 36220,
  },
  {
    province: "ชัยภูมิ",
    district: "จัตุรัส",
    "sub-district": "ส้มป่อย",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "บ้านชวน",
    postcode: 36160,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "บ้านเพชร",
    postcode: 36160,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "บ้านตาล",
    postcode: 36220,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "หัวทะเล",
    postcode: 36220,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "โคกเริงรมย์",
    postcode: 36160,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "เกาะมะนาว",
    postcode: 36160,
  },
  {
    province: "ชัยภูมิ",
    district: "บำเหน็จณรงค์",
    "sub-district": "โคกเพชรพัฒนา",
    postcode: 36160,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวระเหว",
    "sub-district": "หนองบัวระเหว",
    postcode: 36250,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวระเหว",
    "sub-district": "วังตะเฆ่",
    postcode: 36250,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวระเหว",
    "sub-district": "ห้วยแย้",
    postcode: 36250,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวระเหว",
    "sub-district": "โคกสะอาด",
    postcode: 36250,
  },
  {
    province: "ชัยภูมิ",
    district: "หนองบัวระเหว",
    "sub-district": "โสกปลาดุก",
    postcode: 36250,
  },
  {
    province: "ชัยภูมิ",
    district: "เทพสถิต",
    "sub-district": "วะตะแบก",
    postcode: 36230,
  },
  {
    province: "ชัยภูมิ",
    district: "เทพสถิต",
    "sub-district": "ห้วยยายจิ๋ว",
    postcode: 36230,
  },
  {
    province: "ชัยภูมิ",
    district: "เทพสถิต",
    "sub-district": "นายางกลัก",
    postcode: 36230,
  },
  {
    province: "ชัยภูมิ",
    district: "เทพสถิต",
    "sub-district": "บ้านไร่",
    postcode: 36230,
  },
  {
    province: "ชัยภูมิ",
    district: "เทพสถิต",
    "sub-district": "โป่งนก",
    postcode: 36230,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "ผักปัง",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "กวางโจน",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "หนองคอนไทย",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "บ้านแก้ง",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "กุดยม",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "บ้านเพชร",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "โคกสะอาด",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "หนองตูม",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "โอโล",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "ธาตุทอง",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "ภูเขียว",
    "sub-district": "บ้านดอน",
    postcode: 36110,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านแท่น",
    "sub-district": "บ้านแท่น",
    postcode: 36190,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านแท่น",
    "sub-district": "สามสวน",
    postcode: 36190,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านแท่น",
    "sub-district": "สระพัง",
    postcode: 36190,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านแท่น",
    "sub-district": "บ้านเต่า",
    postcode: 36190,
  },
  {
    province: "ชัยภูมิ",
    district: "บ้านแท่น",
    "sub-district": "หนองคู",
    postcode: 36190,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "ช่องสามหมอ",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "หนองขาม",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "นาหนองทุ่ม",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "บ้านแก้ง",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "หนองสังข์",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "หลุบคา",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "โคกกุง",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "เก่าย่าดี",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "ท่ามะไฟหวาน",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "แก้งคร้อ",
    "sub-district": "หนองไผ่",
    postcode: 36150,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "คอนสาร",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ทุ่งพระ",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "โนนคูณ",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ห้วยยาง",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ทุ่งลุยลาย",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ดงบัง",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ทุ่งนาเลา",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "คอนสาร",
    "sub-district": "ดงกลาง",
    postcode: 36180,
  },
  {
    province: "ชัยภูมิ",
    district: "ภักดีชุมพล",
    "sub-district": "บ้านเจียง",
    postcode: 36260,
  },
  {
    province: "ชัยภูมิ",
    district: "ภักดีชุมพล",
    "sub-district": "เจาทอง",
    postcode: 36260,
  },
  {
    province: "ชัยภูมิ",
    district: "ภักดีชุมพล",
    "sub-district": "วังทอง",
    postcode: 36260,
  },
  {
    province: "ชัยภูมิ",
    district: "ภักดีชุมพล",
    "sub-district": "แหลมทอง",
    postcode: 36260,
  },
  {
    province: "ชัยภูมิ",
    district: "เนินสง่า",
    "sub-district": "หนองฉิม",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "เนินสง่า",
    "sub-district": "ตาเนิน",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "เนินสง่า",
    "sub-district": "กะฮาด",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "เนินสง่า",
    "sub-district": "รังงาม",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "ซับใหญ่",
    "sub-district": "ซับใหญ่",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "ซับใหญ่",
    "sub-district": "ท่ากูบ",
    postcode: 36130,
  },
  {
    province: "ชัยภูมิ",
    district: "ซับใหญ่",
    "sub-district": "ตะโกทอง",
    postcode: 36130,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "บุ่ง",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "ไก่คำ",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นาจิก",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "ปลาค้าว",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "เหล่าพรวน",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "สร้างนกทา",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "คึมใหญ่",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นาผือ",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "น้ำปลีก",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นาวัง",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นาหมอม้า",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "โนนโพธิ์",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "โนนหนามแท่ง",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "ห้วยไร่",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "หนองมะแซว",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "กุดปลาดุก",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "ดอนเมย",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นายม",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "เมืองอำนาจเจริญ",
    "sub-district": "นาแต้",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ชานุมาน",
    "sub-district": "ชานุมาน",
    postcode: 37210,
  },
  {
    province: "อำนาจเจริญ",
    district: "ชานุมาน",
    "sub-district": "โคกสาร",
    postcode: 37210,
  },
  {
    province: "อำนาจเจริญ",
    district: "ชานุมาน",
    "sub-district": "คำเขื่อนแก้ว",
    postcode: 37210,
  },
  {
    province: "อำนาจเจริญ",
    district: "ชานุมาน",
    "sub-district": "โคกก่ง",
    postcode: 37210,
  },
  {
    province: "อำนาจเจริญ",
    district: "ชานุมาน",
    "sub-district": "ป่าก่อ",
    postcode: 37210,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "หนองข่า",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "คำโพน",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "นาหว้า",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "ลือ",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "ห้วย",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "โนนงาม",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "ปทุมราชวงศา",
    "sub-district": "นาป่าแซง",
    postcode: 37110,
  },
  {
    province: "อำนาจเจริญ",
    district: "พนา",
    "sub-district": "พนา",
    postcode: 37180,
  },
  {
    province: "อำนาจเจริญ",
    district: "พนา",
    "sub-district": "จานลาน",
    postcode: 37180,
  },
  {
    province: "อำนาจเจริญ",
    district: "พนา",
    "sub-district": "ไม้กลอน",
    postcode: 37180,
  },
  {
    province: "อำนาจเจริญ",
    district: "พนา",
    "sub-district": "พระเหลา",
    postcode: 37180,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "เสนางคนิคม",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "โพนทอง",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "ไร่สีสุก",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "นาเวียง",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "หนองไฮ",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "เสนางคนิคม",
    "sub-district": "หนองสามสี",
    postcode: 37290,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "หัวตะพาน",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "คำพระ",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "เค็งใหญ่",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "หนองแก้ว",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "โพนเมืองน้อย",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "สร้างถ่อน้อย",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "จิกดู่",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "หัวตะพาน",
    "sub-district": "รัตนวารี",
    postcode: 37240,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "อำนาจ",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "ดงมะยาง",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "เปือย",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "ดงบัง",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "ไร่ขี",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "แมด",
    postcode: 37000,
  },
  {
    province: "อำนาจเจริญ",
    district: "ลืออำนาจ",
    "sub-district": "โคกกลาง",
    postcode: 37000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "บึงกาฬ",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "โนนสมบูรณ์",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "โนนสว่าง",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "หอคำ",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "หนองเข็ง",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "หนองเลิง",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "โคกก่อง",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "นาสวรรค์",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "ไคสี",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "ชัยพร",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "วิศิษฐ์",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "คำนาดี",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "เมืองบึงกาฬ",
    "sub-district": "โป่งเปือย",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "ศรีชมภู",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "ดอนหญ้านาง",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "พรเจริญ",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "หนองหัวช้าง",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "วังชมภู",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "ป่าแฝก",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "พรเจริญ",
    "sub-district": "ศรีสำราญ",
    postcode: 38180,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "โซ่",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "หนองพันทา",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "ศรีชมภู",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "คำแก้ว",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "บัวตูม",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "ถ้ำเจริญ",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "โซ่พิสัย",
    "sub-district": "เหล่าทอง",
    postcode: 38170,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "เซกา",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "ซาง",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "ท่ากกแดง",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "บ้านต้อง",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "ป่งไฮ",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "น้ำจั้น",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "ท่าสะอาด",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "หนองทุ่ม",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "เซกา",
    "sub-district": "โสกก่าม",
    postcode: 38150,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "ปากคาด",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "หนองยอง",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "นากั้ง",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "โนนศิลา",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "สมสนุก",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "ปากคาด",
    "sub-district": "นาดง",
    postcode: 38190,
  },
  {
    province: "บึงกาฬ",
    district: "บึงโขงหลง",
    "sub-district": "บึงโขงหลง",
    postcode: 38220,
  },
  {
    province: "บึงกาฬ",
    district: "บึงโขงหลง",
    "sub-district": "โพธิ์หมากแข้ง",
    postcode: 38220,
  },
  {
    province: "บึงกาฬ",
    district: "บึงโขงหลง",
    "sub-district": "ดงบัง",
    postcode: 38220,
  },
  {
    province: "บึงกาฬ",
    district: "บึงโขงหลง",
    "sub-district": "ท่าดอกคำ",
    postcode: 38220,
  },
  {
    province: "บึงกาฬ",
    district: "ศรีวิไล",
    "sub-district": "ศรีวิไล",
    postcode: 38210,
  },
  {
    province: "บึงกาฬ",
    district: "ศรีวิไล",
    "sub-district": "ชุมภูพร",
    postcode: 38210,
  },
  {
    province: "บึงกาฬ",
    district: "ศรีวิไล",
    "sub-district": "นาแสง",
    postcode: 38210,
  },
  {
    province: "บึงกาฬ",
    district: "ศรีวิไล",
    "sub-district": "นาสะแบง",
    postcode: 38210,
  },
  {
    province: "บึงกาฬ",
    district: "ศรีวิไล",
    "sub-district": "นาสิงห์",
    postcode: 38210,
  },
  {
    province: "บึงกาฬ",
    district: "บุ่งคล้า",
    "sub-district": "บุ่งคล้า",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "บุ่งคล้า",
    "sub-district": "หนองเดิ่น",
    postcode: 38000,
  },
  {
    province: "บึงกาฬ",
    district: "บุ่งคล้า",
    "sub-district": "โคกกว้าง",
    postcode: 38000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "หนองบัว",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "หนองภัยศูนย์",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "โพธิ์ชัย",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "หนองสวรรค์",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "หัวนา",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "บ้านขาม",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "นามะเฟือง",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "บ้านพร้าว",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "โนนขมิ้น",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "ลำภู",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "กุดจิก",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "โนนทัน",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "นาคำไฮ",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "ป่าไม้งาม",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "เมืองหนองบัวลำภู",
    "sub-district": "หนองหว้า",
    postcode: 39000,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "นากลาง",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "ด่านช้าง",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "กุดดินจี่",
    postcode: 39350,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "ฝั่งแดง",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "เก่ากลอย",
    postcode: 39350,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "โนนเมือง",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "อุทัยสวรรค์",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "ดงสวรรค์",
    postcode: 39350,
  },
  {
    province: "หนองบัวลำภู",
    district: "นากลาง",
    "sub-district": "กุดแห่",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "โนนสัง",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "บ้านถิ่น",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "หนองเรือ",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "กุดดู่",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "บ้านค้อ",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "โนนเมือง",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "โคกใหญ่",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "โคกม่วง",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "นิคมพัฒนา",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "โนนสัง",
    "sub-district": "ปางกู่",
    postcode: 39140,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "เมืองใหม่",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "ศรีบุญเรือง",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "หนองบัวใต้",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "กุดสะเทียน",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "นากอก",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "โนนสะอาด",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "ยางหล่อ",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "โนนม่วง",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "หนองกุงแก้ว",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "หนองแก",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "ทรายทอง",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "ศรีบุญเรือง",
    "sub-district": "หันนางาม",
    postcode: 39180,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "นาสี",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "บ้านโคก",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "นาดี",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "นาด่าน",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "ดงมะไฟ",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "สุวรรณคูหา",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "บุญทัน",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "สุวรรณคูหา",
    "sub-district": "กุดผึ้ง",
    postcode: 39270,
  },
  {
    province: "หนองบัวลำภู",
    district: "นาวัง",
    "sub-district": "นาเหล่า",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นาวัง",
    "sub-district": "นาแก",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นาวัง",
    "sub-district": "วังทอง",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นาวัง",
    "sub-district": "วังปลาป้อม",
    postcode: 39170,
  },
  {
    province: "หนองบัวลำภู",
    district: "นาวัง",
    "sub-district": "เทพคีรี",
    postcode: 39170,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "ในเมือง",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "สำราญ",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "โคกสี",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "ท่าพระ",
    postcode: 40260,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "บ้านทุ่ม",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "เมืองเก่า",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "พระลับ",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "สาวะถี",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "บ้านหว้า",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "บ้านค้อ",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "แดงใหญ่",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "ดอนช้าง",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "ดอนหัน",
    postcode: 40260,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "ศิลา",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "บ้านเป็ด",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "หนองตูม",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "บึงเนียม",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "เมืองขอนแก่น",
    "sub-district": "โนนท่อน",
    postcode: 40000,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "หนองบัว",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "ป่าหวายนั่ง",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "โนนฆ้อง",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "บ้านเหล่า",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "ป่ามะนาว",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "บ้านฝาง",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านฝาง",
    "sub-district": "โคกงาม",
    postcode: 40270,
  },
  {
    province: "ขอนแก่น",
    district: "พระยืน",
    "sub-district": "พระยืน",
    postcode: 40320,
  },
  {
    province: "ขอนแก่น",
    district: "พระยืน",
    "sub-district": "พระบุ",
    postcode: 40320,
  },
  {
    province: "ขอนแก่น",
    district: "พระยืน",
    "sub-district": "บ้านโต้น",
    postcode: 40320,
  },
  {
    province: "ขอนแก่น",
    district: "พระยืน",
    "sub-district": "หนองแวง",
    postcode: 40320,
  },
  {
    province: "ขอนแก่น",
    district: "พระยืน",
    "sub-district": "ขามป้อม",
    postcode: 40320,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "หนองเรือ",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "บ้านเม็ง",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "บ้านกง",
    postcode: 40240,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "ยางคำ",
    postcode: 40240,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "จระเข้",
    postcode: 40240,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "โนนทอง",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "กุดกว้าง",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "โนนทัน",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "โนนสะอาด",
    postcode: 40210,
  },
  {
    province: "ขอนแก่น",
    district: "หนองเรือ",
    "sub-district": "บ้านผือ",
    postcode: 40240,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "ชุมแพ",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "โนนหัน",
    postcode: 40290,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "นาหนองทุ่ม",
    postcode: 40290,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "โนนอุดม",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "ขัวเรียง",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "หนองไผ่",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "ไชยสอ",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "วังหินลาด",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "นาเพียง",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "หนองเขียด",
    postcode: 40290,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "หนองเสาเล้า",
    postcode: 40130,
  },
  {
    province: "ขอนแก่น",
    district: "ชุมแพ",
    "sub-district": "โนนสะอาด",
    postcode: 40290,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "สีชมพู",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "ศรีสุข",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "นาจาน",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "วังเพิ่ม",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "ซำยาง",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "หนองแดง",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "ดงลาน",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "บริบูรณ์",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "บ้านใหม่",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "สีชมพู",
    "sub-district": "ภูห่าน",
    postcode: 40220,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "น้ำพอง",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "วังชัย",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "หนองกุง",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "บัวใหญ่",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "สะอาด",
    postcode: 40310,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "ม่วงหวาน",
    postcode: 40310,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "บ้านขาม",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "บัวเงิน",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "ทรายมูล",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "ท่ากระเสริม",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "พังทุย",
    postcode: 40140,
  },
  {
    province: "ขอนแก่น",
    district: "น้ำพอง",
    "sub-district": "กุดน้ำใส",
    postcode: 40310,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "โคกสูง",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "บ้านดง",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "เขื่อนอุบลรัตน์",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "นาคำ",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "ศรีสุขสำราญ",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "อุบลรัตน์",
    "sub-district": "ทุ่งโป่ง",
    postcode: 40250,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "หนองโก",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "หนองกุงใหญ่",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "ห้วยโจด",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "ห้วยยาง",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "บ้านฝาง",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "ดูนสาด",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "หนองโน",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "น้ำอ้อม",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "กระนวน",
    "sub-district": "หัวนาคำ",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "บ้านไผ่",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "ในเมือง",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "เมืองเพีย",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "บ้านลาน",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "แคนเหนือ",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "ภูเหล็ก",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "ป่าปอ",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "หินตั้ง",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "หนองน้ำใส",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านไผ่",
    "sub-district": "หัวหนอง",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "เปือยน้อย",
    "sub-district": "เปือยน้อย",
    postcode: 40340,
  },
  {
    province: "ขอนแก่น",
    district: "เปือยน้อย",
    "sub-district": "วังม่วง",
    postcode: 40340,
  },
  {
    province: "ขอนแก่น",
    district: "เปือยน้อย",
    "sub-district": "ขามป้อม",
    postcode: 40340,
  },
  {
    province: "ขอนแก่น",
    district: "เปือยน้อย",
    "sub-district": "สระแก้ว",
    postcode: 40340,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "เมืองพล",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "โจดหนองแก",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "เก่างิ้ว",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "หนองมะเขือ",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "หนองแวงโสกพระ",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "เพ็กใหญ่",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "โคกสง่า",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "หนองแวงนางเบ้า",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "ลอมคอม",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "โนนข่า",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "โสกนกเต็น",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "พล",
    "sub-district": "หัวทุ่ง",
    postcode: 40120,
  },
  {
    province: "ขอนแก่น",
    district: "แวงใหญ่",
    "sub-district": "คอนฉิม",
    postcode: 40330,
  },
  {
    province: "ขอนแก่น",
    district: "แวงใหญ่",
    "sub-district": "ใหม่นาเพียง",
    postcode: 40330,
  },
  {
    province: "ขอนแก่น",
    district: "แวงใหญ่",
    "sub-district": "โนนทอง",
    postcode: 40330,
  },
  {
    province: "ขอนแก่น",
    district: "แวงใหญ่",
    "sub-district": "แวงใหญ่",
    postcode: 40330,
  },
  {
    province: "ขอนแก่น",
    district: "แวงใหญ่",
    "sub-district": "โนนสะอาด",
    postcode: 40330,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "แวงน้อย",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "ก้านเหลือง",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "ท่านางแนว",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "ละหานนา",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "ท่าวัด",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "แวงน้อย",
    "sub-district": "ทางขวาง",
    postcode: 40230,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "หนองสองห้อง",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "คึมชาด",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "โนนธาตุ",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "ตะกั่วป่า",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "สำโรง",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "หนองเม็ก",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "ดอนดู่",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "ดงเค็ง",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "หันโจด",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "ดอนดั่ง",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "วังหิน",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "หนองสองห้อง",
    "sub-district": "หนองไผ่ล้อม",
    postcode: 40190,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "บ้านเรือ",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "หว้าทอง",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "กุดขอนแก่น",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "นาชุมแสง",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "นาหว้า",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "หนองกุงธนสาร",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "หนองกุงเซิน",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "สงเปือย",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "ทุ่งชมพู",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "ดินดำ",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "ภูเวียง",
    "sub-district": "ภูเวียง",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "กุดเค้า",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "สวนหม่อน",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "หนองแปน",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "โพนเพ็ก",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "คำแคน",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "นาข่า",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "นางาม",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "มัญจาคีรี",
    "sub-district": "ท่าศาลา",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "ชนบท",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "กุดเพียขอม",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "วังแสง",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "ห้วยแก",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "บ้านแท่น",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "ศรีบุญเรือง",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "โนนพะยอม",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "ชนบท",
    "sub-district": "ปอแดง",
    postcode: 40180,
  },
  {
    province: "ขอนแก่น",
    district: "เขาสวนกวาง",
    "sub-district": "เขาสวนกวาง",
    postcode: 40280,
  },
  {
    province: "ขอนแก่น",
    district: "เขาสวนกวาง",
    "sub-district": "ดงเมืองแอม",
    postcode: 40280,
  },
  {
    province: "ขอนแก่น",
    district: "เขาสวนกวาง",
    "sub-district": "นางิ้ว",
    postcode: 40280,
  },
  {
    province: "ขอนแก่น",
    district: "เขาสวนกวาง",
    "sub-district": "โนนสมบูรณ์",
    postcode: 40280,
  },
  {
    province: "ขอนแก่น",
    district: "เขาสวนกวาง",
    "sub-district": "คำม่วง",
    postcode: 40280,
  },
  {
    province: "ขอนแก่น",
    district: "ภูผาม่าน",
    "sub-district": "โนนคอม",
    postcode: 40350,
  },
  {
    province: "ขอนแก่น",
    district: "ภูผาม่าน",
    "sub-district": "นาฝาย",
    postcode: 40350,
  },
  {
    province: "ขอนแก่น",
    district: "ภูผาม่าน",
    "sub-district": "ภูผาม่าน",
    postcode: 40350,
  },
  {
    province: "ขอนแก่น",
    district: "ภูผาม่าน",
    "sub-district": "วังสวาบ",
    postcode: 40350,
  },
  {
    province: "ขอนแก่น",
    district: "ภูผาม่าน",
    "sub-district": "ห้วยม่วง",
    postcode: 40350,
  },
  {
    province: "ขอนแก่น",
    district: "ซำสูง",
    "sub-district": "กระนวน",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "ซำสูง",
    "sub-district": "คำแมด",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "ซำสูง",
    "sub-district": "บ้านโนน",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "ซำสูง",
    "sub-district": "คูคำ",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "ซำสูง",
    "sub-district": "ห้วยเตย",
    postcode: 40170,
  },
  {
    province: "ขอนแก่น",
    district: "โคกโพธิ์ไชย",
    "sub-district": "บ้านโคก",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "โคกโพธิ์ไชย",
    "sub-district": "โพธิ์ไชย",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "โคกโพธิ์ไชย",
    "sub-district": "ซับสมบูรณ์",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "โคกโพธิ์ไชย",
    "sub-district": "นาแพง",
    postcode: 40160,
  },
  {
    province: "ขอนแก่น",
    district: "หนองนาคำ",
    "sub-district": "กุดธาตุ",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "หนองนาคำ",
    "sub-district": "บ้านโคก",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "หนองนาคำ",
    "sub-district": "ขนวน",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านแฮด",
    "sub-district": "บ้านแฮด",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านแฮด",
    "sub-district": "โคกสำราญ",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านแฮด",
    "sub-district": "โนนสมบูรณ์",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "บ้านแฮด",
    "sub-district": "หนองแซง",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "โนนศิลา",
    "sub-district": "โนนศิลา",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "โนนศิลา",
    "sub-district": "หนองปลาหมอ",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "โนนศิลา",
    "sub-district": "บ้านหัน",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "โนนศิลา",
    "sub-district": "เปือยใหญ่",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "โนนศิลา",
    "sub-district": "โนนแดง",
    postcode: 40110,
  },
  {
    province: "ขอนแก่น",
    district: "เวียงเก่า",
    "sub-district": "ในเมือง",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "เวียงเก่า",
    "sub-district": "เมืองเก่าพัฒนา",
    postcode: 40150,
  },
  {
    province: "ขอนแก่น",
    district: "เวียงเก่า",
    "sub-district": "เขาน้อย",
    postcode: 40150,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หมากแข้ง",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "นิคมสงเคราะห์",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "บ้านขาว",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หนองบัว",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "บ้านตาด",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "โนนสูง",
    postcode: 41330,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หมูม่น",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "เชียงยืน",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หนองนาคำ",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "กุดสระ",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "นาดี",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "บ้านเลื่อม",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "เชียงพิณ",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "สามพร้าว",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หนองไฮ",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "นาข่า",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "บ้านจั่น",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หนองขอนกว้าง",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "โคกสะอาด",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "นากว้าง",
    postcode: 41000,
  },
  {
    province: "อุดรธานี",
    district: "เมืองอุดรธานี",
    "sub-district": "หนองไผ่",
    postcode: 41330,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "กุดจับ",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "ปะโค",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "ขอนยูง",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "เชียงเพ็ง",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "สร้างก่อ",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "เมืองเพีย",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "กุดจับ",
    "sub-district": "ตาลเลียน",
    postcode: 41250,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "หมากหญ้า",
    postcode: 41360,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "หนองอ้อ",
    postcode: 41220,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "อูบมุง",
    postcode: 41220,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "กุดหมากไฟ",
    postcode: 41220,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "น้ำพ่น",
    postcode: 41360,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "หนองบัวบาน",
    postcode: 41360,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "โนนหวาย",
    postcode: 41220,
  },
  {
    province: "อุดรธานี",
    district: "หนองวัวซอ",
    "sub-district": "หนองวัวซอ",
    postcode: 41360,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "ตูมใต้",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "พันดอน",
    postcode: 41370,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "เวียงคำ",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "แชแล",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "เชียงแหว",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "ห้วยเกิ้ง",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "เสอเพลอ",
    postcode: 41370,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "สีออ",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "ปะโค",
    postcode: 41370,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "ผาสุก",
    postcode: 41370,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "ท่าลี่",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "กุมภวาปี",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "กุมภวาปี",
    "sub-district": "หนองหว้า",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "โนนสะอาด",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "บุ่งแก้ว",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "โพธิ์ศรีสำราญ",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "ทมนางาม",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "หนองกุงศรี",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "โนนสะอาด",
    "sub-district": "โคกกลาง",
    postcode: 41240,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "หนองหาน",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "หนองเม็ก",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "พังงู",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "สะแบง",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "สร้อยพร้าว",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "บ้านเชียง",
    postcode: 41320,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "บ้านยา",
    postcode: 41320,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "โพนงาม",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "ผักตบ",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "หนองไผ่",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "ดอนหายโศก",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "หนองหาน",
    "sub-district": "หนองสระปลา",
    postcode: 41320,
  },
  {
    province: "อุดรธานี",
    district: "ทุ่งฝน",
    "sub-district": "ทุ่งฝน",
    postcode: 41310,
  },
  {
    province: "อุดรธานี",
    district: "ทุ่งฝน",
    "sub-district": "ทุ่งใหญ่",
    postcode: 41310,
  },
  {
    province: "อุดรธานี",
    district: "ทุ่งฝน",
    "sub-district": "นาชุมแสง",
    postcode: 41310,
  },
  {
    province: "อุดรธานี",
    district: "ทุ่งฝน",
    "sub-district": "นาทม",
    postcode: 41310,
  },
  {
    province: "อุดรธานี",
    district: "ไชยวาน",
    "sub-district": "ไชยวาน",
    postcode: 41290,
  },
  {
    province: "อุดรธานี",
    district: "ไชยวาน",
    "sub-district": "หนองหลัก",
    postcode: 41290,
  },
  {
    province: "อุดรธานี",
    district: "ไชยวาน",
    "sub-district": "คำเลาะ",
    postcode: 41290,
  },
  {
    province: "อุดรธานี",
    district: "ไชยวาน",
    "sub-district": "โพนสูง",
    postcode: 41290,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "ศรีธาตุ",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "จำปี",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "บ้านโปร่ง",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "หัวนาคำ",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "หนองนกเขียน",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "นายูง",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "ศรีธาตุ",
    "sub-district": "ตาดทอง",
    postcode: 41230,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "หนองกุงทับม้า",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "หนองหญ้าไซ",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "บะยาว",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "ผาสุก",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "คำโคกสูง",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "วังสามหมอ",
    "sub-district": "วังสามหมอ",
    postcode: 41280,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "ศรีสุทโธ",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "บ้านดุง",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "ดงเย็น",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "โพนสูง",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "อ้อมกอ",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "บ้านจันทน์",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "บ้านชัย",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "นาไหม",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "ถ่อนนาลับ",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "วังทอง",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "บ้านม่วง",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "บ้านตาด",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านดุง",
    "sub-district": "นาคำ",
    postcode: 41190,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "บ้านผือ",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "หายโศก",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "เขือน้ำ",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "คำบง",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "โนนทอง",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "ข้าวสาร",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "จำปาโมง",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "กลางใหญ่",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "เมืองพาน",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "คำด้วง",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "หนองหัวคู",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "บ้านค้อ",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "บ้านผือ",
    "sub-district": "หนองแวง",
    postcode: 41160,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "นางัว",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "น้ำโสม",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "หนองแวง",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "บ้านหยวก",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "โสมเยี่ยม",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "ศรีสำราญ",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "น้ำโสม",
    "sub-district": "สามัคคี",
    postcode: 41210,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "เพ็ญ",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "บ้านธาตุ",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "นาพู่",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "เชียงหวาง",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "สุมเส้า",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "นาบัว",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "บ้านเหล่า",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "จอมศรี",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "เตาไห",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "โคกกลาง",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "เพ็ญ",
    "sub-district": "สร้างแป้น",
    postcode: 41150,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "สร้างคอม",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "เชียงดา",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "บ้านยวด",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "บ้านโคก",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "นาสะอาด",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "สร้างคอม",
    "sub-district": "บ้านหินโงม",
    postcode: 41260,
  },
  {
    province: "อุดรธานี",
    district: "หนองแสง",
    "sub-district": "หนองแสง",
    postcode: 41340,
  },
  {
    province: "อุดรธานี",
    district: "หนองแสง",
    "sub-district": "แสงสว่าง",
    postcode: 41340,
  },
  {
    province: "อุดรธานี",
    district: "หนองแสง",
    "sub-district": "นาดี",
    postcode: 41340,
  },
  {
    province: "อุดรธานี",
    district: "หนองแสง",
    "sub-district": "ทับกุง",
    postcode: 41340,
  },
  {
    province: "อุดรธานี",
    district: "นายูง",
    "sub-district": "นายูง",
    postcode: 41380,
  },
  {
    province: "อุดรธานี",
    district: "นายูง",
    "sub-district": "บ้านก้อง",
    postcode: 41380,
  },
  {
    province: "อุดรธานี",
    district: "นายูง",
    "sub-district": "นาแค",
    postcode: 41380,
  },
  {
    province: "อุดรธานี",
    district: "นายูง",
    "sub-district": "โนนทอง",
    postcode: 41380,
  },
  {
    province: "อุดรธานี",
    district: "พิบูลย์รักษ์",
    "sub-district": "บ้านแดง",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "พิบูลย์รักษ์",
    "sub-district": "นาทราย",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "พิบูลย์รักษ์",
    "sub-district": "ดอนกลอย",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "กู่แก้ว",
    "sub-district": "บ้านจีต",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "กู่แก้ว",
    "sub-district": "โนนทองอินทร์",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "กู่แก้ว",
    "sub-district": "ค้อใหญ่",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "กู่แก้ว",
    "sub-district": "คอนสาย",
    postcode: 41130,
  },
  {
    province: "อุดรธานี",
    district: "ประจักษ์ศิลปาคม",
    "sub-district": "นาม่วง",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "ประจักษ์ศิลปาคม",
    "sub-district": "ห้วยสามพาด",
    postcode: 41110,
  },
  {
    province: "อุดรธานี",
    district: "ประจักษ์ศิลปาคม",
    "sub-district": "อุ่มจาน",
    postcode: 41110,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "กุดป่อง",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "เมือง",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "นาอ้อ",
    postcode: 42100,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "กกดู่",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "น้ำหมาน",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "เสี้ยว",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "นาอาน",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "นาโป่ง",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "นาดินดำ",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "น้ำสวย",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "ชัยพฤกษ์",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "นาแขม",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "ศรีสองรัก",
    postcode: 42100,
  },
  {
    province: "เลย",
    district: "เมืองเลย",
    "sub-district": "กกทอง",
    postcode: 42000,
  },
  {
    province: "เลย",
    district: "นาด้วง",
    "sub-district": "นาด้วง",
    postcode: 42210,
  },
  {
    province: "เลย",
    district: "นาด้วง",
    "sub-district": "นาดอกคำ",
    postcode: 42210,
  },
  {
    province: "เลย",
    district: "นาด้วง",
    "sub-district": "ท่าสะอาด",
    postcode: 42210,
  },
  {
    province: "เลย",
    district: "นาด้วง",
    "sub-district": "ท่าสวรรค์",
    postcode: 42210,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "เชียงคาน",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "ธาตุ",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "นาซ่าว",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "เขาแก้ว",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "ปากตม",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "บุฮม",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "จอมศรี",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "เชียงคาน",
    "sub-district": "หาดทรายขาว",
    postcode: 42110,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "ปากชม",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "เชียงกลม",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "หาดคัมภีร์",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "ห้วยบ่อซืน",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "ห้วยพิชัย",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ปากชม",
    "sub-district": "ชมเจริญ",
    postcode: 42150,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "ด่านซ้าย",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "ปากหมัน",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "นาดี",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "โคกงาม",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "โพนสูง",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "อิปุ่ม",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "กกสะทอน",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "โป่ง",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "วังยาว",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "ด่านซ้าย",
    "sub-district": "นาหอ",
    postcode: 42120,
  },
  {
    province: "เลย",
    district: "นาแห้ว",
    "sub-district": "นาแห้ว",
    postcode: 42170,
  },
  {
    province: "เลย",
    district: "นาแห้ว",
    "sub-district": "แสงภา",
    postcode: 42170,
  },
  {
    province: "เลย",
    district: "นาแห้ว",
    "sub-district": "นาพึง",
    postcode: 42170,
  },
  {
    province: "เลย",
    district: "นาแห้ว",
    "sub-district": "นามาลา",
    postcode: 42170,
  },
  {
    province: "เลย",
    district: "นาแห้ว",
    "sub-district": "เหล่ากอหก",
    postcode: 42170,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "หนองบัว",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "ท่าศาลา",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "ร่องจิก",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "ปลาบ่า",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "ลาดค่าง",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ภูเรือ",
    "sub-district": "สานตม",
    postcode: 42160,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "ท่าลี่",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "หนองผือ",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "อาฮี",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "น้ำแคม",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "โคกใหญ่",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "ท่าลี่",
    "sub-district": "น้ำทูน",
    postcode: 42140,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "วังสะพุง",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "ทรายขาว",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "หนองหญ้าปล้อง",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "หนองงิ้ว",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "ปากปวน",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "ผาน้อย",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "ผาบิ้ง",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "เขาหลวง",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "โคกขมิ้น",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "วังสะพุง",
    "sub-district": "ศรีสงคราม",
    postcode: 42130,
  },
  {
    province: "เลย",
    district: "ภูกระดึง",
    "sub-district": "ศรีฐาน",
    postcode: 42180,
  },
  {
    province: "เลย",
    district: "ภูกระดึง",
    "sub-district": "ผานกเค้า",
    postcode: 42180,
  },
  {
    province: "เลย",
    district: "ภูกระดึง",
    "sub-district": "ภูกระดึง",
    postcode: 42180,
  },
  {
    province: "เลย",
    district: "ภูกระดึง",
    "sub-district": "ห้วยส้ม",
    postcode: 42180,
  },
  {
    province: "เลย",
    district: "ภูหลวง",
    "sub-district": "ภูหอ",
    postcode: 42230,
  },
  {
    province: "เลย",
    district: "ภูหลวง",
    "sub-district": "หนองคัน",
    postcode: 42230,
  },
  {
    province: "เลย",
    district: "ภูหลวง",
    "sub-district": "ห้วยสีเสียด",
    postcode: 42230,
  },
  {
    province: "เลย",
    district: "ภูหลวง",
    "sub-district": "เลยวังไสย์",
    postcode: 42230,
  },
  {
    province: "เลย",
    district: "ภูหลวง",
    "sub-district": "แก่งศรีภูมิ",
    postcode: 42230,
  },
  {
    province: "เลย",
    district: "ผาขาว",
    "sub-district": "ผาขาว",
    postcode: 42240,
  },
  {
    province: "เลย",
    district: "ผาขาว",
    "sub-district": "ท่าช้างคล้อง",
    postcode: 42240,
  },
  {
    province: "เลย",
    district: "ผาขาว",
    "sub-district": "โนนปอแดง",
    postcode: 42240,
  },
  {
    province: "เลย",
    district: "ผาขาว",
    "sub-district": "โนนป่าซาง",
    postcode: 42240,
  },
  {
    province: "เลย",
    district: "ผาขาว",
    "sub-district": "บ้านเพิ่ม",
    postcode: 42240,
  },
  {
    province: "เลย",
    district: "เอราวัณ",
    "sub-district": "เอราวัณ",
    postcode: 42220,
  },
  {
    province: "เลย",
    district: "เอราวัณ",
    "sub-district": "ผาอินทร์แปลง",
    postcode: 42220,
  },
  {
    province: "เลย",
    district: "เอราวัณ",
    "sub-district": "ผาสามยอด",
    postcode: 42220,
  },
  {
    province: "เลย",
    district: "เอราวัณ",
    "sub-district": "ทรัพย์ไพวัลย์",
    postcode: 42220,
  },
  {
    province: "เลย",
    district: "หนองหิน",
    "sub-district": "หนองหิน",
    postcode: 42190,
  },
  {
    province: "เลย",
    district: "หนองหิน",
    "sub-district": "ตาดข่า",
    postcode: 42190,
  },
  {
    province: "เลย",
    district: "หนองหิน",
    "sub-district": "ปวนพุ",
    postcode: 42190,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "ในเมือง",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "มีชัย",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "โพธิ์ชัย",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "กวนวัน",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "เวียงคุก",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "วัดธาตุ",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "หาดคำ",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "หินโงม",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "บ้านเดื่อ",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "ค่ายบกหวาน",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "โพนสว่าง",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "พระธาตุบังพวน",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "หนองกอมเกาะ",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "ปะโค",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "เมืองหมี",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "เมืองหนองคาย",
    "sub-district": "สีกาย",
    postcode: 43000,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "ท่าบ่อ",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "น้ำโมง",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "กองนาง",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "โคกคอน",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "บ้านเดื่อ",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "บ้านถ่อน",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "บ้านว่าน",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "นาข่า",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "โพนสา",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "ท่าบ่อ",
    "sub-district": "หนองนาง",
    postcode: 43110,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "จุมพล",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "วัดหลวง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "กุดบง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "ชุมช้าง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "ทุ่งหลวง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "เหล่าต่างคำ",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "นาหนัง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "เซิม",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "บ้านโพธิ์",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "บ้านผือ",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพนพิสัย",
    "sub-district": "สร้างนางขาว",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "ศรีเชียงใหม่",
    "sub-district": "พานพร้าว",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "ศรีเชียงใหม่",
    "sub-district": "บ้านหม้อ",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "ศรีเชียงใหม่",
    "sub-district": "พระพุทธบาท",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "ศรีเชียงใหม่",
    "sub-district": "หนองปลาปาก",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "สังคม",
    "sub-district": "แก้งไก่",
    postcode: 43160,
  },
  {
    province: "หนองคาย",
    district: "สังคม",
    "sub-district": "ผาตั้ง",
    postcode: 43160,
  },
  {
    province: "หนองคาย",
    district: "สังคม",
    "sub-district": "บ้านม่วง",
    postcode: 43160,
  },
  {
    province: "หนองคาย",
    district: "สังคม",
    "sub-district": "นางิ้ว",
    postcode: 43160,
  },
  {
    province: "หนองคาย",
    district: "สังคม",
    "sub-district": "สังคม",
    postcode: 43160,
  },
  {
    province: "หนองคาย",
    district: "สระใคร",
    "sub-district": "สระใคร",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "สระใคร",
    "sub-district": "คอกช้าง",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "สระใคร",
    "sub-district": "บ้านฝาง",
    postcode: 43100,
  },
  {
    province: "หนองคาย",
    district: "เฝ้าไร่",
    "sub-district": "เฝ้าไร่",
    postcode: 43230,
  },
  {
    province: "หนองคาย",
    district: "เฝ้าไร่",
    "sub-district": "นาดี",
    postcode: 43230,
  },
  {
    province: "หนองคาย",
    district: "เฝ้าไร่",
    "sub-district": "หนองหลวง",
    postcode: 43230,
  },
  {
    province: "หนองคาย",
    district: "เฝ้าไร่",
    "sub-district": "วังหลวง",
    postcode: 43230,
  },
  {
    province: "หนองคาย",
    district: "เฝ้าไร่",
    "sub-district": "อุดมพร",
    postcode: 43230,
  },
  {
    province: "หนองคาย",
    district: "รัตนวาปี",
    "sub-district": "รัตนวาปี",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "รัตนวาปี",
    "sub-district": "นาทับไฮ",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "รัตนวาปี",
    "sub-district": "บ้านต้อน",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "รัตนวาปี",
    "sub-district": "พระบาทนาสิงห์",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "รัตนวาปี",
    "sub-district": "โพนแพง",
    postcode: 43120,
  },
  {
    province: "หนองคาย",
    district: "โพธิ์ตาก",
    "sub-district": "โพธิ์ตาก",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "โพธิ์ตาก",
    "sub-district": "โพนทอง",
    postcode: 43130,
  },
  {
    province: "หนองคาย",
    district: "โพธิ์ตาก",
    "sub-district": "ด่านศรีสุข",
    postcode: 43130,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ตลาด",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "เขวา",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ท่าตูม",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "แวงน่าง",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "โคกก่อ",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ดอนหว่าน",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "เกิ้ง",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "แก่งเลิงจาน",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ท่าสองคอน",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ลาดพัฒนา",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "หนองปลิง",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "ห้วยแอ่ง",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "หนองโน",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "เมืองมหาสารคาม",
    "sub-district": "บัวค้อ",
    postcode: 44000,
  },
  {
    province: "มหาสารคาม",
    district: "แกดำ",
    "sub-district": "แกดำ",
    postcode: 44190,
  },
  {
    province: "มหาสารคาม",
    district: "แกดำ",
    "sub-district": "วังแสง",
    postcode: 44190,
  },
  {
    province: "มหาสารคาม",
    district: "แกดำ",
    "sub-district": "มิตรภาพ",
    postcode: 44190,
  },
  {
    province: "มหาสารคาม",
    district: "แกดำ",
    "sub-district": "หนองกุง",
    postcode: 44190,
  },
  {
    province: "มหาสารคาม",
    district: "แกดำ",
    "sub-district": "โนนภิบาล",
    postcode: 44190,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "หัวขวาง",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "ยางน้อย",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "วังยาว",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "เขวาไร่",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "แพง",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "แก้งแก",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "หนองเหล็ก",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "หนองบัว",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "เหล่า",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "เขื่อน",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "หนองบอน",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "โพนงาม",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "ยางท่าแจ้ง",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "แห่ใต้",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "หนองกุงสวรรค์",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "เลิงใต้",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "โกสุมพิสัย",
    "sub-district": "ดอนกลาง",
    postcode: 44140,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "โคกพระ",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "คันธารราษฎร์",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "มะค่า",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "ท่าขอนยาง",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "นาสีนวน",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "ขามเรียง",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "เขวาใหญ่",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "ศรีสุข",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "กุดใส้จ่อ",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "กันทรวิชัย",
    "sub-district": "ขามเฒ่าพัฒนา",
    postcode: 44150,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "เชียงยืน",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "หนองซอน",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "ดอนเงิน",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "กู่ทอง",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "นาทอง",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "เสือเฒ่า",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "โพนทอง",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "เชียงยืน",
    "sub-district": "เหล่าบัวบาน",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "บรบือ",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "บ่อใหญ่",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "วังไชย",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "หนองม่วง",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "กำพี้",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "โนนราษี",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "โนนแดง",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "หนองจิก",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "บัวมาศ",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "หนองคูขาด",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "วังใหม่",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "ยาง",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "หนองสิม",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "หนองโก",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "บรบือ",
    "sub-district": "ดอนงัว",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "นาเชือก",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "สำโรง",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "หนองแดง",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "เขวาไร่",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "หนองโพธิ์",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "ปอพาน",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "หนองเม็ก",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "หนองเรือ",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "หนองกุง",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "นาเชือก",
    "sub-district": "สันป่าตอง",
    postcode: 44170,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ปะหลาน",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ก้ามปู",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "เวียงสะอาด",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "เม็กดำ",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "นาสีนวล",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ราษฎร์เจริญ",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "หนองบัวแก้ว",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "เมืองเตา",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ลานสะแก",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "เวียงชัย",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "หนองบัว",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ราษฎร์พัฒนา",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "เมืองเสือ",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "พยัคฆภูมิพิสัย",
    "sub-district": "ภารแอ่น",
    postcode: 44110,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "หนองแสง",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "ขามป้อม",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "เสือโก้ก",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "ดงใหญ่",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "โพธิ์ชัย",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "หัวเรือ",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "แคน",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "งัวบา",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "นาข่า",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "บ้านหวาย",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "หนองไฮ",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "ประชาพัฒนา",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "หนองทุ่ม",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "หนองแสน",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "วาปีปทุม",
    "sub-district": "โคกสีทองหลาง",
    postcode: 44120,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "นาดูน",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "หนองไผ่",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "หนองคู",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "ดงบัง",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "ดงดวน",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "หัวดง",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "ดงยาง",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "กู่สันตรัตน์",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "นาดูน",
    "sub-district": "พระธาตุ",
    postcode: 44180,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "ยางสีสุราช",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "นาภู",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "แวงดง",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "บ้านกู่",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "ดงเมือง",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "สร้างแซ่ง",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "ยางสีสุราช",
    "sub-district": "หนองบัวสันตุ",
    postcode: 44210,
  },
  {
    province: "มหาสารคาม",
    district: "กุดรัง",
    "sub-district": "กุดรัง",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "กุดรัง",
    "sub-district": "นาโพธิ์",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "กุดรัง",
    "sub-district": "เลิงแฝก",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "กุดรัง",
    "sub-district": "หนองแวง",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "กุดรัง",
    "sub-district": "ห้วยเตย",
    postcode: 44130,
  },
  {
    province: "มหาสารคาม",
    district: "ชื่นชม",
    "sub-district": "ชื่นชม",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "ชื่นชม",
    "sub-district": "กุดปลาดุก",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "ชื่นชม",
    "sub-district": "เหล่าดอกไม้",
    postcode: 44160,
  },
  {
    province: "มหาสารคาม",
    district: "ชื่นชม",
    "sub-district": "หนองกุง",
    postcode: 44160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "ในเมือง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "รอบเมือง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "เหนือเมือง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "ขอนแก่น",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "นาโพธิ์",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "สะอาดสมบูรณ์",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "สีแก้ว",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "ปอภาร (ปอพาน)",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "โนนรัง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "หนองแก้ว",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "หนองแวง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "ดงลาน",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "แคนใหญ่",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "โนนตาล",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองร้อยเอ็ด",
    "sub-district": "เมืองทอง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "เกษตรวิสัย",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "เมืองบัว",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "เหล่าหลวง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "สิงห์โคก",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "ดงครั่งใหญ่",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "บ้านฝาง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "หนองแวง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "กำแพง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "กู่กาสิงห์",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "น้ำอ้อม",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "โนนสว่าง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "ทุ่งทอง",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เกษตรวิสัย",
    "sub-district": "ดงครั่งน้อย",
    postcode: 45150,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "บัวแดง",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "ดอกล้ำ",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "หนองแคน",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "โพนสูง",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "โนนสวรรค์",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "สระบัว",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "โนนสง่า",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ปทุมรัตต์",
    "sub-district": "ขี้เหล็ก",
    postcode: 45190,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "หัวช้าง",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "หนองผือ",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "เมืองหงส์",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "โคกล่าม",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "น้ำใส",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ดงแดง",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ดงกลาง",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ป่าสังข์",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "อีง่อง",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ลิ้นฟ้า",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ดู่น้อย",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จตุรพักตรพิมาน",
    "sub-district": "ศรีโคตร",
    postcode: 45180,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "นิเวศน์",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "ธงธานี",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "หนองไผ่",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "ธวัชบุรี",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "อุ่มเม้า",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "มะอึ",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "เขวาทุ่ง",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "ไพศาล",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "เมืองน้อย",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "บึงนคร",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "ราชธานี",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ธวัชบุรี",
    "sub-district": "หนองพอก",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "พนมไพร",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "แสนสุข",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "กุดน้ำใส",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "หนองทัพไทย",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "โพธิ์ใหญ่",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "วารีสวัสดิ์",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "โคกสว่าง",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "โพธิ์ชัย",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "นานวล",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "คำไฮ",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "สระแก้ว",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "ค้อใหญ่",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "พนมไพร",
    "sub-district": "ชานุวรรณ",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "แวง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "โคกกกม่วง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "นาอุดม",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "สว่าง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "หนองใหญ่",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "โพธิ์ทอง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "โนนชัยศรี",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "โพธิ์ศรีสว่าง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "อุ่มเม่า",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "คำนาดี",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "พรมสวรรค์",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "สระนกแก้ว",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "วังสามัคคี",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทอง",
    "sub-district": "โคกสูง",
    postcode: 45110,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "ขามเปี้ย",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "เชียงใหม่",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "บัวคำ",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "อัคคะคำ",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "สะอาด",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "คำพอุง",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "หนองตาไก้",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "ดอนโอง",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพธิ์ชัย",
    "sub-district": "โพธิ์ศรี",
    postcode: 45230,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "หนองพอก",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "บึงงาม",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "ภูเขาทอง",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "กกโพธิ์",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "โคกสว่าง",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "หนองขุ่นใหญ่",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "รอบเมือง",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "ผาน้ำย้อย",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองพอก",
    "sub-district": "ท่าสีดา",
    postcode: 45210,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "กลาง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "นางาม",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "เมืองไพร",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "นาแซง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "นาเมือง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "วังหลวง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "ท่าม่วง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "ขวาว",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "โพธิ์ทอง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "ภูเงิน",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "เกาะแก้ว",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "นาเลิง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "เหล่าน้อย",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "ศรีวิลัย",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "หนองหลวง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "พรสวรรค์",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "ขวัญเมือง",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เสลภูมิ",
    "sub-district": "บึงเกลือ",
    postcode: 45120,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "สระคู",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ดอกไม้",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "นาใหญ่",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "หินกอง",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "เมืองทุ่ง",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "หัวโทน",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "บ่อพันขัน",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ทุ่งหลวง",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "หัวช้าง",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "น้ำคำ",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ห้วยหินลาด",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ช้างเผือก",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ทุ่งกุลา",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "ทุ่งศรีเมือง",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "สุวรรณภูมิ",
    "sub-district": "จำปาขัน",
    postcode: 45130,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองสรวง",
    "sub-district": "หนองผือ",
    postcode: 45220,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองสรวง",
    "sub-district": "หนองหิน",
    postcode: 45220,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองสรวง",
    "sub-district": "คูเมือง",
    postcode: 45220,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองสรวง",
    "sub-district": "กกกุง",
    postcode: 45220,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมืองสรวง",
    "sub-district": "เมืองสรวง",
    postcode: 45220,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทราย",
    "sub-district": "โพนทราย",
    postcode: 45240,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทราย",
    "sub-district": "สามขา",
    postcode: 45240,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทราย",
    "sub-district": "ศรีสว่าง",
    postcode: 45240,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทราย",
    "sub-district": "ยางคำ",
    postcode: 45240,
  },
  {
    province: "ร้อยเอ็ด",
    district: "โพนทราย",
    "sub-district": "ท่าหาดยาว",
    postcode: 45240,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "อาจสามารถ",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "โพนเมือง",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "บ้านแจ้ง",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "หน่อม",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "หนองหมื่นถ่าน",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "หนองขาม",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "โหรา",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "หนองบัว",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "ขี้เหล็ก",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "อาจสามารถ",
    "sub-district": "บ้านดู่",
    postcode: 45160,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมยวดี",
    "sub-district": "เมยวดี",
    postcode: 45250,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมยวดี",
    "sub-district": "ชุมพร",
    postcode: 45250,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมยวดี",
    "sub-district": "บุ่งเลิศ",
    postcode: 45250,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เมยวดี",
    "sub-district": "ชมสะอาด",
    postcode: 45250,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "โพธิ์ทอง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "ศรีสมเด็จ",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "เมืองเปลือย",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "หนองใหญ่",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "สวนจิก",
    postcode: 45280,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "โพธิ์สัย",
    postcode: 45280,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "หนองแวงควง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ศรีสมเด็จ",
    "sub-district": "บ้านบาก",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ดินดำ",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ปาฝา",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ม่วงลาด",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "จังหาร",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ดงสิงห์",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ยางใหญ่",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "ผักแว่น",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "จังหาร",
    "sub-district": "แสนชาติ",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "เชียงขวัญ",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "พลับพลา",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "พระธาตุ",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "พระเจ้า",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "หมูม้น",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "เชียงขวัญ",
    "sub-district": "บ้านเขือง",
    postcode: 45000,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองฮี",
    "sub-district": "หนองฮี",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองฮี",
    "sub-district": "สาวแห",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองฮี",
    "sub-district": "ดูกอึ่ง",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "หนองฮี",
    "sub-district": "เด่นราษฎร์",
    postcode: 45140,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ทุ่งเขาหลวง",
    "sub-district": "ทุ่งเขาหลวง",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ทุ่งเขาหลวง",
    "sub-district": "เทอดไทย",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ทุ่งเขาหลวง",
    "sub-district": "บึงงาม",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ทุ่งเขาหลวง",
    "sub-district": "มะบ้า",
    postcode: 45170,
  },
  {
    province: "ร้อยเอ็ด",
    district: "ทุ่งเขาหลวง",
    "sub-district": "เหล่า",
    postcode: 45170,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "กาฬสินธุ์",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "เหนือ",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "หลุบ",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ไผ่",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ลำปาว",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ลำพาน",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "เชียงเครือ",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "บึงวิชัย",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ห้วยโพธิ์",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ภูปอ",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ภูดิน",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "หนองกุง",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "กลางหมื่น",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ขมิ้น",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "โพนทอง",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "นาจารย์",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "เมืองกาฬสินธุ์",
    "sub-district": "ลำคลอง",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "นามน",
    "sub-district": "นามน",
    postcode: 46230,
  },
  {
    province: "กาฬสินธุ์",
    district: "นามน",
    "sub-district": "ยอดแกง",
    postcode: 46230,
  },
  {
    province: "กาฬสินธุ์",
    district: "นามน",
    "sub-district": "สงเปลือย",
    postcode: 46230,
  },
  {
    province: "กาฬสินธุ์",
    district: "นามน",
    "sub-district": "หลักเหลี่ยม",
    postcode: 46230,
  },
  {
    province: "กาฬสินธุ์",
    district: "นามน",
    "sub-district": "หนองบัว",
    postcode: 46230,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "กมลาไสย",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "หลักเมือง",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "โพนงาม",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "ดงลิง",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "ธัญญา",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "หนองแปน",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "เจ้าท่า",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "กมลาไสย",
    "sub-district": "โคกสมบูรณ์",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "ร่องคำ",
    "sub-district": "ร่องคำ",
    postcode: 46210,
  },
  {
    province: "กาฬสินธุ์",
    district: "ร่องคำ",
    "sub-district": "สามัคคี",
    postcode: 46210,
  },
  {
    province: "กาฬสินธุ์",
    district: "ร่องคำ",
    "sub-district": "เหล่าอ้อย",
    postcode: 46210,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "บัวขาว",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "แจนแลน",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "เหล่าใหญ่",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "จุมจัง",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "เหล่าไฮงาม",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "กุดหว้า",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "สามขา",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "นาขาม",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "หนองห้าง",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "นาโก",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "สมสะอาด",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "กุฉินารายณ์",
    "sub-district": "กุดค้าว",
    postcode: 46110,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "คุ้มเก่า",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "สงเปลือย",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "หนองผือ",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "กุดสิมคุ้มใหม่",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "สระพังทอง",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "เขาวง",
    "sub-district": "กุดปลาค้าว",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "ยางตลาด",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "หัวงัว",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "อุ่มเม่า",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "บัวบาน",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "เว่อ",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "อิตื้อ",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "หัวนาคำ",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "หนองอิเฒ่า",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "ดอนสมบูรณ์",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "นาเชือก",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "คลองขาม",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "เขาพระนอน",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "นาดี",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "โนนสูง",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ยางตลาด",
    "sub-district": "หนองตอกแป้น",
    postcode: 46120,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "ห้วยเม็ก",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "คำใหญ่",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "กุดโดน",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "บึงนาเรียง",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "หัวหิน",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "พิมูล",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "คำเหมือดแก้ว",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "โนนสะอาด",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยเม็ก",
    "sub-district": "ทรายทอง",
    postcode: 46170,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "ภูสิงห์",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "สหัสขันธ์",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "นามะเขือ",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "โนนศิลา",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "นิคม",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "โนนแหลมทอง",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "โนนบุรี",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "สหัสขันธ์",
    "sub-district": "โนนน้ำเกลี้ยง",
    postcode: 46140,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "ทุ่งคลอง",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "โพน",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "ดินจี่",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "นาบอน",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "นาทัน",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "คำม่วง",
    "sub-district": "เนินยาง",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "ท่าคันโท",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "กุงเก่า",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "ยางอู้ม",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "กุดจิก",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "นาตาล",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "ท่าคันโท",
    "sub-district": "ดงสมบูรณ์",
    postcode: 46190,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "หนองกุงศรี",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "หนองบัว",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "โคกเครือ",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "หนองสรวง",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "เสาเล้า",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "หนองใหญ่",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "ดงมูล",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "ลำหนองแสน",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "หนองกุงศรี",
    "sub-district": "หนองหิน",
    postcode: 46220,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "สมเด็จ",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "หนองแวง",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "แซงบาดาล",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "มหาไชย",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "หมูม่น",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "ผาเสวย",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "ศรีสมเด็จ",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "สมเด็จ",
    "sub-district": "ลำห้วยหลัว",
    postcode: 46150,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยผึ้ง",
    "sub-district": "คำบง",
    postcode: 46240,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยผึ้ง",
    "sub-district": "ไค้นุ่น",
    postcode: 46240,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยผึ้ง",
    "sub-district": "นิคมห้วยผึ้ง",
    postcode: 46240,
  },
  {
    province: "กาฬสินธุ์",
    district: "ห้วยผึ้ง",
    "sub-district": "หนองอีบุตร",
    postcode: 46240,
  },
  {
    province: "กาฬสินธุ์",
    district: "สามชัย",
    "sub-district": "สำราญ",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "สามชัย",
    "sub-district": "สำราญใต้",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "สามชัย",
    "sub-district": "คำสร้างเที่ยง",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "สามชัย",
    "sub-district": "หนองช้าง",
    postcode: 46180,
  },
  {
    province: "กาฬสินธุ์",
    district: "นาคู",
    "sub-district": "นาคู",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "นาคู",
    "sub-district": "สายนาวัง",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "นาคู",
    "sub-district": "โนนนาจาน",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "นาคู",
    "sub-district": "บ่อแก้ว",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "นาคู",
    "sub-district": "ภูแล่นช้าง",
    postcode: 46160,
  },
  {
    province: "กาฬสินธุ์",
    district: "ดอนจาน",
    "sub-district": "ดอนจาน",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "ดอนจาน",
    "sub-district": "สะอาดไชยศรี",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "ดอนจาน",
    "sub-district": "ดงพยุง",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "ดอนจาน",
    "sub-district": "ม่วงนา",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "ดอนจาน",
    "sub-district": "นาจำปา",
    postcode: 46000,
  },
  {
    province: "กาฬสินธุ์",
    district: "ฆ้องชัย",
    "sub-district": "ฆ้องชัยพัฒนา",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "ฆ้องชัย",
    "sub-district": "เหล่ากลาง",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "ฆ้องชัย",
    "sub-district": "โคกสะอาด",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "ฆ้องชัย",
    "sub-district": "โนนศิลาเลิง",
    postcode: 46130,
  },
  {
    province: "กาฬสินธุ์",
    district: "ฆ้องชัย",
    "sub-district": "ลำชี",
    postcode: 46130,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ธาตุเชิงชุม",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ขมิ้น",
    postcode: 47220,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "งิ้วด่อน",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "โนนหอม",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "เชียงเครือ",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ท่าแร่",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ม่วงลาย",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ดงชน",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ห้วยยาง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "พังขว้าง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ดงมะไฟ",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ธาตุนาเวง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "เหล่าปอแดง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "หนองลาด",
    postcode: 47220,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "ฮางโฮง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "เมืองสกลนคร",
    "sub-district": "โคกก่อง",
    postcode: 47000,
  },
  {
    province: "สกลนคร",
    district: "กุสุมาลย์",
    "sub-district": "กุสุมาลย์",
    postcode: 47210,
  },
  {
    province: "สกลนคร",
    district: "กุสุมาลย์",
    "sub-district": "นาโพธิ์",
    postcode: 47210,
  },
  {
    province: "สกลนคร",
    district: "กุสุมาลย์",
    "sub-district": "นาเพียง",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "กุสุมาลย์",
    "sub-district": "โพธิไพศาล",
    postcode: 47210,
  },
  {
    province: "สกลนคร",
    district: "กุสุมาลย์",
    "sub-district": "อุ่มจาน",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "กุดบาก",
    "sub-district": "กุดบาก",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "กุดบาก",
    "sub-district": "นาม่อง",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "กุดบาก",
    "sub-district": "กุดไห",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "พรรณา",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "วังยาง",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "พอกน้อย",
    postcode: 47220,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "นาหัวบ่อ",
    postcode: 47220,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "ไร่",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "ช้างมิ่ง",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "นาใน",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "สว่าง",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "บะฮี",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พรรณานิคม",
    "sub-district": "เชิงชุม",
    postcode: 47130,
  },
  {
    province: "สกลนคร",
    district: "พังโคน",
    "sub-district": "พังโคน",
    postcode: 47160,
  },
  {
    province: "สกลนคร",
    district: "พังโคน",
    "sub-district": "ม่วงไข่",
    postcode: 47160,
  },
  {
    province: "สกลนคร",
    district: "พังโคน",
    "sub-district": "แร่",
    postcode: 47160,
  },
  {
    province: "สกลนคร",
    district: "พังโคน",
    "sub-district": "ไฮหย่อง",
    postcode: 47160,
  },
  {
    province: "สกลนคร",
    district: "พังโคน",
    "sub-district": "ต้นผึ้ง",
    postcode: 47160,
  },
  {
    province: "สกลนคร",
    district: "วาริชภูมิ",
    "sub-district": "วาริชภูมิ",
    postcode: 47150,
  },
  {
    province: "สกลนคร",
    district: "วาริชภูมิ",
    "sub-district": "ปลาโหล",
    postcode: 47150,
  },
  {
    province: "สกลนคร",
    district: "วาริชภูมิ",
    "sub-district": "หนองลาด",
    postcode: 47150,
  },
  {
    province: "สกลนคร",
    district: "วาริชภูมิ",
    "sub-district": "คำบ่อ",
    postcode: 47150,
  },
  {
    province: "สกลนคร",
    district: "วาริชภูมิ",
    "sub-district": "ค้อเขียว",
    postcode: 47150,
  },
  {
    province: "สกลนคร",
    district: "นิคมน้ำอูน",
    "sub-district": "นิคมน้ำอูน",
    postcode: 47270,
  },
  {
    province: "สกลนคร",
    district: "นิคมน้ำอูน",
    "sub-district": "หนองปลิง",
    postcode: 47270,
  },
  {
    province: "สกลนคร",
    district: "นิคมน้ำอูน",
    "sub-district": "หนองบัว",
    postcode: 47270,
  },
  {
    province: "สกลนคร",
    district: "นิคมน้ำอูน",
    "sub-district": "สุวรรณคาม",
    postcode: 47270,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "วานรนิวาส",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "เดื่อศรีคันไชย",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "ขัวก่าย",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "หนองสนม",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "คูสะคาม",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "ธาตุ",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "หนองแวง",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "ศรีวิชัย",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "นาซอ",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "อินทร์แปลง",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "นาคำ",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "คอนสวรรค์",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "กุดเรือคำ",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "วานรนิวาส",
    "sub-district": "หนองแวงใต้",
    postcode: 47120,
  },
  {
    province: "สกลนคร",
    district: "คำตากล้า",
    "sub-district": "คำตากล้า",
    postcode: 47250,
  },
  {
    province: "สกลนคร",
    district: "คำตากล้า",
    "sub-district": "หนองบัวสิม",
    postcode: 47250,
  },
  {
    province: "สกลนคร",
    district: "คำตากล้า",
    "sub-district": "นาแต้",
    postcode: 47250,
  },
  {
    province: "สกลนคร",
    district: "คำตากล้า",
    "sub-district": "แพด",
    postcode: 47250,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "ม่วง",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "มาย",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "ดงหม้อทอง",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "ดงเหนือ",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "ดงหม้อทองใต้",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "ห้วยหลัว",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "โนนสะอาด",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "หนองกวั่ง",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "บ้านม่วง",
    "sub-district": "บ่อแก้ว",
    postcode: 47140,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "อากาศ",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "โพนแพง",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "วาใหญ่",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "โพนงาม",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "ท่าก้อน",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "นาฮี",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "บะหว้า",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "อากาศอำนวย",
    "sub-district": "สามัคคีพัฒนา",
    postcode: 47170,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "สว่างแดนดิน",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "คำสะอาด",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "บ้านต้าย",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "บงเหนือ",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "โพนสูง",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "โคกสี",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "หนองหลวง",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "บงใต้",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "ค้อใต้",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "พันนา",
    postcode: 47240,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "แวง",
    postcode: 47240,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "ทรายมูล",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "ตาลโกน",
    postcode: 47240,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "ตาลเนิ้ง",
    postcode: 47240,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "ธาตุทอง",
    postcode: 47240,
  },
  {
    province: "สกลนคร",
    district: "สว่างแดนดิน",
    "sub-district": "บ้านถ่อน",
    postcode: 47110,
  },
  {
    province: "สกลนคร",
    district: "ส่องดาว",
    "sub-district": "ส่องดาว",
    postcode: 47190,
  },
  {
    province: "สกลนคร",
    district: "ส่องดาว",
    "sub-district": "ท่าศิลา",
    postcode: 47190,
  },
  {
    province: "สกลนคร",
    district: "ส่องดาว",
    "sub-district": "วัฒนา",
    postcode: 47190,
  },
  {
    province: "สกลนคร",
    district: "ส่องดาว",
    "sub-district": "ปทุมวาปี",
    postcode: 47190,
  },
  {
    province: "สกลนคร",
    district: "เต่างอย",
    "sub-district": "เต่างอย",
    postcode: 47260,
  },
  {
    province: "สกลนคร",
    district: "เต่างอย",
    "sub-district": "บึงทวาย",
    postcode: 47260,
  },
  {
    province: "สกลนคร",
    district: "เต่างอย",
    "sub-district": "นาตาล",
    postcode: 47260,
  },
  {
    province: "สกลนคร",
    district: "เต่างอย",
    "sub-district": "จันทร์เพ็ญ",
    postcode: 47260,
  },
  {
    province: "สกลนคร",
    district: "โคกศรีสุพรรณ",
    "sub-district": "ตองโขบ",
    postcode: 47280,
  },
  {
    province: "สกลนคร",
    district: "โคกศรีสุพรรณ",
    "sub-district": "เหล่าโพนค้อ",
    postcode: 47280,
  },
  {
    province: "สกลนคร",
    district: "โคกศรีสุพรรณ",
    "sub-district": "ด่านม่วงคำ",
    postcode: 47280,
  },
  {
    province: "สกลนคร",
    district: "โคกศรีสุพรรณ",
    "sub-district": "แมดนาท่ม",
    postcode: 47280,
  },
  {
    province: "สกลนคร",
    district: "เจริญศิลป์",
    "sub-district": "บ้านเหล่า",
    postcode: 47290,
  },
  {
    province: "สกลนคร",
    district: "เจริญศิลป์",
    "sub-district": "เจริญศิลป์",
    postcode: 47290,
  },
  {
    province: "สกลนคร",
    district: "เจริญศิลป์",
    "sub-district": "ทุ่งแก",
    postcode: 47290,
  },
  {
    province: "สกลนคร",
    district: "เจริญศิลป์",
    "sub-district": "โคกศิลา",
    postcode: 47290,
  },
  {
    province: "สกลนคร",
    district: "เจริญศิลป์",
    "sub-district": "หนองแปน",
    postcode: 47290,
  },
  {
    province: "สกลนคร",
    district: "โพนนาแก้ว",
    "sub-district": "บ้านโพน",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "โพนนาแก้ว",
    "sub-district": "นาแก้ว",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "โพนนาแก้ว",
    "sub-district": "นาตงวัฒนา",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "โพนนาแก้ว",
    "sub-district": "บ้านแป้น",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "โพนนาแก้ว",
    "sub-district": "เชียงสือ",
    postcode: 47230,
  },
  {
    province: "สกลนคร",
    district: "ภูพาน",
    "sub-district": "สร้างค้อ",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "ภูพาน",
    "sub-district": "หลุบเลา",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "ภูพาน",
    "sub-district": "โคกภู",
    postcode: 47180,
  },
  {
    province: "สกลนคร",
    district: "ภูพาน",
    "sub-district": "กกปลาซิว",
    postcode: 47180,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "ในเมือง",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "หนองแสง",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "นาทราย",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "นาราชควาย",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "กุรุคุ",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "บ้านผึ้ง",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "อาจสามารถ",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "ขามเฒ่า",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "บ้านกลาง",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "ท่าค้อ",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "คำเตย",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "หนองญาติ",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "ดงขวาง",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "วังตามัว",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "เมืองนครพนม",
    "sub-district": "โพธิ์ตาก",
    postcode: 48000,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "ปลาปาก",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "หนองฮี",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "กุตาไก้",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "โคกสว่าง",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "โคกสูง",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "มหาชัย",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "นามะเขือ",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ปลาปาก",
    "sub-district": "หนองเทาใหญ่",
    postcode: 48160,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "ท่าอุเทน",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "โนนตาล",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "ท่าจำปา",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "ไชยบุรี",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "พนอม",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "พะทาย",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "เวินพระบาท",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "รามราช",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "ท่าอุเทน",
    "sub-district": "หนองเทา",
    postcode: 48120,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "บ้านแพง",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "ไผ่ล้อม",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "โพนทอง",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "หนองแวง",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "นางัว",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "บ้านแพง",
    "sub-district": "นาเข",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "ธาตุพนม",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "ฝั่งแดง",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "โพนแพง",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "พระกลางทุ่ง",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "นาถ่อน",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "แสนพัน",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "ดอนนางหงส์",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "น้ำก่ำ",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "อุ่มเหม้า",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "นาหนาด",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "กุดฉิม",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "ธาตุพนม",
    "sub-district": "ธาตุพนมเหนือ",
    postcode: 48110,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "เรณู",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "โพนทอง",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "ท่าลาด",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "นางาม",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "โคกหินแฮ่",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "หนองย่างชิ้น",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "เรณูใต้",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "เรณูนคร",
    "sub-district": "นาขาม",
    postcode: 48170,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "นาแก",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "พระซอง",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "หนองสังข์",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "นาคู่",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "พิมาน",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "พุ่มแก",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "ก้านเหลือง",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "หนองบ่อ",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "นาเลียง",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "บ้านแก้ง",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "คำพี้",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "นาแก",
    "sub-district": "สีชมพู",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "ศรีสงคราม",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "นาเดื่อ",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "บ้านเอื้อง",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "สามผง",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "ท่าบ่อสงคราม",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "บ้านข่า",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "นาคำ",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "โพนสว่าง",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "ศรีสงคราม",
    "sub-district": "หาดแพง",
    postcode: 48150,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "นาหว้า",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "นางัว",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "บ้านเสียว",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "นาคูณใหญ่",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "เหล่าพัฒนา",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "นาหว้า",
    "sub-district": "ท่าเรือ",
    postcode: 48180,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "โพนสวรรค์",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "นาหัวบ่อ",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "นาขมิ้น",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "โพนบก",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "บ้านค้อ",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "โพนจาน",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "โพนสวรรค์",
    "sub-district": "นาใน",
    postcode: 48190,
  },
  {
    province: "นครพนม",
    district: "นาทม",
    "sub-district": "นาทม",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "นาทม",
    "sub-district": "หนองซน",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "นาทม",
    "sub-district": "ดอนเตย",
    postcode: 48140,
  },
  {
    province: "นครพนม",
    district: "วังยาง",
    "sub-district": "วังยาง",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "วังยาง",
    "sub-district": "โคกสี",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "วังยาง",
    "sub-district": "ยอดชาด",
    postcode: 48130,
  },
  {
    province: "นครพนม",
    district: "วังยาง",
    "sub-district": "หนองโพธิ์",
    postcode: 48130,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "มุกดาหาร",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "ศรีบุญเรือง",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "บ้านโคก",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "บางทรายใหญ่",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "โพนทราย",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "ผึ่งแดด",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "นาโสก",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "นาสีนวน",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "คำป่าหลาย",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "คำอาฮวน",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "ดงเย็น",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "ดงมอน",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "เมืองมุกดาหาร",
    "sub-district": "กุดแข้",
    postcode: 49000,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "นิคมคำสร้อย",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "นากอก",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "หนองแวง",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "กกแดง",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "นาอุดม",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "โชคชัย",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "นิคมคำสร้อย",
    "sub-district": "ร่มเกล้า",
    postcode: 49130,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "ดอนตาล",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "โพธิ์ไทร",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "ป่าไร่",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "เหล่าหมี",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "บ้านบาก",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "นาสะเม็ง",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดอนตาล",
    "sub-district": "บ้านแก้ง",
    postcode: 49120,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "ดงหลวง",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "หนองบัว",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "กกตูม",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "หนองแคน",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "ชะโนดน้อย",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "ดงหลวง",
    "sub-district": "พังแดง",
    postcode: 49140,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "บ้านซ่ง",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "คำชะอี",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "หนองเอี่ยน",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "บ้านค้อ",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "บ้านเหล่า",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "โพนงาม",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "เหล่าสร้างถ่อ",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "คำบก",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "คำชะอี",
    "sub-district": "น้ำเที่ยง",
    postcode: 49110,
  },
  {
    province: "มุกดาหาร",
    district: "หว้านใหญ่",
    "sub-district": "หว้านใหญ่",
    postcode: 49150,
  },
  {
    province: "มุกดาหาร",
    district: "หว้านใหญ่",
    "sub-district": "ป่งขาม",
    postcode: 49150,
  },
  {
    province: "มุกดาหาร",
    district: "หว้านใหญ่",
    "sub-district": "บางทรายน้อย",
    postcode: 49150,
  },
  {
    province: "มุกดาหาร",
    district: "หว้านใหญ่",
    "sub-district": "ชะโนด",
    postcode: 49150,
  },
  {
    province: "มุกดาหาร",
    district: "หว้านใหญ่",
    "sub-district": "ดงหมู",
    postcode: 49150,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "หนองสูง",
    postcode: 49160,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "โนนยาง",
    postcode: 49160,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "ภูวง",
    postcode: 49160,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "บ้านเป้า",
    postcode: 49160,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "หนองสูงใต้",
    postcode: 49160,
  },
  {
    province: "มุกดาหาร",
    district: "หนองสูง",
    "sub-district": "หนองสูงเหนือ",
    postcode: 49160,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ศรีภูมิ",
    postcode: 50200,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "พระสิงห์",
    postcode: 50200,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "หายยา",
    postcode: 50100,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ช้างม่อย",
    postcode: 50300,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ช้างคลาน",
    postcode: 50100,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "วัดเกต",
    postcode: 50000,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ช้างเผือก",
    postcode: 50300,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "สุเทพ",
    postcode: 50200,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "แม่เหียะ",
    postcode: 50100,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ป่าแดด",
    postcode: 50100,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "หนองหอย",
    postcode: 50000,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ท่าศาลา",
    postcode: 50000,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "หนองป่าครั่ง",
    postcode: 50000,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ฟ้าฮ่าม",
    postcode: 50000,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "ป่าตัน",
    postcode: 50300,
  },
  {
    province: "เชียงใหม่",
    district: "เมืองเชียงใหม่",
    "sub-district": "สันผีเสื้อ",
    postcode: 50300,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "บ้านหลวง",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "ข่วงเปา",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "สบเตี๊ยะ",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "บ้านแปะ",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "ดอยแก้ว",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "จอมทอง",
    "sub-district": "แม่สอย",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "ช่างเคิ่ง",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "ท่าผา",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "บ้านทับ",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "แม่ศึก",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "แม่นาจร",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "ปางหินฝน",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แจ่ม",
    "sub-district": "กองแขก",
    postcode: 50270,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "เชียงดาว",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "เมืองนะ",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "เมืองงาย",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "แม่นะ",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "เมืองคอง",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "ปิงโค้ง",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "เชียงดาว",
    "sub-district": "ทุ่งข้าวพวง",
    postcode: 50170,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "เชิงดอย",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "สันปูเลย",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ลวงเหนือ",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ป่าป้อง",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "สง่าบ้าน",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ป่าลาน",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ตลาดขวัญ",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "สำราญราษฎร์",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "แม่คือ",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ตลาดใหญ่",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "แม่ฮ้อยเงิน",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "แม่โป่ง",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "ป่าเมี่ยง",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยสะเก็ด",
    "sub-district": "เทพเสด็จ",
    postcode: 50220,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "สันมหาพน",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "แม่แตง",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "ขี้เหล็ก",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "ช่อแล",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "แม่หอพระ",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "สบเปิง",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "บ้านเป้า",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "สันป่ายาง",
    postcode: 50330,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "ป่าแป๋",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "เมืองก๋าย",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "บ้านช้าง",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "กื้ดช้าง",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "อินทขิล",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่แตง",
    "sub-district": "สมก๋าย",
    postcode: 50150,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "ริมใต้",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "ริมเหนือ",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "สันโป่ง",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "ขี้เหล็ก",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "สะลวง",
    postcode: 50330,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "ห้วยทราย",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "แม่แรม",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "โป่งแยง",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "แม่สา",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "ดอนแก้ว",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ริม",
    "sub-district": "เหมืองแก้ว",
    postcode: 50180,
  },
  {
    province: "เชียงใหม่",
    district: "สะเมิง",
    "sub-district": "สะเมิงใต้",
    postcode: 50250,
  },
  {
    province: "เชียงใหม่",
    district: "สะเมิง",
    "sub-district": "สะเมิงเหนือ",
    postcode: 50250,
  },
  {
    province: "เชียงใหม่",
    district: "สะเมิง",
    "sub-district": "แม่สาบ",
    postcode: 50250,
  },
  {
    province: "เชียงใหม่",
    district: "สะเมิง",
    "sub-district": "บ่อแก้ว",
    postcode: 50250,
  },
  {
    province: "เชียงใหม่",
    district: "สะเมิง",
    "sub-district": "ยั้งเมิน",
    postcode: 50250,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "เวียง",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "ม่อนปิ่น",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "แม่งอน",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "แม่สูน",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "สันทราย",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "แม่คะ",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "แม่ข่า",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "ฝาง",
    "sub-district": "โป่งน้ำร้อน",
    postcode: 50110,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "แม่อาย",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "แม่สาว",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "สันต้นหมื้อ",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "แม่นาวาง",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "ท่าตอน",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "บ้านหลวง",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "แม่อาย",
    "sub-district": "มะลิกา",
    postcode: 50280,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "เวียง",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "ทุ่งหลวง",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "ป่าตุ้ม",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "ป่าไหน่",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "สันทราย",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "บ้านโป่ง",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "น้ำแพร่",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "เขื่อนผาก",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "แม่แวน",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "แม่ปั๋ง",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "พร้าว",
    "sub-district": "โหล่งขอด",
    postcode: 50190,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "ยุหว่า",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "สันกลาง",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "ท่าวังพร้าว",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "มะขามหลวง",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "แม่ก๊า",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "บ้านแม",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "บ้านกลาง",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "ทุ่งสะโตก",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "ทุ่งต้อม",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "น้ำบ่อหลวง",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันป่าตอง",
    "sub-district": "มะขุนหวาน",
    postcode: 50120,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "สันกำแพง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "ทรายมูล",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "ร้องวัวแดง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "บวกค้าง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "แช่ช้าง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "ออนใต้",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "แม่ปูคา",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "ห้วยทราย",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "ต้นเปา",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันกำแพง",
    "sub-district": "สันกลาง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "สันทรายหลวง",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "สันทรายน้อย",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "สันพระเนตร",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "สันนาเม็ง",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "สันป่าเปา",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "หนองแหย่ง",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "หนองจ๊อม",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "หนองหาร",
    postcode: 50290,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "แม่แฝก",
    postcode: 50290,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "แม่แฝกใหม่",
    postcode: 50290,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "เมืองเล็น",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "สันทราย",
    "sub-district": "ป่าไผ่",
    postcode: 50210,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "หางดง",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "หนองแก๋ว",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "หารแก้ว",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "หนองตอง",
    postcode: 50340,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "ขุนคง",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "สบแม่ข่า",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "บ้านแหวน",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "สันผักหวาน",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "หนองควาย",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "บ้านปง",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "หางดง",
    "sub-district": "น้ำแพร่",
    postcode: 50230,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "หางดง",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "ฮอด",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "บ้านตาล",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "บ่อหลวง",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "บ่อสลี",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ฮอด",
    "sub-district": "นาคอเรือ",
    postcode: 50240,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "ดอยเต่า",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "ท่าเดื่อ",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "มืดกา",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "บ้านแอ่น",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "บงตัน",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยเต่า",
    "sub-district": "โปงทุ่ง",
    postcode: 50260,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "อมก๋อย",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "ยางเปียง",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "แม่ตื่น",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "ม่อนจอง",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "สบโขง",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "อมก๋อย",
    "sub-district": "นาเกียน",
    postcode: 50310,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ยางเนิ้ง",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "สารภี",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ชมภู",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ไชยสถาน",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ขัวมุง",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "หนองแฝก",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "หนองผึ้ง",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ท่ากว้าง",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ดอนแก้ว",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ท่าวังตาล",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "สันทราย",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "สารภี",
    "sub-district": "ป่าบง",
    postcode: 50140,
  },
  {
    province: "เชียงใหม่",
    district: "เวียงแหง",
    "sub-district": "เมืองแหง",
    postcode: 50350,
  },
  {
    province: "เชียงใหม่",
    district: "เวียงแหง",
    "sub-district": "เปียงหลวง",
    postcode: 50350,
  },
  {
    province: "เชียงใหม่",
    district: "เวียงแหง",
    "sub-district": "แสนไห",
    postcode: 50350,
  },
  {
    province: "เชียงใหม่",
    district: "ไชยปราการ",
    "sub-district": "ปงตำ",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "ไชยปราการ",
    "sub-district": "ศรีดงเย็น",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "ไชยปราการ",
    "sub-district": "แม่ทะลบ",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "ไชยปราการ",
    "sub-district": "หนองบัว",
    postcode: 50320,
  },
  {
    province: "เชียงใหม่",
    district: "แม่วาง",
    "sub-district": "บ้านกาด",
    postcode: 50360,
  },
  {
    province: "เชียงใหม่",
    district: "แม่วาง",
    "sub-district": "ทุ่งปี๊",
    postcode: 50360,
  },
  {
    province: "เชียงใหม่",
    district: "แม่วาง",
    "sub-district": "ทุ่งรวงทอง",
    postcode: 50360,
  },
  {
    province: "เชียงใหม่",
    district: "แม่วาง",
    "sub-district": "แม่วิน",
    postcode: 50360,
  },
  {
    province: "เชียงใหม่",
    district: "แม่วาง",
    "sub-district": "ดอนเปา",
    postcode: 50360,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "ออนเหนือ",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "ออนกลาง",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "บ้านสหกรณ์",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "ห้วยแก้ว",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "แม่ทา",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "แม่ออน",
    "sub-district": "ทาเหนือ",
    postcode: 50130,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยหล่อ",
    "sub-district": "ดอยหล่อ",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยหล่อ",
    "sub-district": "สองแคว",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยหล่อ",
    "sub-district": "ยางคราม",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "ดอยหล่อ",
    "sub-district": "สันติสุข",
    postcode: 50160,
  },
  {
    province: "เชียงใหม่",
    district: "กัลยาณิวัฒนา",
    "sub-district": "บ้านจันทร์",
    postcode: 58130,
  },
  {
    province: "เชียงใหม่",
    district: "กัลยาณิวัฒนา",
    "sub-district": "แม่แดด",
    postcode: 58130,
  },
  {
    province: "เชียงใหม่",
    district: "กัลยาณิวัฒนา",
    "sub-district": "แจ่มหลวง",
    postcode: 58130,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ในเมือง",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "เหมืองง่า",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "อุโมงค์",
    postcode: 51150,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "หนองช้างคืน",
    postcode: 51150,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ประตูป่า",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ริมปิง",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ต้นธง",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "บ้านแป้น",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "เหมืองจี้",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ป่าสัก",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "เวียงยอง",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "บ้านกลาง",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "มะเขือแจ้",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "ศรีบัวบาน",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "เมืองลำพูน",
    "sub-district": "หนองหนาม",
    postcode: 51000,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทาปลาดุก",
    postcode: 51140,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทาสบเส้า",
    postcode: 51140,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทากาศ",
    postcode: 51170,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทาขุมเงิน",
    postcode: 51170,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทาทุ่งหลวง",
    postcode: 51170,
  },
  {
    province: "ลำพูน",
    district: "แม่ทา",
    "sub-district": "ทาแม่ลอบ",
    postcode: 51170,
  },
  {
    province: "ลำพูน",
    district: "บ้านโฮ่ง",
    "sub-district": "บ้านโฮ่ง",
    postcode: 51130,
  },
  {
    province: "ลำพูน",
    district: "บ้านโฮ่ง",
    "sub-district": "ป่าพลู",
    postcode: 51130,
  },
  {
    province: "ลำพูน",
    district: "บ้านโฮ่ง",
    "sub-district": "เหล่ายาว",
    postcode: 51130,
  },
  {
    province: "ลำพูน",
    district: "บ้านโฮ่ง",
    "sub-district": "ศรีเตี้ย",
    postcode: 51130,
  },
  {
    province: "ลำพูน",
    district: "บ้านโฮ่ง",
    "sub-district": "หนองปลาสะวาย",
    postcode: 51130,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "ลี้",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "แม่ตืน",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "นาทราย",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "ดงดำ",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "ก้อ",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "แม่ลาน",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "ป่าไผ่",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ลี้",
    "sub-district": "ศรีวิชัย",
    postcode: 51110,
  },
  {
    province: "ลำพูน",
    district: "ทุ่งหัวช้าง",
    "sub-district": "ทุ่งหัวช้าง",
    postcode: 51160,
  },
  {
    province: "ลำพูน",
    district: "ทุ่งหัวช้าง",
    "sub-district": "บ้านปวง",
    postcode: 51160,
  },
  {
    province: "ลำพูน",
    district: "ทุ่งหัวช้าง",
    "sub-district": "ตะเคียนปม",
    postcode: 51160,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "ปากบ่อง",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "ป่าซาง",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "แม่แรง",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "ม่วงน้อย",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "บ้านเรือน",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "มะกอก",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "ท่าตุ้ม",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "น้ำดิบ",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "ป่าซาง",
    "sub-district": "นครเจดีย์",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "บ้านธิ",
    "sub-district": "บ้านธิ",
    postcode: 51180,
  },
  {
    province: "ลำพูน",
    district: "บ้านธิ",
    "sub-district": "ห้วยยาบ",
    postcode: 51180,
  },
  {
    province: "ลำพูน",
    district: "เวียงหนองล่อง",
    "sub-district": "หนองล่อง",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "เวียงหนองล่อง",
    "sub-district": "หนองยวง",
    postcode: 51120,
  },
  {
    province: "ลำพูน",
    district: "เวียงหนองล่อง",
    "sub-district": "วังผาง",
    postcode: 51120,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "เวียงเหนือ",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "หัวเวียง",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "สวนดอก",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "สบตุ๋ย",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "พระบาท",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "ชมพู",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "กล้วยแพะ",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "ปงแสนทอง",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ้านแลง",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ้านเสด็จ",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "พิชัย",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "ทุ่งฝาย",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ้านเอื้อม",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ้านเป้า",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ้านค่า",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บ่อแฮ้ว",
    postcode: 52100,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "ต้นธงชัย",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "นิคมพัฒนา",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "เมืองลำปาง",
    "sub-district": "บุญนาคพัฒนา",
    postcode: 52000,
  },
  {
    province: "ลำปาง",
    district: "แม่เมาะ",
    "sub-district": "บ้านดง",
    postcode: 52220,
  },
  {
    province: "ลำปาง",
    district: "แม่เมาะ",
    "sub-district": "นาสัก",
    postcode: 52220,
  },
  {
    province: "ลำปาง",
    district: "แม่เมาะ",
    "sub-district": "จางเหนือ",
    postcode: 52220,
  },
  {
    province: "ลำปาง",
    district: "แม่เมาะ",
    "sub-district": "แม่เมาะ",
    postcode: 52220,
  },
  {
    province: "ลำปาง",
    district: "แม่เมาะ",
    "sub-district": "สบป้าด",
    postcode: 52220,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "ลำปางหลวง",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "นาแก้ว",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "ไหล่หิน",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "วังพร้าว",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "ศาลา",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "เกาะคา",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "นาแส่ง",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "ท่าผา",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เกาะคา",
    "sub-district": "ใหม่พัฒนา",
    postcode: 52130,
  },
  {
    province: "ลำปาง",
    district: "เสริมงาม",
    "sub-district": "ทุ่งงาม",
    postcode: 52210,
  },
  {
    province: "ลำปาง",
    district: "เสริมงาม",
    "sub-district": "เสริมขวา",
    postcode: 52210,
  },
  {
    province: "ลำปาง",
    district: "เสริมงาม",
    "sub-district": "เสริมซ้าย",
    postcode: 52210,
  },
  {
    province: "ลำปาง",
    district: "เสริมงาม",
    "sub-district": "เสริมกลาง",
    postcode: 52210,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "หลวงเหนือ",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "หลวงใต้",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "บ้านโป่ง",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "บ้านร้อง",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "ปงเตา",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "นาแก",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "บ้านอ้อน",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "บ้านแหง",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "บ้านหวด",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "งาว",
    "sub-district": "แม่ตีบ",
    postcode: 52110,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "แจ้ห่ม",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "บ้านสา",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "ปงดอน",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "แม่สุก",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "เมืองมาย",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "ทุ่งผึ้ง",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "แจ้ห่ม",
    "sub-district": "วิเชตนคร",
    postcode: 52120,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "ทุ่งฮั้ว",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังเหนือ",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังใต้",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "ร่องเคาะ",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังทอง",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังซ้าย",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังแก้ว",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "วังเหนือ",
    "sub-district": "วังทรายคำ",
    postcode: 52140,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "ล้อมแรด",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "แม่วะ",
    postcode: 52230,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "แม่ปะ",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "แม่มอก",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "เวียงมอก",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "นาโป่ง",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "แม่ถอด",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "เถิน",
    "sub-district": "เถินบุรี",
    postcode: 52160,
  },
  {
    province: "ลำปาง",
    district: "แม่พริก",
    "sub-district": "แม่พริก",
    postcode: 52180,
  },
  {
    province: "ลำปาง",
    district: "แม่พริก",
    "sub-district": "ผาปัง",
    postcode: 52180,
  },
  {
    province: "ลำปาง",
    district: "แม่พริก",
    "sub-district": "แม่ปุ",
    postcode: 52180,
  },
  {
    province: "ลำปาง",
    district: "แม่พริก",
    "sub-district": "พระบาทวังตวง",
    postcode: 52180,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "แม่ทะ",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "นาครัว",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "ป่าตัน",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "บ้านกิ่ว",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "บ้านบอม",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "น้ำโจ้",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "ดอนไฟ",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "หัวเสือ",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "วังเงิน",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "แม่ทะ",
    "sub-district": "สันดอนแก้ว",
    postcode: 52150,
  },
  {
    province: "ลำปาง",
    district: "สบปราบ",
    "sub-district": "สบปราบ",
    postcode: 52170,
  },
  {
    province: "ลำปาง",
    district: "สบปราบ",
    "sub-district": "สมัย",
    postcode: 52170,
  },
  {
    province: "ลำปาง",
    district: "สบปราบ",
    "sub-district": "แม่กัวะ",
    postcode: 52170,
  },
  {
    province: "ลำปาง",
    district: "สบปราบ",
    "sub-district": "นายาง",
    postcode: 52170,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "ห้างฉัตร",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "หนองหล่ม",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "เมืองยาว",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "ปงยางคก",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "เวียงตาล",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "แม่สัน",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "ห้างฉัตร",
    "sub-district": "วอแก้ว",
    postcode: 52190,
  },
  {
    province: "ลำปาง",
    district: "เมืองปาน",
    "sub-district": "เมืองปาน",
    postcode: 52240,
  },
  {
    province: "ลำปาง",
    district: "เมืองปาน",
    "sub-district": "บ้านขอ",
    postcode: 52240,
  },
  {
    province: "ลำปาง",
    district: "เมืองปาน",
    "sub-district": "ทุ่งกว๋าว",
    postcode: 52240,
  },
  {
    province: "ลำปาง",
    district: "เมืองปาน",
    "sub-district": "แจ้ซ้อน",
    postcode: 52240,
  },
  {
    province: "ลำปาง",
    district: "เมืองปาน",
    "sub-district": "หัวเมือง",
    postcode: 52240,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ท่าอิฐ",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ท่าเสา",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "บ้านเกาะ",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ป่าเซ่า",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "คุ้งตะเภา",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "วังกะพี้",
    postcode: 53170,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "หาดกรวด",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "น้ำริด",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "งิ้วงาม",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "บ้านด่านนาขาม",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "บ้านด่าน",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ผาจุก",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "วังดิน",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "แสนตอ",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "หาดงิ้ว",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ขุนฝาง",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "เมืองอุตรดิตถ์",
    "sub-district": "ถ้ำฉลอง",
    postcode: 53000,
  },
  {
    province: "อุตรดิตถ์",
    district: "ตรอน",
    "sub-district": "วังแดง",
    postcode: 53140,
  },
  {
    province: "อุตรดิตถ์",
    district: "ตรอน",
    "sub-district": "บ้านแก่ง",
    postcode: 53140,
  },
  {
    province: "อุตรดิตถ์",
    district: "ตรอน",
    "sub-district": "หาดสองแคว",
    postcode: 53140,
  },
  {
    province: "อุตรดิตถ์",
    district: "ตรอน",
    "sub-district": "น้ำอ่าง",
    postcode: 53140,
  },
  {
    province: "อุตรดิตถ์",
    district: "ตรอน",
    "sub-district": "ข่อยสูง",
    postcode: 53140,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "ท่าปลา",
    postcode: 53150,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "หาดล้า",
    postcode: 53150,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "ผาเลือด",
    postcode: 53190,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "จริม",
    postcode: 53150,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "น้ำหมัน",
    postcode: 53150,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "ท่าแฝก",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "นางพญา",
    postcode: 53150,
  },
  {
    province: "อุตรดิตถ์",
    district: "ท่าปลา",
    "sub-district": "ร่วมจิต",
    postcode: 53190,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "แสนตอ",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "บ้านฝาย",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "เด่นเหล็ก",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "น้ำไคร้",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "น้ำไผ่",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "น้ำปาด",
    "sub-district": "ห้วยมุ่น",
    postcode: 53110,
  },
  {
    province: "อุตรดิตถ์",
    district: "ฟากท่า",
    "sub-district": "ฟากท่า",
    postcode: 53160,
  },
  {
    province: "อุตรดิตถ์",
    district: "ฟากท่า",
    "sub-district": "สองคอน",
    postcode: 53160,
  },
  {
    province: "อุตรดิตถ์",
    district: "ฟากท่า",
    "sub-district": "บ้านเสี้ยว",
    postcode: 53160,
  },
  {
    province: "อุตรดิตถ์",
    district: "ฟากท่า",
    "sub-district": "สองห้อง",
    postcode: 53160,
  },
  {
    province: "อุตรดิตถ์",
    district: "บ้านโคก",
    "sub-district": "ม่วงเจ็ดต้น",
    postcode: 53180,
  },
  {
    province: "อุตรดิตถ์",
    district: "บ้านโคก",
    "sub-district": "บ้านโคก",
    postcode: 53180,
  },
  {
    province: "อุตรดิตถ์",
    district: "บ้านโคก",
    "sub-district": "นาขุม",
    postcode: 53180,
  },
  {
    province: "อุตรดิตถ์",
    district: "บ้านโคก",
    "sub-district": "บ่อเบี้ย",
    postcode: 53180,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "ในเมือง",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "บ้านดารา",
    postcode: 53220,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "ไร่อ้อย",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "ท่าสัก",
    postcode: 53220,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "คอรุม",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "บ้านหม้อ",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "ท่ามะเฟือง",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "บ้านโคน",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "พญาแมน",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "นาอิน",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "พิชัย",
    "sub-district": "นายาง",
    postcode: 53120,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ศรีพนมมาศ",
    postcode: 53130,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "แม่พูล",
    postcode: 53130,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "นานกกก",
    postcode: 53130,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ฝายหลวง",
    postcode: 53130,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ชัยจุมพล",
    postcode: 53130,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ไผ่ล้อม",
    postcode: 53210,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ทุ่งยั้ง",
    postcode: 53210,
  },
  {
    province: "อุตรดิตถ์",
    district: "ลับแล",
    "sub-district": "ด่านแม่คำมัน",
    postcode: 53210,
  },
  {
    province: "อุตรดิตถ์",
    district: "ทองแสนขัน",
    "sub-district": "ผักขวง",
    postcode: 53230,
  },
  {
    province: "อุตรดิตถ์",
    district: "ทองแสนขัน",
    "sub-district": "บ่อทอง",
    postcode: 53230,
  },
  {
    province: "อุตรดิตถ์",
    district: "ทองแสนขัน",
    "sub-district": "ป่าคาย",
    postcode: 53230,
  },
  {
    province: "อุตรดิตถ์",
    district: "ทองแสนขัน",
    "sub-district": "น้ำพี้",
    postcode: 53230,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ในเวียง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "นาจักร",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "น้ำชำ",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ป่าแดง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ทุ่งโฮ้ง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "เหมืองหม้อ",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "วังธง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "แม่หล่าย",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ห้วยม้า",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ป่าแมต",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "บ้านถิ่น",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "สวนเขื่อน",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "วังหงส์",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "แม่คำมี",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ทุ่งกวาว",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ท่าข้าม",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "แม่ยม",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ช่อแฮ",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "ร่องฟอง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "เมืองแพร่",
    "sub-district": "กาญจนา",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "ร้องกวาง",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "ร้องเข็ม",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "น้ำเลา",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "บ้านเวียง",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "ทุ่งศรี",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "แม่ยางตาล",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "แม่ยางฮ่อ",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "ไผ่โทน",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "ห้วยโรง",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "แม่ทราย",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ร้องกวาง",
    "sub-district": "แม่ยางร้อง",
    postcode: 54140,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "ห้วยอ้อ",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "บ้านปิน",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "ต้าผามอก",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "เวียงต้า",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "ปากกาง",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "หัวทุ่ง",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "ทุ่งแล้ง",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "บ่อเหล็กลอง",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "ลอง",
    "sub-district": "แม่ปาน",
    postcode: 54150,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "สูงเม่น",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "น้ำชำ",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "หัวฝาย",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "ดอนมูล",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "บ้านเหล่า",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "บ้านกวาง",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "บ้านปง",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "บ้านกาศ",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "ร่องกาศ",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "สบสาย",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "เวียงทอง",
    postcode: 54000,
  },
  {
    province: "แพร่",
    district: "สูงเม่น",
    "sub-district": "พระหลวง",
    postcode: 54130,
  },
  {
    province: "แพร่",
    district: "เด่นชัย",
    "sub-district": "เด่นชัย",
    postcode: 54110,
  },
  {
    province: "แพร่",
    district: "เด่นชัย",
    "sub-district": "แม่จั๊วะ",
    postcode: 54110,
  },
  {
    province: "แพร่",
    district: "เด่นชัย",
    "sub-district": "ไทรย้อย",
    postcode: 54110,
  },
  {
    province: "แพร่",
    district: "เด่นชัย",
    "sub-district": "ห้วยไร่",
    postcode: 54110,
  },
  {
    province: "แพร่",
    district: "เด่นชัย",
    "sub-district": "ปงป่าหวาย",
    postcode: 54110,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "บ้านหนุน",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "บ้านกลาง",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "ห้วยหม้าย",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "เตาปูน",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "หัวเมือง",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "สะเอียบ",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "แดนชุมพล",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "สอง",
    "sub-district": "ทุ่งน้าว",
    postcode: 54120,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "วังชิ้น",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "สรอย",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "แม่ป้าก",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "นาพูน",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "แม่พุง",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "ป่าสัก",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "วังชิ้น",
    "sub-district": "แม่เกิ๋ง",
    postcode: 54160,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "แม่คำมี",
    postcode: 54170,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "หนองม่วงไข่",
    postcode: 54170,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "น้ำรัด",
    postcode: 54170,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "วังหลวง",
    postcode: 54170,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "ตำหนักธรรม",
    postcode: 54170,
  },
  {
    province: "แพร่",
    district: "หนองม่วงไข่",
    "sub-district": "ทุ่งแค้ว",
    postcode: 54170,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "ในเวียง",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "บ่อ",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "ผาสิงห์",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "ไชยสถาน",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "ถืมตอง",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "เรือง",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "นาซาว",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "ดู่ใต้",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "กองควาย",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "บ่อสวก",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เมืองน่าน",
    "sub-district": "สะเนียน",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "แม่จริม",
    "sub-district": "หนองแดง",
    postcode: 55170,
  },
  {
    province: "น่าน",
    district: "แม่จริม",
    "sub-district": "หมอเมือง",
    postcode: 55170,
  },
  {
    province: "น่าน",
    district: "แม่จริม",
    "sub-district": "น้ำพาง",
    postcode: 55170,
  },
  {
    province: "น่าน",
    district: "แม่จริม",
    "sub-district": "น้ำปาย",
    postcode: 55170,
  },
  {
    province: "น่าน",
    district: "แม่จริม",
    "sub-district": "แม่จริม",
    postcode: 55170,
  },
  {
    province: "น่าน",
    district: "บ้านหลวง",
    "sub-district": "บ้านฟ้า",
    postcode: 55190,
  },
  {
    province: "น่าน",
    district: "บ้านหลวง",
    "sub-district": "ป่าคาหลวง",
    postcode: 55190,
  },
  {
    province: "น่าน",
    district: "บ้านหลวง",
    "sub-district": "สวด",
    postcode: 55190,
  },
  {
    province: "น่าน",
    district: "บ้านหลวง",
    "sub-district": "บ้านพี้",
    postcode: 55190,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "นาน้อย",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "เชียงของ",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "ศรีษะเกษ",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "สถาน",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "สันทะ",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "บัวใหญ่",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "นาน้อย",
    "sub-district": "น้ำตก",
    postcode: 55150,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ปัว",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "แงง",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "สถาน",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ศิลาแลง",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ศิลาเพชร",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "อวน",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ไชยวัฒนา",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "เจดีย์ชัย",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ภูคา",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "สกาด",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "ป่ากลาง",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ปัว",
    "sub-district": "วรนคร",
    postcode: 55120,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ริม",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ป่าคา",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ผาตอ",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ยม",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ตาลชุม",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ศรีภูมิ",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "จอมพระ",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "แสนทอง",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ท่าวังผา",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "ท่าวังผา",
    "sub-district": "ผาทอง",
    postcode: 55140,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "กลางเวียง",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ขึ่ง",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ไหล่น่าน",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ตาลชุม",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "นาเหลือง",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ส้าน",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "น้ำมวบ",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "น้ำปั้ว",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ยาบหัวนา",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ปงสนุก",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "อ่ายนาไลย",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ส้านนาหนองใหม่",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "แม่ขะนิง",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "แม่สาคร",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "จอมจันทร์",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "แม่สา",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "เวียงสา",
    "sub-district": "ทุ่งศรีทอง",
    postcode: 55110,
  },
  {
    province: "น่าน",
    district: "ทุ่งช้าง",
    "sub-district": "ปอน",
    postcode: 55130,
  },
  {
    province: "น่าน",
    district: "ทุ่งช้าง",
    "sub-district": "งอบ",
    postcode: 55130,
  },
  {
    province: "น่าน",
    district: "ทุ่งช้าง",
    "sub-district": "และ",
    postcode: 55130,
  },
  {
    province: "น่าน",
    district: "ทุ่งช้าง",
    "sub-district": "ทุ่งช้าง",
    postcode: 55130,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "เชียงกลาง",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "เปือ",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "เชียงคาน",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "พระธาตุ",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "พญาแก้ว",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "เชียงกลาง",
    "sub-district": "พระพุทธบาท",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "นาหมื่น",
    "sub-district": "นาทะนุง",
    postcode: 55180,
  },
  {
    province: "น่าน",
    district: "นาหมื่น",
    "sub-district": "บ่อแก้ว",
    postcode: 55180,
  },
  {
    province: "น่าน",
    district: "นาหมื่น",
    "sub-district": "เมืองลี",
    postcode: 55180,
  },
  {
    province: "น่าน",
    district: "นาหมื่น",
    "sub-district": "ปิงหลวง",
    postcode: 55180,
  },
  {
    province: "น่าน",
    district: "สันติสุข",
    "sub-district": "ดู่พงษ์",
    postcode: 55210,
  },
  {
    province: "น่าน",
    district: "สันติสุข",
    "sub-district": "ป่าแลวหลวง",
    postcode: 55210,
  },
  {
    province: "น่าน",
    district: "สันติสุข",
    "sub-district": "พงษ์",
    postcode: 55210,
  },
  {
    province: "น่าน",
    district: "บ่อเกลือ",
    "sub-district": "บ่อเกลือเหนือ",
    postcode: 55220,
  },
  {
    province: "น่าน",
    district: "บ่อเกลือ",
    "sub-district": "บ่อเกลือใต้",
    postcode: 55220,
  },
  {
    province: "น่าน",
    district: "บ่อเกลือ",
    "sub-district": "ภูฟ้า",
    postcode: 55220,
  },
  {
    province: "น่าน",
    district: "บ่อเกลือ",
    "sub-district": "ดงพญา",
    postcode: 55220,
  },
  {
    province: "น่าน",
    district: "สองแคว",
    "sub-district": "นาไร่หลวง",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "สองแคว",
    "sub-district": "ชนแดน",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "สองแคว",
    "sub-district": "ยอด",
    postcode: 55160,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "ม่วงตึ๊ด",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "นาปัง",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "น้ำแก่น",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "น้ำเกี๋ยน",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "เมืองจัง",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "ท่าน้าว",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "ภูเพียง",
    "sub-district": "ฝายแก้ว",
    postcode: 55000,
  },
  {
    province: "น่าน",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ห้วยโก๋น",
    postcode: 55130,
  },
  {
    province: "น่าน",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ขุนน่าน",
    postcode: 55130,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "เวียง",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "แม่ต๋ำ",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "แม่นาเรือ",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "บ้านตุ่น",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "บ้านต๊ำ",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "บ้านต๋อม",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "แม่ปืม",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "แม่กา",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "บ้านใหม่",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "จำป่าหวาย",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "ท่าวังทอง",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "แม่ใส",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "บ้านสาง",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "ท่าจำปี",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "เมืองพะเยา",
    "sub-district": "สันป่าม่วง",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "ห้วยข้าวก่ำ",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "จุน",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "ลอ",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "หงส์หิน",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "ทุ่งรวงทอง",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "ห้วยยางขาม",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "จุน",
    "sub-district": "พระธาตุขิงแกง",
    postcode: 56150,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "หย่วน",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "น้ำแวน",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "เวียง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "ฝายกวาง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "เจดีย์คำ",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "ร่มเย็น",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "เชียงบาน",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "แม่ลาว",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "อ่างทอง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงคำ",
    "sub-district": "ทุ่งผาสุข",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "เชียงม่วน",
    "sub-district": "เชียงม่วน",
    postcode: 56160,
  },
  {
    province: "พะเยา",
    district: "เชียงม่วน",
    "sub-district": "บ้านมาง",
    postcode: 56160,
  },
  {
    province: "พะเยา",
    district: "เชียงม่วน",
    "sub-district": "สระ",
    postcode: 56160,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "ดอกคำใต้",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "ดอนศรีชุม",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "บ้านถ้ำ",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "บ้านปิน",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "ห้วยลาน",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "สันโค้ง",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "ป่าซาง",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "หนองหล่ม",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "ดงสุวรรณ",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "บุญเกิด",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "สว่างอารมณ์",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ดอกคำใต้",
    "sub-district": "คือเวียง",
    postcode: 56120,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "ปง",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "ควร",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "ออย",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "งิม",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "ผาช้างน้อย",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "นาปรัง",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "ปง",
    "sub-district": "ขุนควร",
    postcode: 56140,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "แม่ใจ",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "ศรีถ้อย",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "แม่สุก",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "ป่าแฝก",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "บ้านเหล่า",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "แม่ใจ",
    "sub-district": "เจริญราษฎร์",
    postcode: 56130,
  },
  {
    province: "พะเยา",
    district: "ภูซาง",
    "sub-district": "ภูซาง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "ภูซาง",
    "sub-district": "ป่าสัก",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "ภูซาง",
    "sub-district": "ทุ่งกล้วย",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "ภูซาง",
    "sub-district": "เชียงแรง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "ภูซาง",
    "sub-district": "สบบง",
    postcode: 56110,
  },
  {
    province: "พะเยา",
    district: "ภูกามยาว",
    "sub-district": "ห้วยแก้ว",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "ภูกามยาว",
    "sub-district": "ดงเจน",
    postcode: 56000,
  },
  {
    province: "พะเยา",
    district: "ภูกามยาว",
    "sub-district": "แม่อิง",
    postcode: 56000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "เวียง",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "รอบเวียง",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "บ้านดู่",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "นางแล",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "แม่ข้าวต้ม",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "แม่ยาว",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "สันทราย",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "แม่กรณ์",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ห้วยชมภู",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ห้วยสัก",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ริมกก",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ดอยลาน",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ป่าอ้อดอนชัย",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ท่าสาย",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ดอยฮาง",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เมืองเชียงราย",
    "sub-district": "ท่าสุด",
    postcode: 57100,
  },
  {
    province: "เชียงราย",
    district: "เวียงชัย",
    "sub-district": "เวียงชัย",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงชัย",
    "sub-district": "ผางาม",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงชัย",
    "sub-district": "เวียงเหนือ",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงชัย",
    "sub-district": "ดอนศิลา",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงชัย",
    "sub-district": "เมืองชุม",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "เวียง",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "สถาน",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "ครึ่ง",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "บุญเรือง",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "ห้วยซ้อ",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "ศรีดอนชัย",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เชียงของ",
    "sub-district": "ริมโขง",
    postcode: 57140,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "เวียง",
    postcode: 57160,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "งิ้ว",
    postcode: 57160,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "ปล้อง",
    postcode: 57230,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "แม่ลอย",
    postcode: 57230,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "เชียงเคี่ยน",
    postcode: 57230,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "ตับเต่า",
    postcode: 57160,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "หงาว",
    postcode: 57160,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "สันทรายงาม",
    postcode: 57160,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "ศรีดอนไชย",
    postcode: 57230,
  },
  {
    province: "เชียงราย",
    district: "เทิง",
    "sub-district": "หนองแรด",
    postcode: 57230,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "สันมะเค็ด",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "แม่อ้อ",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ธารทอง",
    postcode: 57250,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "สันติสุข",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ดอยงาม",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "หัวง้ม",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "เจริญเมือง",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ป่าหุ่ง",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ม่วงคำ",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ทรายขาว",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "สันกลาง",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "แม่เย็น",
    postcode: 57280,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "เมืองพาน",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "ทานตะวัน",
    postcode: 57280,
  },
  {
    province: "เชียงราย",
    district: "พาน",
    "sub-district": "เวียงห้าว",
    postcode: 57120,
  },
  {
    province: "เชียงราย",
    district: "ป่าแดด",
    "sub-district": "ป่าแดด",
    postcode: 57190,
  },
  {
    province: "เชียงราย",
    district: "ป่าแดด",
    "sub-district": "ป่าแงะ",
    postcode: 57190,
  },
  {
    province: "เชียงราย",
    district: "ป่าแดด",
    "sub-district": "สันมะค่า",
    postcode: 57190,
  },
  {
    province: "เชียงราย",
    district: "ป่าแดด",
    "sub-district": "โรงช้าง",
    postcode: 57190,
  },
  {
    province: "เชียงราย",
    district: "ป่าแดด",
    "sub-district": "ศรีโพธิ์เงิน",
    postcode: 57190,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "แม่จัน",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "จันจว้า",
    postcode: 57270,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "แม่คำ",
    postcode: 57240,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "ป่าซาง",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "สันทราย",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "ท่าข้าวเปลือก",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "ป่าตึง",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "แม่ไร่",
    postcode: 57240,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "ศรีค้ำ",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "จันจว้าใต้",
    postcode: 57270,
  },
  {
    province: "เชียงราย",
    district: "แม่จัน",
    "sub-district": "จอมสวรรค์",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "เวียง",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "ป่าสัก",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "บ้านแซว",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "ศรีดอนมูล",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "แม่เงิน",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "เชียงแสน",
    "sub-district": "โยนก",
    postcode: 57150,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "แม่สาย",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "ห้วยไคร้",
    postcode: 57220,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "เกาะช้าง",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "โป่งผา",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "ศรีเมืองชุม",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "เวียงพางคำ",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "บ้านด้าย",
    postcode: 57220,
  },
  {
    province: "เชียงราย",
    district: "แม่สาย",
    "sub-district": "โป่งงาม",
    postcode: 57130,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "แม่สรวย",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "ป่าแดด",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "แม่พริก",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "ศรีถ้อย",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "ท่าก๊อ",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "วาวี",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "แม่สรวย",
    "sub-district": "เจดีย์หลวง",
    postcode: 57180,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "สันสลี",
    postcode: 57170,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "เวียง",
    postcode: 57170,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "บ้านโป่ง",
    postcode: 57170,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "ป่างิ้ว",
    postcode: 57170,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "เวียงกาหลง",
    postcode: 57260,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "แม่เจดีย์",
    postcode: 57260,
  },
  {
    province: "เชียงราย",
    district: "เวียงป่าเป้า",
    "sub-district": "แม่เจดีย์ใหม่",
    postcode: 57260,
  },
  {
    province: "เชียงราย",
    district: "พญาเม็งราย",
    "sub-district": "แม่เปา",
    postcode: 57290,
  },
  {
    province: "เชียงราย",
    district: "พญาเม็งราย",
    "sub-district": "แม่ต๋ำ",
    postcode: 57290,
  },
  {
    province: "เชียงราย",
    district: "พญาเม็งราย",
    "sub-district": "ไม้ยา",
    postcode: 57290,
  },
  {
    province: "เชียงราย",
    district: "พญาเม็งราย",
    "sub-district": "เม็งราย",
    postcode: 57290,
  },
  {
    province: "เชียงราย",
    district: "พญาเม็งราย",
    "sub-district": "ตาดควัน",
    postcode: 57290,
  },
  {
    province: "เชียงราย",
    district: "เวียงแก่น",
    "sub-district": "ม่วงยาย",
    postcode: 57310,
  },
  {
    province: "เชียงราย",
    district: "เวียงแก่น",
    "sub-district": "ปอ",
    postcode: 57310,
  },
  {
    province: "เชียงราย",
    district: "เวียงแก่น",
    "sub-district": "หล่ายงาว",
    postcode: 57310,
  },
  {
    province: "เชียงราย",
    district: "เวียงแก่น",
    "sub-district": "ท่าข้าม",
    postcode: 57310,
  },
  {
    province: "เชียงราย",
    district: "ขุนตาล",
    "sub-district": "ต้า",
    postcode: 57340,
  },
  {
    province: "เชียงราย",
    district: "ขุนตาล",
    "sub-district": "ป่าตาล",
    postcode: 57340,
  },
  {
    province: "เชียงราย",
    district: "ขุนตาล",
    "sub-district": "ยางฮอม",
    postcode: 57340,
  },
  {
    province: "เชียงราย",
    district: "แม่ฟ้าหลวง",
    "sub-district": "เทอดไทย",
    postcode: 57240,
  },
  {
    province: "เชียงราย",
    district: "แม่ฟ้าหลวง",
    "sub-district": "แม่สลองใน",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่ฟ้าหลวง",
    "sub-district": "แม่สลองนอก",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "แม่ฟ้าหลวง",
    "sub-district": "แม่ฟ้าหลวง",
    postcode: 57240,
  },
  {
    province: "เชียงราย",
    district: "แม่ลาว",
    "sub-district": "ดงมะดะ",
    postcode: 57250,
  },
  {
    province: "เชียงราย",
    district: "แม่ลาว",
    "sub-district": "จอมหมอกแก้ว",
    postcode: 57250,
  },
  {
    province: "เชียงราย",
    district: "แม่ลาว",
    "sub-district": "บัวสลี",
    postcode: 57250,
  },
  {
    province: "เชียงราย",
    district: "แม่ลาว",
    "sub-district": "ป่าก่อดำ",
    postcode: 57250,
  },
  {
    province: "เชียงราย",
    district: "แม่ลาว",
    "sub-district": "โป่งแพร่",
    postcode: 57000,
  },
  {
    province: "เชียงราย",
    district: "เวียงเชียงรุ้ง",
    "sub-district": "ทุ่งก่อ",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงเชียงรุ้ง",
    "sub-district": "ดงมหาวัน",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "เวียงเชียงรุ้ง",
    "sub-district": "ป่าซาง",
    postcode: 57210,
  },
  {
    province: "เชียงราย",
    district: "ดอยหลวง",
    "sub-district": "ปงน้อย",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "ดอยหลวง",
    "sub-district": "โชคชัย",
    postcode: 57110,
  },
  {
    province: "เชียงราย",
    district: "ดอยหลวง",
    "sub-district": "หนองป่าก่อ",
    postcode: 57110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "จองคำ",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "ห้วยโป่ง",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "ผาบ่อง",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "ปางหมู",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "หมอกจำแป่",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "ห้วยผา",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "เมืองแม่ฮ่องสอน",
    "sub-district": "ห้วยปูลิง",
    postcode: 58000,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "ขุนยวม",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "แม่เงา",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "เมืองปอน",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "แม่ยวมน้อย",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "แม่กิ๊",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ขุนยวม",
    "sub-district": "แม่อูคอ",
    postcode: 58140,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "เวียงใต้",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "เวียงเหนือ",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "แม่นาเติง",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "แม่ฮี้",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "ทุ่งยาว",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "เมืองแปง",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปาย",
    "sub-district": "โป่งสา",
    postcode: 58130,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "บ้านกาศ",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "แม่สะเรียง",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "แม่คง",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "แม่เหาะ",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "แม่ยวม",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "เสาหิน",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่สะเรียง",
    "sub-district": "ป่าแป๋",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "แม่ลาน้อย",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "แม่ลาหลวง",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "ท่าผาปุ้ม",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "แม่โถ",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "ห้วยห้อม",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "แม่นาจาง",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "สันติคีรี",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "แม่ลาน้อย",
    "sub-district": "ขุนแม่ลาน้อย",
    postcode: 58120,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "สบเมย",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "แม่คะตวน",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "กองก๋อย",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "แม่สวด",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "ป่าโปง",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "สบเมย",
    "sub-district": "แม่สามแลบ",
    postcode: 58110,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปางมะผ้า",
    "sub-district": "สบป่อง",
    postcode: 58150,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปางมะผ้า",
    "sub-district": "ปางมะผ้า",
    postcode: 58150,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปางมะผ้า",
    "sub-district": "ถ้ำลอด",
    postcode: 58150,
  },
  {
    province: "แม่ฮ่องสอน",
    district: "ปางมะผ้า",
    "sub-district": "นาปู่ป้อม",
    postcode: 58150,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "ปากน้ำโพ",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "กลางแดด",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "เกรียงไกร",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "แควใหญ่",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "ตะเคียนเลื่อน",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "นครสวรรค์ตก",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "นครสวรรค์ออก",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "บางพระหลวง",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "บางม่วง",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "บ้านมะเกลือ",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "บ้านแก่ง",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "พระนอน",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "วัดไทร",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "หนองกรด",
    postcode: 60240,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "หนองกระโดน",
    postcode: 60240,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "หนองปลิง",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "เมืองนครสวรรค์",
    "sub-district": "บึงเสนาท",
    postcode: 60000,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "โกรกพระ",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "ยางตาล",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "บางมะฝ่อ",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "บางประมุง",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "นากลาง",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "ศาลาแดง",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "เนินกว้าว",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "เนินศาลา",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "โกรกพระ",
    "sub-district": "หาดสูง",
    postcode: 60170,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ชุมแสง",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ทับกฤช",
    postcode: 60250,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "พิกุล",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "เกยไชย",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ท่าไม้",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "บางเคียน",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "หนองกระเจา",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "พันลาน",
    postcode: 60250,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "โคกหม้อ",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ไผ่สิงห์",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ฆะมัง",
    postcode: 60120,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมแสง",
    "sub-district": "ทับกฤชใต้",
    postcode: 60250,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "หนองบัว",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "หนองกลับ",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ธารทหาร",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ห้วยร่วม",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ห้วยถั่วใต้",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ห้วยถั่วเหนือ",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ห้วยใหญ่",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "ทุ่งทอง",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "หนองบัว",
    "sub-district": "วังบ่อ",
    postcode: 60110,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "ท่างิ้ว",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "บางตาหงาย",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "หูกวาง",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "อ่างทอง",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "บ้านแดน",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "บางแก้ว",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "ตาขีด",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "ตาสัง",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "ด่านช้าง",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "หนองกรด",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "หนองตางู",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "บึงปลาทู",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "บรรพตพิสัย",
    "sub-district": "เจริญผล",
    postcode: 60180,
  },
  {
    province: "นครสวรรค์",
    district: "เก้าเลี้ยว",
    "sub-district": "มหาโพธิ",
    postcode: 60230,
  },
  {
    province: "นครสวรรค์",
    district: "เก้าเลี้ยว",
    "sub-district": "เก้าเลี้ยว",
    postcode: 60230,
  },
  {
    province: "นครสวรรค์",
    district: "เก้าเลี้ยว",
    "sub-district": "หนองเต่า",
    postcode: 60230,
  },
  {
    province: "นครสวรรค์",
    district: "เก้าเลี้ยว",
    "sub-district": "เขาดิน",
    postcode: 60230,
  },
  {
    province: "นครสวรรค์",
    district: "เก้าเลี้ยว",
    "sub-district": "หัวดง",
    postcode: 60230,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "ตาคลี",
    postcode: 60140,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "ช่องแค",
    postcode: 60210,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "จันเสน",
    postcode: 60260,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "ห้วยหอม",
    postcode: 60210,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "หัวหวาย",
    postcode: 60140,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "หนองโพ",
    postcode: 60140,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "หนองหม้อ",
    postcode: 60140,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "สร้อยทอง",
    postcode: 60210,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "ลาดทิพรส",
    postcode: 60260,
  },
  {
    province: "นครสวรรค์",
    district: "ตาคลี",
    "sub-district": "พรหมนิมิต",
    postcode: 60210,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "ท่าตะโก",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "พนมรอก",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "หัวถนน",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "สายลำโพง",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "วังมหากร",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "ดอนคา",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "ทำนบ",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "วังใหญ่",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "พนมเศษ",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ท่าตะโก",
    "sub-district": "หนองหลวง",
    postcode: 60160,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "โคกเดื่อ",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "สำโรงชัย",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "วังน้ำลัด",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "ตะคร้อ",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "โพธิ์ประสาท",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "วังข่อย",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "นาขอม",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "ไพศาลี",
    "sub-district": "ไพศาลี",
    postcode: 60220,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "พยุหะ",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "เนินมะกอก",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "นิคมเขาบ่อแก้ว",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "ม่วงหัก",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "ยางขาว",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "ย่านมัทรี",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "เขาทอง",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "ท่าน้ำอ้อย",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "น้ำทรง",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "เขากะลา",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "พยุหะคีรี",
    "sub-district": "สระทะเล",
    postcode: 60130,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "ลาดยาว",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "ห้วยน้ำหอม",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "วังม้า",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "วังเมือง",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "สร้อยละคร",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "มาบแก",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "หนองยาว",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "หนองนมวัว",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "บ้านไร่",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "เนินขี้เหล็ก",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "ศาลเจ้าไก่ต่อ",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ลาดยาว",
    "sub-district": "สระแก้ว",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "ตากฟ้า",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "ลำพยนต์",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "สุขสำราญ",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "หนองพิกุล",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "พุนกยูง",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "อุดมธัญญา",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "ตากฟ้า",
    "sub-district": "เขาชายธง",
    postcode: 60190,
  },
  {
    province: "นครสวรรค์",
    district: "แม่วงก์",
    "sub-district": "แม่วงก์",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "แม่วงก์",
    "sub-district": "แม่เล่ย์",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "แม่วงก์",
    "sub-district": "วังซ่าน",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "แม่วงก์",
    "sub-district": "เขาชนกัน",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "แม่เปิน",
    "sub-district": "แม่เปิน",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมตาบง",
    "sub-district": "ชุมตาบง",
    postcode: 60150,
  },
  {
    province: "นครสวรรค์",
    district: "ชุมตาบง",
    "sub-district": "ปางสวรรค์",
    postcode: 60150,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "อุทัยใหม่",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "น้ำซึม",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "สะแกกรัง",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "ดอนขวาง",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "หาดทนง",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "เกาะเทโพ",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "ท่าซุง",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "หนองแก",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "โนนเหล็ก",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "หนองเต่า",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "หนองไผ่แบน",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "หนองพังค่า",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "ทุ่งใหญ่",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "เมืองอุทัยธานี",
    "sub-district": "เนินแจง",
    postcode: 61000,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "ทัพทัน",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "ทุ่งนาไทย",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "เขาขี้ฝอย",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "หนองหญ้าปล้อง",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "โคกหม้อ",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "หนองยายดา",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "หนองกลางดง",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "หนองกระทุ่ม",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "หนองสระ",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "ทัพทัน",
    "sub-district": "ตลุกดู่",
    postcode: 61120,
  },
  {
    province: "อุทัยธานี",
    district: "สว่างอารมณ์",
    "sub-district": "สว่างอารมณ์",
    postcode: 61150,
  },
  {
    province: "อุทัยธานี",
    district: "สว่างอารมณ์",
    "sub-district": "หนองหลวง",
    postcode: 61150,
  },
  {
    province: "อุทัยธานี",
    district: "สว่างอารมณ์",
    "sub-district": "พลวงสองนาง",
    postcode: 61150,
  },
  {
    province: "อุทัยธานี",
    district: "สว่างอารมณ์",
    "sub-district": "ไผ่เขียว",
    postcode: 61150,
  },
  {
    province: "อุทัยธานี",
    district: "สว่างอารมณ์",
    "sub-district": "บ่อยาง",
    postcode: 61150,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "หนองฉาง",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "หนองยาง",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "หนองนางนวล",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "หนองสรวง",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "บ้านเก่า",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "อุทัยเก่า",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "ทุ่งโพ",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "ทุ่งพง",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "เขาบางแกรก",
    postcode: 61170,
  },
  {
    province: "อุทัยธานี",
    district: "หนองฉาง",
    "sub-district": "เขากวางทอง",
    postcode: 61110,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "หนองขาหย่าง",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "หนองไผ่",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "ดอนกลอย",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "ห้วยรอบ",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "ทุ่งพึ่ง",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "ท่าโพ",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "หมกแถว",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "หลุมเข้า",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "หนองขาหย่าง",
    "sub-district": "ดงขวาง",
    postcode: 61130,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "บ้านไร่",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "ทัพหลวง",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "ห้วยแห้ง",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "คอกควาย",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "วังหิน",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "เมืองการุ้ง",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "แก่นมะกรูด",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "หนองจอก",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "หูช้าง",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "บ้านบึง",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "บ้านใหม่คลองเคียน",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "หนองบ่มกล้วย",
    postcode: 61180,
  },
  {
    province: "อุทัยธานี",
    district: "บ้านไร่",
    "sub-district": "เจ้าวัด",
    postcode: 61140,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "ลานสัก",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "ประดู่ยืน",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "ป่าอ้อ",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "ระบำ",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "น้ำรอบ",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ลานสัก",
    "sub-district": "ทุ่งนางาม",
    postcode: 61160,
  },
  {
    province: "อุทัยธานี",
    district: "ห้วยคต",
    "sub-district": "สุขฤทัย",
    postcode: 61170,
  },
  {
    province: "อุทัยธานี",
    district: "ห้วยคต",
    "sub-district": "ทองหลาง",
    postcode: 61170,
  },
  {
    province: "อุทัยธานี",
    district: "ห้วยคต",
    "sub-district": "ห้วยคต",
    postcode: 61170,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ในเมือง",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ไตรตรึงษ์",
    postcode: 62160,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "อ่างทอง",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "นาบ่อคำ",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "นครชุม",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ทรงธรรม",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ลานดอกไม้",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "หนองปลิง",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "คณฑี",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "นิคมทุ่งโพธิ์ทะเล",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "เทพนคร",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "วังทอง",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ท่าขุนราม",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "คลองแม่ลาย",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "ธำมรงค์",
    postcode: 62160,
  },
  {
    province: "กำแพงเพชร",
    district: "เมืองกำแพงเพชร",
    "sub-district": "สระแก้ว",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "ไทรงาม",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "หนองคล้า",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "หนองทอง",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "หนองไม้กอง",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "มหาชัย",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "พานทอง",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "ไทรงาม",
    "sub-district": "หนองแม่แตง",
    postcode: 62150,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองลาน",
    "sub-district": "คลองน้ำไหล",
    postcode: 62180,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองลาน",
    "sub-district": "โป่งน้ำร้อน",
    postcode: 62180,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองลาน",
    "sub-district": "คลองลานพัฒนา",
    postcode: 62180,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองลาน",
    "sub-district": "สักงาม",
    postcode: 62180,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "ยางสูง",
    postcode: 62130,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "ป่าพุทรา",
    postcode: 62130,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "แสนตอ",
    postcode: 62130,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "สลกบาตร",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "บ่อถ้ำ",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "ดอนแตง",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "วังชะพลู",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "โค้งไผ่",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "ปางมะค่า",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "วังหามแห",
    postcode: 62140,
  },
  {
    province: "กำแพงเพชร",
    district: "ขาณุวรลักษบุรี",
    "sub-district": "เกาะตาล",
    postcode: 62130,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "คลองขลุง",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "ท่ามะเขือ",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "ท่าพุทรา",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "แม่ลาด",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "วังยาง",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "วังแขม",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "หัวถนน",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "วังไทร",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "วังบัว",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "คลองขลุง",
    "sub-district": "คลองสมบูรณ์",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "พรานกระต่าย",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "หนองหัววัว",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "ท่าไม้",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "วังควง",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "วังตะแบก",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "เขาคีริส",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "คุยบ้านโอง",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "คลองพิไกร",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "ถ้ำกระต่ายทอง",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "พรานกระต่าย",
    "sub-district": "ห้วยยั้ง",
    postcode: 62110,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "ลานกระบือ",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "ช่องลม",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "หนองหลวง",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "โนนพลวง",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "ประชาสุขสันต์",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "บึงทับแรต",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ลานกระบือ",
    "sub-district": "จันทิมา",
    postcode: 62170,
  },
  {
    province: "กำแพงเพชร",
    district: "ทรายทองวัฒนา",
    "sub-district": "ทุ่งทราย",
    postcode: 62190,
  },
  {
    province: "กำแพงเพชร",
    district: "ทรายทองวัฒนา",
    "sub-district": "ทุ่งทอง",
    postcode: 62190,
  },
  {
    province: "กำแพงเพชร",
    district: "ทรายทองวัฒนา",
    "sub-district": "ถาวรวัฒนา",
    postcode: 62190,
  },
  {
    province: "กำแพงเพชร",
    district: "ปางศิลาทอง",
    "sub-district": "โพธิ์ทอง",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "ปางศิลาทอง",
    "sub-district": "หินดาต",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "ปางศิลาทอง",
    "sub-district": "ปางตาไว",
    postcode: 62120,
  },
  {
    province: "กำแพงเพชร",
    district: "บึงสามัคคี",
    "sub-district": "บึงสามัคคี",
    postcode: 62210,
  },
  {
    province: "กำแพงเพชร",
    district: "บึงสามัคคี",
    "sub-district": "วังชะโอน",
    postcode: 62210,
  },
  {
    province: "กำแพงเพชร",
    district: "บึงสามัคคี",
    "sub-district": "ระหาน",
    postcode: 62210,
  },
  {
    province: "กำแพงเพชร",
    district: "บึงสามัคคี",
    "sub-district": "เทพนิมิต",
    postcode: 62210,
  },
  {
    province: "กำแพงเพชร",
    district: "โกสัมพีนคร",
    "sub-district": "โกสัมพี",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "โกสัมพีนคร",
    "sub-district": "เพชรชมภู",
    postcode: 62000,
  },
  {
    province: "กำแพงเพชร",
    district: "โกสัมพีนคร",
    "sub-district": "ลานดอกไม้ตก",
    postcode: 62000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "ระแหง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "หนองหลวง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "เชียงเงิน",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "หัวเดียด",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "หนองบัวเหนือ",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "ไม้งาม",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "โป่งแดง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "น้ำรึม",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "วังหิน",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "แม่ท้อ",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "ป่ามะม่วง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "หนองบัวใต้",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "วังประจบ",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "เมืองตาก",
    "sub-district": "ตลุกกลางทุ่ง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "ตากออก",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "สมอโคน",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "แม่สลิด",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "ตากตก",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "เกาะตะเภา",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "ทุ่งกระเชาะ",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "บ้านตาก",
    "sub-district": "ท้องฟ้า",
    postcode: 63120,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "สามเงา",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "วังหมัน",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "ยกกระบัตร",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "ย่านรี",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "บ้านนา",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "สามเงา",
    "sub-district": "วังจันทร์",
    postcode: 63130,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "แม่ระมาด",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "แม่จะเรา",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "ขะเนจื้อ",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "แม่ตื่น",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "สามหมื่น",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "แม่ระมาด",
    "sub-district": "พระธาตุ",
    postcode: 63140,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "ท่าสองยาง",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "แม่ต้าน",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "แม่สอง",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "แม่หละ",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "แม่วะหลวง",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "ท่าสองยาง",
    "sub-district": "แม่อุสุ",
    postcode: 63150,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "แม่สอด",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "แม่กุ",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "พะวอ",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "แม่ตาว",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "แม่กาษา",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "ท่าสายลวด",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "แม่ปะ",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "มหาวัน",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "ด่านแม่ละเมา",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "แม่สอด",
    "sub-district": "พระธาตุผาแดง",
    postcode: 63110,
  },
  {
    province: "ตาก",
    district: "พบพระ",
    "sub-district": "พบพระ",
    postcode: 63160,
  },
  {
    province: "ตาก",
    district: "พบพระ",
    "sub-district": "ช่องแคบ",
    postcode: 63160,
  },
  {
    province: "ตาก",
    district: "พบพระ",
    "sub-district": "คีรีราษฎร์",
    postcode: 63160,
  },
  {
    province: "ตาก",
    district: "พบพระ",
    "sub-district": "วาเล่ย์",
    postcode: 63160,
  },
  {
    province: "ตาก",
    district: "พบพระ",
    "sub-district": "รวมไทยพัฒนา",
    postcode: 63160,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "อุ้มผาง",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "หนองหลวง",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "โมโกร",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "แม่จัน",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "แม่ละมุ้ง",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "อุ้มผาง",
    "sub-district": "แม่กลอง",
    postcode: 63170,
  },
  {
    province: "ตาก",
    district: "วังเจ้า",
    "sub-district": "เชียงทอง",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "วังเจ้า",
    "sub-district": "นาโบสถ์",
    postcode: 63000,
  },
  {
    province: "ตาก",
    district: "วังเจ้า",
    "sub-district": "ประดาง",
    postcode: 63000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "ธานี",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "บ้านสวน",
    postcode: 64220,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "เมืองเก่า",
    postcode: 64210,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "ปากแคว",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "ยางซ้าย",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "บ้านกล้วย",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "บ้านหลุม",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "ตาลเตี้ย",
    postcode: 64220,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "ปากพระ",
    postcode: 64000,
  },
  {
    province: "สุโขทัย",
    district: "เมืองสุโขทัย",
    "sub-district": "วังทองแดง",
    postcode: 64210,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "ลานหอย",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "บ้านด่าน",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "วังตะคร้อ",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "วังน้ำขาว",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "ตลิ่งชัน",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "หนองหญ้าปล้อง",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "บ้านด่านลานหอย",
    "sub-district": "วังลึก",
    postcode: 64140,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "โตนด",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "ทุ่งหลวง",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "บ้านป้อม",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "สามพวง",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "ศรีคีรีมาศ",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "หนองจิก",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "นาเชิงคีรี",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "หนองกระดิ่ง",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "บ้านน้ำพุ",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "คีรีมาศ",
    "sub-district": "ทุ่งยางเมือง",
    postcode: 64160,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "กง",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "บ้านกร่าง",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ไกรนอก",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ไกรกลาง",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ไกรใน",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ดงเดือย",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ป่าแฝก",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "กกแรต",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "ท่าฉนวน",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "หนองตูม",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "กงไกรลาศ",
    "sub-district": "บ้านใหม่สุขเกษม",
    postcode: 64170,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "หาดเสี้ยว",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "ป่างิ้ว",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "แม่สำ",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "แม่สิน",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "บ้านตึก",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "หนองอ้อ",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "ท่าชัย",
    postcode: 64190,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "ศรีสัชนาลัย",
    postcode: 64190,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "ดงคู่",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "บ้านแก่ง",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสัชนาลัย",
    "sub-district": "สารจิตร",
    postcode: 64130,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "คลองตาล",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "วังลึก",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "สามเรือน",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "บ้านนา",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "วังทอง",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "นาขุนไกร",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "เกาะตาเลี้ยง",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "วัดเกาะ",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "บ้านไร่",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "ทับผึ้ง",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "บ้านซ่าน",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "วังใหญ่",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "ศรีสำโรง",
    "sub-district": "ราวต้นจันทร์",
    postcode: 64120,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "เมืองสวรรคโลก",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "ในเมือง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "คลองกระจง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "วังพิณพาทย์",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "วังไม้ขอน",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "ย่านยาว",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "นาทุ่ง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "คลองยาง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "เมืองบางยม",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "ท่าทอง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "ปากน้ำ",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "ป่ากุมเกาะ",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "เมืองบางขลัง",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "สวรรคโลก",
    "sub-district": "หนองกลับ",
    postcode: 64110,
  },
  {
    province: "สุโขทัย",
    district: "ศรีนคร",
    "sub-district": "ศรีนคร",
    postcode: 64180,
  },
  {
    province: "สุโขทัย",
    district: "ศรีนคร",
    "sub-district": "นครเดิฐ",
    postcode: 64180,
  },
  {
    province: "สุโขทัย",
    district: "ศรีนคร",
    "sub-district": "น้ำขุม",
    postcode: 64180,
  },
  {
    province: "สุโขทัย",
    district: "ศรีนคร",
    "sub-district": "คลองมะพลับ",
    postcode: 64180,
  },
  {
    province: "สุโขทัย",
    district: "ศรีนคร",
    "sub-district": "หนองบัว",
    postcode: 64180,
  },
  {
    province: "สุโขทัย",
    district: "ทุ่งเสลี่ยม",
    "sub-district": "บ้านใหม่ไชยมงคล",
    postcode: 64230,
  },
  {
    province: "สุโขทัย",
    district: "ทุ่งเสลี่ยม",
    "sub-district": "ไทยชนะศึก",
    postcode: 64150,
  },
  {
    province: "สุโขทัย",
    district: "ทุ่งเสลี่ยม",
    "sub-district": "ทุ่งเสลี่ยม",
    postcode: 64150,
  },
  {
    province: "สุโขทัย",
    district: "ทุ่งเสลี่ยม",
    "sub-district": "กลางดง",
    postcode: 64150,
  },
  {
    province: "สุโขทัย",
    district: "ทุ่งเสลี่ยม",
    "sub-district": "เขาแก้วศรีสมบูรณ์",
    postcode: 64230,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ในเมือง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "วังน้ำคู้",
    postcode: 65230,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "วัดจันทร์",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "วัดพริก",
    postcode: 65230,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ท่าทอง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ท่าโพธิ์",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "สมอแข",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ดอนทอง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "บ้านป่า",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ปากโทก",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "หัวรอ",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "จอมทอง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "บ้านกร่าง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "บ้านคลอง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "พลายชุมพล",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "มะขามสูง",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "อรัญญิก",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "บึงพระ",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "ไผ่ขอดอน",
    postcode: 65000,
  },
  {
    province: "พิษณุโลก",
    district: "เมืองพิษณุโลก",
    "sub-district": "งิ้วงาม",
    postcode: 65230,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "นครไทย",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "หนองกะท้าว",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "บ้านแยง",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "เนินเพิ่ม",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "นาบัว",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "นครชุม",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "น้ำกุ่ม",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "ยางโกลน",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "บ่อโพธิ์",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "บ้านพร้าว",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "นครไทย",
    "sub-district": "ห้วยเฮี้ย",
    postcode: 65120,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "ป่าแดง",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "ชาติตระการ",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "สวนเมี่ยง",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "บ้านดง",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "บ่อภาค",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "ชาติตระการ",
    "sub-district": "ท่าสะแก",
    postcode: 65170,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "บางระกำ",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "ปลักแรด",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "พันเสา",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "วังอิทก",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "บึงกอก",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "หนองกุลา",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "ชุมแสงสงคราม",
    postcode: 65240,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "นิคมพัฒนา",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "บ่อทอง",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "ท่านางงาม",
    postcode: 65140,
  },
  {
    province: "พิษณุโลก",
    district: "บางระกำ",
    "sub-district": "คุยม่วง",
    postcode: 65240,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "บางกระทุ่ม",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "บ้านไร่",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "โคกสลุด",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "สนามคลี",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "ท่าตาล",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "ไผ่ล้อม",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "นครป่าหมาก",
    postcode: 65110,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "เนินกุ่ม",
    postcode: 65210,
  },
  {
    province: "พิษณุโลก",
    district: "บางกระทุ่ม",
    "sub-district": "วัดตายม",
    postcode: 65210,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "พรหมพิราม",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "ท่าช้าง",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "วงฆ้อง",
    postcode: 65180,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "มะตูม",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "หอกลอง",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "ศรีภิรมย์",
    postcode: 65180,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "ตลุกเทียม",
    postcode: 65180,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "วังวน",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "หนองแขม",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "มะต้อง",
    postcode: 65180,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "ทับยายเชียง",
    postcode: 65150,
  },
  {
    province: "พิษณุโลก",
    district: "พรหมพิราม",
    "sub-district": "ดงประคำ",
    postcode: 65180,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "วัดโบสถ์",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "ท่างาม",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "ท้อแท้",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "บ้านยาง",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "หินลาด",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วัดโบสถ์",
    "sub-district": "คันโช้ง",
    postcode: 65160,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "วังทอง",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "พันชาลี",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "แม่ระกา",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "บ้านกลาง",
    postcode: 65220,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "วังพิกุล",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "แก่งโสภา",
    postcode: 65220,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "ท่าหมื่นราม",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "วังนกแอ่น",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "หนองพระ",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "ชัยนาม",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "วังทอง",
    "sub-district": "ดินทอง",
    postcode: 65130,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "ชมพู",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "บ้านมุง",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "ไทรย้อย",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "วังโพรง",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "บ้านน้อยซุ้มขี้เหล็ก",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "เนินมะปราง",
    postcode: 65190,
  },
  {
    province: "พิษณุโลก",
    district: "เนินมะปราง",
    "sub-district": "วังยาง",
    postcode: 65190,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ในเมือง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ไผ่ขวาง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ย่านยาว",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ท่าฬ่อ",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ปากทาง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "คลองคะเชนทร์",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "โรงช้าง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "เมืองเก่า",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ท่าหลวง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "บ้านบุ่ง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ฆะมัง",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ดงป่าคำ",
    postcode: 66170,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "หัวดง",
    postcode: 66170,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ป่ามะคาบ",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "สายคำโห้",
    postcode: 66000,
  },
  {
    province: "พิจิตร",
    district: "เมืองพิจิตร",
    "sub-district": "ดงกลาง",
    postcode: 66170,
  },
  {
    province: "พิจิตร",
    district: "วังทรายพูน",
    "sub-district": "วังทรายพูน",
    postcode: 66180,
  },
  {
    province: "พิจิตร",
    district: "วังทรายพูน",
    "sub-district": "หนองปลาไหล",
    postcode: 66180,
  },
  {
    province: "พิจิตร",
    district: "วังทรายพูน",
    "sub-district": "หนองพระ",
    postcode: 66180,
  },
  {
    province: "พิจิตร",
    district: "วังทรายพูน",
    "sub-district": "หนองปล้อง",
    postcode: 66180,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "โพธิ์ประทับช้าง",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "ไผ่ท่าโพ",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "วังจิก",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "ไผ่รอบ",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "ดงเสือเหลือง",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "เนินสว่าง",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "โพธิ์ประทับช้าง",
    "sub-district": "ทุ่งใหญ่",
    postcode: 66190,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ตะพานหิน",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "งิ้วราย",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ห้วยเกตุ",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ไทรโรงโขน",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "หนองพยอม",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ทุ่งโพธิ์",
    postcode: 66150,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ดงตะขบ",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "คลองคูณ",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "วังสำโรง",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "วังหว้า",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "วังหลุม",
    postcode: 66150,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ทับหมัน",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "ตะพานหิน",
    "sub-district": "ไผ่หลวง",
    postcode: 66110,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "บางมูลนาก",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "บางไผ่",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "หอไกร",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "เนินมะกอก",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "วังสำโรง",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "ภูมิ",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "วังกรด",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "ห้วยเขน",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "วังตะกู",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "บางมูลนาก",
    "sub-district": "ลำประดา",
    postcode: 66120,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "โพทะเล",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ท้ายน้ำ",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ทะนง",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ท่าบัว",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ทุ่งน้อย",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ท่าขมิ้น",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ท่าเสา",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "บางคลาน",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "ท่านั่ง",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "บ้านน้อย",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "โพทะเล",
    "sub-district": "วัดขวาง",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "สามง่าม",
    "sub-district": "สามง่าม",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "สามง่าม",
    "sub-district": "กำแพงดิน",
    postcode: 66220,
  },
  {
    province: "พิจิตร",
    district: "สามง่าม",
    "sub-district": "รังนก",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "สามง่าม",
    "sub-district": "เนินปอ",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "สามง่าม",
    "sub-district": "หนองโสน",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "ทับคล้อ",
    "sub-district": "ทับคล้อ",
    postcode: 66150,
  },
  {
    province: "พิจิตร",
    district: "ทับคล้อ",
    "sub-district": "เขาทราย",
    postcode: 66230,
  },
  {
    province: "พิจิตร",
    district: "ทับคล้อ",
    "sub-district": "เขาเจ็ดลูก",
    postcode: 66230,
  },
  {
    province: "พิจิตร",
    district: "ทับคล้อ",
    "sub-district": "ท้ายทุ่ง",
    postcode: 66150,
  },
  {
    province: "พิจิตร",
    district: "สากเหล็ก",
    "sub-district": "สากเหล็ก",
    postcode: 66160,
  },
  {
    province: "พิจิตร",
    district: "สากเหล็ก",
    "sub-district": "ท่าเยี่ยม",
    postcode: 66160,
  },
  {
    province: "พิจิตร",
    district: "สากเหล็ก",
    "sub-district": "คลองทราย",
    postcode: 66160,
  },
  {
    province: "พิจิตร",
    district: "สากเหล็ก",
    "sub-district": "หนองหญ้าไทร",
    postcode: 66160,
  },
  {
    province: "พิจิตร",
    district: "สากเหล็ก",
    "sub-district": "วังทับไทร",
    postcode: 66160,
  },
  {
    province: "พิจิตร",
    district: "บึงนาราง",
    "sub-district": "ห้วยแก้ว",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "บึงนาราง",
    "sub-district": "โพธิ์ไทรงาม",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "บึงนาราง",
    "sub-district": "แหลมรัง",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "บึงนาราง",
    "sub-district": "บางลาย",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "บึงนาราง",
    "sub-district": "บึงนาราง",
    postcode: 66130,
  },
  {
    province: "พิจิตร",
    district: "ดงเจริญ",
    "sub-district": "วังงิ้วใต้",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "ดงเจริญ",
    "sub-district": "วังงิ้ว",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "ดงเจริญ",
    "sub-district": "ห้วยร่วม",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "ดงเจริญ",
    "sub-district": "ห้วยพุก",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "ดงเจริญ",
    "sub-district": "สำนักขุนเณร",
    postcode: 66210,
  },
  {
    province: "พิจิตร",
    district: "วชิรบารมี",
    "sub-district": "บ้านนา",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "วชิรบารมี",
    "sub-district": "บึงบัว",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "วชิรบารมี",
    "sub-district": "วังโมกข์",
    postcode: 66140,
  },
  {
    province: "พิจิตร",
    district: "วชิรบารมี",
    "sub-district": "หนองหลุม",
    postcode: 66220,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ในเมือง",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ตะเบาะ",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "บ้านโตก",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "สะเดียง",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ป่าเลา",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "นางั่ว",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ท่าพล",
    postcode: 67250,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ดงมูลเหล็ก",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "บ้านโคก",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ชอนไพร",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "นาป่า",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "นายม",
    postcode: 67210,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "วังชมภู",
    postcode: 67210,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "น้ำร้อน",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ห้วยสะแก",
    postcode: 67210,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ห้วยใหญ่",
    postcode: 67000,
  },
  {
    province: "เพชรบูรณ์",
    district: "เมืองเพชรบูรณ์",
    "sub-district": "ระวิง",
    postcode: 67210,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ชนแดน",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ดงขุย",
    postcode: 67190,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ท่าข้าม",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "พุทธบาท",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ลาดแค",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "บ้านกล้วย",
    postcode: 67190,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ซับพุทรา",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ตะกุดไร",
    postcode: 67190,
  },
  {
    province: "เพชรบูรณ์",
    district: "ชนแดน",
    "sub-district": "ศาลาลาย",
    postcode: 67150,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "หล่มสัก",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "วัดป่า",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ตาลเดี่ยว",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ฝายนาแซง",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "หนองสว่าง",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "น้ำเฮี้ย",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "สักหลง",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ท่าอิบุญ",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บ้านโสก",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บ้านติ้ว",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ห้วยไร่",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "น้ำก้อ",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ปากช่อง",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "น้ำชุน",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "หนองไขว่",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ลานบ่า",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บุ่งคล้า",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บุ่งน้ำเต้า",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บ้านกลาง",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ช้างตะลูด",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บ้านไร่",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "ปากดุก",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มสัก",
    "sub-district": "บ้านหวาย",
    postcode: 67110,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "หล่มเก่า",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "นาซำ",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "หินฮาว",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "บ้านเนิน",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "ศิลา",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "นาแซง",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "วังบาล",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "นาเกาะ",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "หล่มเก่า",
    "sub-district": "ตาดกลอย",
    postcode: 67120,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "ท่าโรง",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "สระประดู่",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "สามแยก",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "โคกปรง",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "น้ำร้อน",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "บ่อรัง",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "พุเตย",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "พุขาม",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "ภูน้ำหยด",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "ซับสมบูรณ์",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "บึงกระจับ",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "วังใหญ่",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "ยางสาว",
    postcode: 67130,
  },
  {
    province: "เพชรบูรณ์",
    district: "วิเชียรบุรี",
    "sub-district": "ซับน้อย",
    postcode: 67180,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "ศรีเทพ",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "สระกรวด",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "คลองกระจัง",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "นาสนุ่น",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "โคกสะอาด",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "หนองย่างทอย",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "ศรีเทพ",
    "sub-district": "ประดู่งาม",
    postcode: 67170,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "กองทูล",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "นาเฉลียง",
    postcode: 67220,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "บ้านโภชน์",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "ท่าแดง",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "เพชรละคร",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "บ่อไทย",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "ห้วยโป่ง",
    postcode: 67220,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "วังท่าดี",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "บัววัฒนา",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "หนองไผ่",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "วังโบสถ์",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "ยางงาม",
    postcode: 67220,
  },
  {
    province: "เพชรบูรณ์",
    district: "หนองไผ่",
    "sub-district": "ท่าด้วง",
    postcode: 67140,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "ซับสมอทอด",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "ซับไม้แดง",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "หนองแจง",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "กันจุ",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "วังพิกุล",
    postcode: 67230,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "พญาวัง",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "ศรีมงคล",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "สระแก้ว",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "บึงสามพัน",
    "sub-district": "บึงสามพัน",
    postcode: 67160,
  },
  {
    province: "เพชรบูรณ์",
    district: "น้ำหนาว",
    "sub-district": "น้ำหนาว",
    postcode: 67260,
  },
  {
    province: "เพชรบูรณ์",
    district: "น้ำหนาว",
    "sub-district": "หลักด่าน",
    postcode: 67260,
  },
  {
    province: "เพชรบูรณ์",
    district: "น้ำหนาว",
    "sub-district": "วังกวาง",
    postcode: 67260,
  },
  {
    province: "เพชรบูรณ์",
    district: "น้ำหนาว",
    "sub-district": "โคกมน",
    postcode: 67260,
  },
  {
    province: "เพชรบูรณ์",
    district: "วังโป่ง",
    "sub-district": "วังโป่ง",
    postcode: 67240,
  },
  {
    province: "เพชรบูรณ์",
    district: "วังโป่ง",
    "sub-district": "ท้ายดง",
    postcode: 67240,
  },
  {
    province: "เพชรบูรณ์",
    district: "วังโป่ง",
    "sub-district": "ซับเปิบ",
    postcode: 67240,
  },
  {
    province: "เพชรบูรณ์",
    district: "วังโป่ง",
    "sub-district": "วังหิน",
    postcode: 67240,
  },
  {
    province: "เพชรบูรณ์",
    district: "วังโป่ง",
    "sub-district": "วังศาล",
    postcode: 67240,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "ทุ่งสมอ",
    postcode: 67270,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "แคมป์สน",
    postcode: 67280,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "เขาค้อ",
    postcode: 67270,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "ริมสีม่วง",
    postcode: 67270,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "สะเดาะพง",
    postcode: 67270,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "หนองแม่นา",
    postcode: 67270,
  },
  {
    province: "เพชรบูรณ์",
    district: "เขาค้อ",
    "sub-district": "เข็กน้อย",
    postcode: 67280,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "หน้าเมือง",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "เจดีย์หัก",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "ดอนตะโก",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "หนองกลางนา",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "ห้วยไผ่",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "คุ้งน้ำวน",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "คุ้งกระถิน",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "อ่างทอง",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "โคกหม้อ",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "สามเรือน",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "พิกุลทอง",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "น้ำพุ",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "ดอนแร่",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "หินกอง",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "เขาแร้ง",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "เกาะพลับพลา",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "หลุมดิน",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "บางป่า",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "พงสวาย",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "คูบัว",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "ท่าราบ",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "เมืองราชบุรี",
    "sub-district": "บ้านไร่",
    postcode: 70000,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "จอมบึง",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "ปากช่อง",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "เบิกไพร",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "ด่านทับตะโก",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "แก้มอ้น",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "จอมบึง",
    "sub-district": "รางบัว",
    postcode: 70150,
  },
  {
    province: "ราชบุรี",
    district: "สวนผึ้ง",
    "sub-district": "สวนผึ้ง",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "สวนผึ้ง",
    "sub-district": "ป่าหวาย",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "สวนผึ้ง",
    "sub-district": "ท่าเคย",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "สวนผึ้ง",
    "sub-district": "ตะนาวศรี",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ดำเนินสะดวก",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ประสาทสิทธิ์",
    postcode: 70210,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ศรีสุราษฎร์",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ตาหลวง",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ดอนกรวย",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ดอนคลัง",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "บัวงาม",
    postcode: 70210,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "บ้านไร่",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "แพงพวย",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "สี่หมื่น",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ท่านัด",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ขุนพิทักษ์",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "ดำเนินสะดวก",
    "sub-district": "ดอนไผ่",
    postcode: 70130,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "บ้านโป่ง",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "ท่าผา",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "กรับใหญ่",
    postcode: 70190,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "ปากแรต",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "หนองกบ",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "หนองอ้อ",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "ดอนกระเบื้อง",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "สวนกล้วย",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "นครชุมน์",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "บ้านม่วง",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "คุ้งพยอม",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "หนองปลาหมอ",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "เขาขลุง",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "เบิกไพร",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บ้านโป่ง",
    "sub-district": "ลาดบัวขาว",
    postcode: 70110,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "บางแพ",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "วังเย็น",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "หัวโพ",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "วัดแก้ว",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "ดอนใหญ่",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "ดอนคา",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "บางแพ",
    "sub-district": "โพหัก",
    postcode: 70160,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "โพธาราม",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "ดอนกระเบื้อง",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "หนองโพ",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "บ้านเลือก",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "คลองตาคต",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "บ้านฆ้อง",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "บ้านสิงห์",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "ดอนทราย",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "เจ็ดเสมียน",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "คลองข่อย",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "ชำแระ",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "สร้อยฟ้า",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "ท่าชุมพล",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "บางโตนด",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "เตาปูน",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "นางแก้ว",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "ธรรมเสน",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "เขาชะงุ้ม",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "โพธาราม",
    "sub-district": "หนองกวาง",
    postcode: 70120,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ทุ่งหลวง",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "วังมะนาว",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ดอนทราย",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "หนองกระทุ่ม",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ปากท่อ",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ป่าไก่",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "วัดยางงาม",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "อ่างหิน",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "บ่อกระดาน",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ยางหัก",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "วันดาว",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "ปากท่อ",
    "sub-district": "ห้วยยางโทน",
    postcode: 70140,
  },
  {
    province: "ราชบุรี",
    district: "วัดเพลง",
    "sub-district": "เกาะศาลพระ",
    postcode: 70170,
  },
  {
    province: "ราชบุรี",
    district: "วัดเพลง",
    "sub-district": "จอมประทัด",
    postcode: 70170,
  },
  {
    province: "ราชบุรี",
    district: "วัดเพลง",
    "sub-district": "วัดเพลง",
    postcode: 70170,
  },
  {
    province: "ราชบุรี",
    district: "บ้านคา",
    "sub-district": "บ้านคา",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "บ้านคา",
    "sub-district": "บ้านบึง",
    postcode: 70180,
  },
  {
    province: "ราชบุรี",
    district: "บ้านคา",
    "sub-district": "หนองพันจันทร์",
    postcode: 70180,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "บ้านเหนือ",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "บ้านใต้",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "ปากแพรก",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "ท่ามะขาม",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "แก่งเสี้ยน",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "หนองบัว",
    postcode: 71190,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "ลาดหญ้า",
    postcode: 71190,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "วังด้ง",
    postcode: 71190,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "ช่องสะเดา",
    postcode: 71190,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "หนองหญ้า",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "เกาะสำโรง",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "บ้านเก่า",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "เมืองกาญจนบุรี",
    "sub-district": "วังเย็น",
    postcode: 71000,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "ลุ่มสุ่ม",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "ท่าเสา",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "สิงห์",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "ไทรโยค",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "วังกระแจะ",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "ศรีมงคล",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "ไทรโยค",
    "sub-district": "บ้องตี้",
    postcode: 71150,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "บ่อพลอย",
    postcode: 71160,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "หนองกุ่ม",
    postcode: 71160,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "หนองรี",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "หลุมรัง",
    postcode: 71160,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "ช่องด่าน",
    postcode: 71160,
  },
  {
    province: "กาญจนบุรี",
    district: "บ่อพลอย",
    "sub-district": "หนองกร่าง",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "นาสวน",
    postcode: 71250,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "ด่านแม่แฉลบ",
    postcode: 71250,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "หนองเป็ด",
    postcode: 71250,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "ท่ากระดาน",
    postcode: 71250,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "เขาโจด",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "ศรีสวัสดิ์",
    "sub-district": "แม่กระบุง",
    postcode: 71250,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "พงตึก",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ยางม่วง",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ดอนชะเอม",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ท่าไม้",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ตะคร้ำเอน",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ท่ามะกา",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ท่าเรือ",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "โคกตะบอง",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ดอนขมิ้น",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "อุโลกสี่หมื่น",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "เขาสามสิบหาบ",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "พระแท่น",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "หวายเหนียว",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "แสนตอ",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "สนามแย้",
    postcode: 70190,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "ท่าเสา",
    postcode: 71120,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่ามะกา",
    "sub-district": "หนองลาน",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "ท่าม่วง",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "วังขนาย",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "วังศาลา",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "ท่าล้อ",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "หนองขาว",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "ทุ่งทอง",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "เขาน้อย",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "ม่วงชุม",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "บ้านใหม่",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "พังตรุ",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "ท่าตะคร้อ",
    postcode: 71130,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "รางสาลี่",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ท่าม่วง",
    "sub-district": "หนองตากยา",
    postcode: 71110,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "ท่าขนุน",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "ปิล๊อก",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "หินดาด",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "ลิ่นถิ่น",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "ชะแล",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "ห้วยเขย่ง",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "ทองผาภูมิ",
    "sub-district": "สหกรณ์นิคม",
    postcode: 71180,
  },
  {
    province: "กาญจนบุรี",
    district: "สังขละบุรี",
    "sub-district": "หนองลู",
    postcode: 71240,
  },
  {
    province: "กาญจนบุรี",
    district: "สังขละบุรี",
    "sub-district": "ปรังเผล",
    postcode: 71240,
  },
  {
    province: "กาญจนบุรี",
    district: "สังขละบุรี",
    "sub-district": "ไล่โว่",
    postcode: 71240,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "พนมทวน",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "หนองโรง",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "ทุ่งสมอ",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "ดอนเจดีย์",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "พังตรุ",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "รางหวาย",
    postcode: 71170,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "หนองสาหร่าย",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "พนมทวน",
    "sub-district": "ดอนตาเพชร",
    postcode: 71140,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "เลาขวัญ",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "หนองโสน",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "หนองประดู่",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "หนองปลิง",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "หนองนกแก้ว",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "ทุ่งกระบ่ำ",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "เลาขวัญ",
    "sub-district": "หนองฝ้าย",
    postcode: 71210,
  },
  {
    province: "กาญจนบุรี",
    district: "ด่านมะขามเตี้ย",
    "sub-district": "ด่านมะขามเตี้ย",
    postcode: 71260,
  },
  {
    province: "กาญจนบุรี",
    district: "ด่านมะขามเตี้ย",
    "sub-district": "กลอนโด",
    postcode: 71260,
  },
  {
    province: "กาญจนบุรี",
    district: "ด่านมะขามเตี้ย",
    "sub-district": "จรเข้เผือก",
    postcode: 71260,
  },
  {
    province: "กาญจนบุรี",
    district: "ด่านมะขามเตี้ย",
    "sub-district": "หนองไผ่",
    postcode: 71260,
  },
  {
    province: "กาญจนบุรี",
    district: "หนองปรือ",
    "sub-district": "หนองปรือ",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "หนองปรือ",
    "sub-district": "หนองปลาไหล",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "หนองปรือ",
    "sub-district": "สมเด็จเจริญ",
    postcode: 71220,
  },
  {
    province: "กาญจนบุรี",
    district: "ห้วยกระเจา",
    "sub-district": "ห้วยกระเจา",
    postcode: 71170,
  },
  {
    province: "กาญจนบุรี",
    district: "ห้วยกระเจา",
    "sub-district": "วังไผ่",
    postcode: 71170,
  },
  {
    province: "กาญจนบุรี",
    district: "ห้วยกระเจา",
    "sub-district": "ดอนแสลบ",
    postcode: 71170,
  },
  {
    province: "กาญจนบุรี",
    district: "ห้วยกระเจา",
    "sub-district": "สระลงเรือ",
    postcode: 71170,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ท่าพี่เลี้ยง",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "รั้วใหญ่",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ทับตีเหล็ก",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ท่าระหัด",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ไผ่ขวาง",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "โคกโคเฒ่า",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ดอนตาล",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ดอนมะสังข์",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "พิหารแดง",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ดอนกำยาน",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ดอนโพธิ์ทอง",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "บ้านโพธิ์",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "สระแก้ว",
    postcode: 72230,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ตลิ่งชัน",
    postcode: 72230,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "บางกุ้ง",
    postcode: 72210,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "ศาลาขาว",
    postcode: 72210,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "สวนแตง",
    postcode: 72210,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "สนามชัย",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "โพธิ์พระยา",
    postcode: 72000,
  },
  {
    province: "สุพรรณบุรี",
    district: "เมืองสุพรรณบุรี",
    "sub-district": "สนามคลี",
    postcode: 72230,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "เขาพระ",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "เดิมบาง",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "นางบวช",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "เขาดิน",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "ปากน้ำ",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "ทุ่งคลี",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "โคกช้าง",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "หัวเขา",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "หัวนา",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "บ่อกรุ",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "วังศรีราช",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "ป่าสะแก",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "ยางนอน",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "เดิมบางนางบวช",
    "sub-district": "หนองกระทุ่ม",
    postcode: 72120,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "หนองมะค่าโมง",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "ด่านช้าง",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "ห้วยขมิ้น",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "องค์พระ",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "วังคัน",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "นิคมกระเสียว",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "ด่านช้าง",
    "sub-district": "วังยาว",
    postcode: 72180,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "โคกคราม",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "บางปลาม้า",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "ตะค่า",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "บางใหญ่",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "กฤษณา",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "สาลี",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "ไผ่กองดิน",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "องครักษ์",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "จรเข้ใหญ่",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "บ้านแหลม",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "มะขามล้ม",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "วังน้ำเย็น",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "วัดโบสถ์",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "บางปลาม้า",
    "sub-district": "วัดดาว",
    postcode: 72150,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "ศรีประจันต์",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "บ้านกร่าง",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "มดแดง",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "บางงาม",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "ดอนปรู",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "ปลายนา",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "วังหว้า",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "วังน้ำซับ",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ศรีประจันต์",
    "sub-district": "วังยาง",
    postcode: 72140,
  },
  {
    province: "สุพรรณบุรี",
    district: "ดอนเจดีย์",
    "sub-district": "ดอนเจดีย์",
    postcode: 72170,
  },
  {
    province: "สุพรรณบุรี",
    district: "ดอนเจดีย์",
    "sub-district": "หนองสาหร่าย",
    postcode: 72170,
  },
  {
    province: "สุพรรณบุรี",
    district: "ดอนเจดีย์",
    "sub-district": "ไร่รถ",
    postcode: 72170,
  },
  {
    province: "สุพรรณบุรี",
    district: "ดอนเจดีย์",
    "sub-district": "สระกระโจม",
    postcode: 72250,
  },
  {
    province: "สุพรรณบุรี",
    district: "ดอนเจดีย์",
    "sub-district": "ทะเลบก",
    postcode: 72170,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "สองพี่น้อง",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บางเลน",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บางตาเถร",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บางตะเคียน",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บ้านกุ่ม",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "หัวโพธิ์",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บางพลับ",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "เนินพระปรางค์",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บ้านช้าง",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "ต้นตาล",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "ศรีสำราญ",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "ทุ่งคอก",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "หนองบ่อ",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "บ่อสุพรรณ",
    postcode: 72190,
  },
  {
    province: "สุพรรณบุรี",
    district: "สองพี่น้อง",
    "sub-district": "ดอนมะนาว",
    postcode: 72110,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "ย่านยาว",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "วังลึก",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "สามชุก",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "หนองผักนาก",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "บ้านสระ",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "หนองสะเดา",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "สามชุก",
    "sub-district": "กระเสียว",
    postcode: 72130,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "อู่ทอง",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "สระยายโสม",
    postcode: 72220,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "จรเข้สามพัน",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "บ้านดอน",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "ยุ้งทะลาย",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "ดอนมะเกลือ",
    postcode: 72220,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "หนองโอ่ง",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "ดอนคา",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "พลับพลาไชย",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "บ้านโข้ง",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "เจดีย์",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "สระพังลาน",
    postcode: 72220,
  },
  {
    province: "สุพรรณบุรี",
    district: "อู่ทอง",
    "sub-district": "กระจัน",
    postcode: 72160,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "หนองหญ้าไซ",
    postcode: 72240,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "หนองราชวัตร",
    postcode: 72240,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "หนองโพธิ์",
    postcode: 72240,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "แจงงาม",
    postcode: 72240,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "หนองขาม",
    postcode: 72240,
  },
  {
    province: "สุพรรณบุรี",
    district: "หนองหญ้าไซ",
    "sub-district": "ทัพหลวง",
    postcode: 72240,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "พระปฐมเจดีย์",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "บางแขม",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "พระประโทน",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ธรรมศาลา",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ตาก้อง",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "มาบแค",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "สนามจันทร์",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ดอนยายหอม",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ถนนขาด",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "บ่อพลับ",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "นครปฐม",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "วังตะกู",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "หนองปากโลง",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "สามควายเผือก",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ทุ่งน้อย",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "หนองดินแดง",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "วังเย็น",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "โพรงมะเดื่อ",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ลำพยา",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "สระกะเทียม",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "สวนป่าน",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ห้วยจรเข้",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "ทัพหลวง",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "หนองงูเหลือม",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "เมืองนครปฐม",
    "sub-district": "บ้านยาง",
    postcode: 73000,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ทุ่งกระพังโหม",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "กระตีบ",
    postcode: 73180,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ทุ่งลูกนก",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ห้วยขวาง",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ทุ่งขวาง",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "สระสี่มุม",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ทุ่งบัว",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ดอนข่อย",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "สระพัฒนา",
    postcode: 73180,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ห้วยหมอนทอง",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "ห้วยม่วง",
    postcode: 73180,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "กำแพงแสน",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "รางพิกุล",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "หนองกระทุ่ม",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "กำแพงแสน",
    "sub-district": "วังน้ำเขียว",
    postcode: 73140,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "นครชัยศรี",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "บางกระเบา",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "วัดแค",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ท่าตำหนัก",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "บางแก้ว",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ท่ากระชับ",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ขุนแก้ว",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ท่าพระยา",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "พะเนียด",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "บางระกำ",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "โคกพระเจดีย์",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ศรีษะทอง",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "แหลมบัว",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ศรีมหาโพธิ์",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "สัมปทวน",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "วัดสำโรง",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ดอนแฝก",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ห้วยพลู",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "วัดละมุด",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "บางพระ",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "บางแก้วฟ้า",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ลานตากฟ้า",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "งิ้วราย",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "นครชัยศรี",
    "sub-district": "ไทยาวาส",
    postcode: 73120,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "สามง่าม",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ห้วยพระ",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ลำเหย",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ดอนพุทรา",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "บ้านหลวง",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ดอนรวก",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ห้วยด้วน",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "ดอนตูม",
    "sub-district": "ลำลูกบัว",
    postcode: 73150,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางเลน",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางปลา",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางหลวง",
    postcode: 73190,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางภาษี",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางระกำ",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บางไทรป่า",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "หินมูล",
    postcode: 73190,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "ไทรงาม",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "ดอนตูม",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "นิลเพชร",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "บัวปากท่า",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "คลองนกกระทุง",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "นราภิรมย์",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "ลำพญา",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "บางเลน",
    "sub-district": "ไผ่หูช้าง",
    postcode: 73130,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ท่าข้าม",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ทรงคนอง",
    postcode: 73210,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "หอมเกร็ด",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "บางกระทึก",
    postcode: 73210,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "บางเตย",
    postcode: 73210,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "สามพราน",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "บางช้าง",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ไร่ขิง",
    postcode: 73210,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ท่าตลาด",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "กระทุ่มล้ม",
    postcode: 73220,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "คลองใหม่",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ตลาดจินดา",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "คลองจินดา",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "ยายชา",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "บ้านใหม่",
    postcode: 73110,
  },
  {
    province: "นครปฐม",
    district: "สามพราน",
    "sub-district": "อ้อมใหญ่",
    postcode: 73160,
  },
  {
    province: "นครปฐม",
    district: "พุทธมณฑล",
    "sub-district": "ศาลายา",
    postcode: 73170,
  },
  {
    province: "นครปฐม",
    district: "พุทธมณฑล",
    "sub-district": "คลองโยง",
    postcode: 73170,
  },
  {
    province: "นครปฐม",
    district: "พุทธมณฑล",
    "sub-district": "มหาสวัสดิ์",
    postcode: 73170,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "มหาชัย",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "ท่าฉลอม",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "โกรกกราก",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บ้านบ่อ",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บางโทรัด",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "กาหลง",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "นาโคก",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "ท่าจีน",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "นาดี",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "ท่าทราย",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "คอกกระบือ",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บางน้ำจืด",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "พันท้ายนรสิงห์",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "โคกขาม",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บ้านเกาะ",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บางกระเจ้า",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "บางหญ้าแพรก",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "เมืองสมุทรสาคร",
    "sub-district": "ชัยมงคล",
    postcode: 74000,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "ตลาดกระทุ่มแบน",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "อ้อมน้อย",
    postcode: 74130,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "ท่าไม้",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "สวนหลวง",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "บางยาง",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "คลองมะเดื่อ",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "หนองนกไข่",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "ดอนไก่ดี",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "แคราย",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "กระทุ่มแบน",
    "sub-district": "ท่าเสา",
    postcode: 74110,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "บ้านแพ้ว",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "หลักสาม",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "ยกกระบัตร",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "โรงเข้",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "หนองสองห้อง",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "หนองบัว",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "หลักสอง",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "เจ็ดริ้ว",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "คลองตัน",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "อำแพง",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "สวนส้ม",
    postcode: 74120,
  },
  {
    province: "สมุทรสาคร",
    district: "บ้านแพ้ว",
    "sub-district": "เกษตรพัฒนา",
    postcode: 74120,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "แม่กลอง",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "บางขันแตก",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "ลาดใหญ่",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "บ้านปรก",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "บางแก้ว",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "ท้ายหาด",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "แหลมใหญ่",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "คลองเขิน",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "คลองโคน",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "นางตะเคียน",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "เมืองสมุทรสงคราม",
    "sub-district": "บางจะเกร็ง",
    postcode: 75000,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "กระดังงา",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางสะแก",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางยี่รงค์",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "โรงหีบ",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางคนที",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "ดอนมะโนรา",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางพรม",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางกุ้ง",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "จอมปลวก",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางนกแขวก",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "ยายแพง",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บางกระบือ",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "บางคนที",
    "sub-district": "บ้านปราโมทย์",
    postcode: 75120,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "อัมพวา",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "สวนหลวง",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "ท่าคา",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "วัดประดู่",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "เหมืองใหม่",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "บางช้าง",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "แควอ้อม",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "ปลายโพงพาง",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "บางแค",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "แพรกหนามแดง",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "ยี่สาร",
    postcode: 75110,
  },
  {
    province: "สมุทรสงคราม",
    district: "อัมพวา",
    "sub-district": "บางนางลี่",
    postcode: 75110,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ท่าราบ",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "คลองกระแชง",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "บางจาน",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "นาพันสาม",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ธงชัย",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "บ้านกุ่ม",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "หนองโสน",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ไร่ส้ม",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "เวียงคอย",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "บางจาก",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "บ้านหม้อ",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ต้นมะม่วง",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ช่องสะแก",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "นาวุ้ง",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "สำมะโรง",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "โพพระ",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "หาดเจ้าสำราญ",
    postcode: 76100,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "หัวสะพาน",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ต้นมะพร้าว",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "วังตะโก",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "โพไร่หวาน",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "ดอนยาง",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "หนองขนาน",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เมืองเพชรบุรี",
    "sub-district": "หนองพลับ",
    postcode: 76000,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "เขาย้อย",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "สระพัง",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "บางเค็ม",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "ทับคาง",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "หนองปลาไหล",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "หนองปรง",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "หนองชุมพล",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "ห้วยโรง",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "ห้วยท่าช้าง",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "เขาย้อย",
    "sub-district": "หนองชุมพลเหนือ",
    postcode: 76140,
  },
  {
    province: "เพชรบุรี",
    district: "หนองหญ้าปล้อง",
    "sub-district": "หนองหญ้าปล้อง",
    postcode: 76160,
  },
  {
    province: "เพชรบุรี",
    district: "หนองหญ้าปล้อง",
    "sub-district": "ยางน้ำกลัดเหนือ",
    postcode: 76160,
  },
  {
    province: "เพชรบุรี",
    district: "หนองหญ้าปล้อง",
    "sub-district": "ยางน้ำกลัดใต้",
    postcode: 76160,
  },
  {
    province: "เพชรบุรี",
    district: "หนองหญ้าปล้อง",
    "sub-district": "ท่าตะคร้อ",
    postcode: 76160,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "ชะอำ",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "บางเก่า",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "นายาง",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "เขาใหญ่",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "หนองศาลา",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "ห้วยทรายเหนือ",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "ไร่ใหม่พัฒนา",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "สามพระยา",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ชะอำ",
    "sub-district": "ดอนขุนห้วย",
    postcode: 76120,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ท่ายาง",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ท่าคอย",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ยางหย่อง",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "หนองจอก",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "มาบปลาเค้า",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ท่าไม้รวก",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "วังไคร้",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "กลัดหลวง",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ปึกเตียน",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "เขากระปุก",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "ท่าแลง",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "ท่ายาง",
    "sub-district": "บ้านในดง",
    postcode: 76130,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "บ้านลาด",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "บ้านหาด",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "บ้านทาน",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ตำหรุ",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "สมอพลือ",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ไร่มะขาม",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ท่าเสน",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "หนองกระเจ็ด",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "หนองกะปุ",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ลาดโพธิ์",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "สะพานไกร",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ไร่โคก",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "โรงเข้",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ไร่สะท้อน",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ห้วยข้อง",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ท่าช้าง",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ถ้ำรงค์",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านลาด",
    "sub-district": "ห้วยลึก",
    postcode: 76150,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บ้านแหลม",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บางขุนไทร",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "ปากทะเล",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บางแก้ว",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "แหลมผักเบี้ย",
    postcode: 76100,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บางตะบูน",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บางตะบูนออก",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "บางครก",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "ท่าแร้ง",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "บ้านแหลม",
    "sub-district": "ท่าแร้งออก",
    postcode: 76110,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "แก่งกระจาน",
    postcode: 76170,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "สองพี่น้อง",
    postcode: 76170,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "วังจันทร์",
    postcode: 76170,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "ป่าเด็ง",
    postcode: 76170,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "พุสวรรค์",
    postcode: 76170,
  },
  {
    province: "เพชรบุรี",
    district: "แก่งกระจาน",
    "sub-district": "ห้วยแม่เพรียง",
    postcode: 76170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "ประจวบคีรีขันธ์",
    postcode: 77000,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "เกาะหลัก",
    postcode: 77000,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "คลองวาฬ",
    postcode: 77000,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "ห้วยทราย",
    postcode: 77000,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "อ่าวน้อย",
    postcode: 77000,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "เมืองประจวบคีรีขันธ์",
    "sub-district": "บ่อนอก",
    postcode: 77210,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "กุยบุรี",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "กุยเหนือ",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "เขาแดง",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "ดอนยายหนู",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "สามกระทาย",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "กุยบุรี",
    "sub-district": "หาดขาม",
    postcode: 77150,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "ทับสะแก",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "อ่างทอง",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "นาหูกวาง",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "เขาล้าน",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "ห้วยยาง",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ทับสะแก",
    "sub-district": "แสงอรุณ",
    postcode: 77130,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "กำเนิดนพคุณ",
    postcode: 77140,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "พงศ์ประศาสน์",
    postcode: 77140,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "ร่อนทอง",
    postcode: 77230,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "ธงชัย",
    postcode: 77190,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "ชัยเกษม",
    postcode: 77190,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "ทองมงคล",
    postcode: 77230,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพาน",
    "sub-district": "แม่รำพึง",
    postcode: 77140,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพานน้อย",
    "sub-district": "ปากแพรก",
    postcode: 77170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพานน้อย",
    "sub-district": "บางสะพาน",
    postcode: 77170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพานน้อย",
    "sub-district": "ทรายทอง",
    postcode: 77170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพานน้อย",
    "sub-district": "ช้างแรก",
    postcode: 77170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "บางสะพานน้อย",
    "sub-district": "ไชยราช",
    postcode: 77170,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "ปราณบุรี",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "เขาน้อย",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "ปากน้ำปราณ",
    postcode: 77220,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "หนองตาแต้ม",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "วังก์พง",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "ปราณบุรี",
    "sub-district": "เขาจ้าว",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "หัวหิน",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "หนองแก",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "หินเหล็กไฟ",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "หนองพลับ",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "ทับใต้",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "ห้วยสัตว์ใหญ่",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "หัวหิน",
    "sub-district": "บึงนคร",
    postcode: 77110,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "สามร้อยยอด",
    "sub-district": "สามร้อยยอด",
    postcode: 77120,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "สามร้อยยอด",
    "sub-district": "ศิลาลอย",
    postcode: 77180,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "สามร้อยยอด",
    "sub-district": "ไร่เก่า",
    postcode: 77180,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "สามร้อยยอด",
    "sub-district": "ศาลาลัย",
    postcode: 77180,
  },
  {
    province: "ประจวบคีรีขันธ์",
    district: "สามร้อยยอด",
    "sub-district": "ไร่ใหม่",
    postcode: 77180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ในเมือง",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ท่าวัง",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "คลัง",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ท่าไร่",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ปากนคร",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "นาทราย",
    postcode: 80280,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "กำแพงเซา",
    postcode: 80280,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ไชยมนตรี",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "มะม่วงสองต้น",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "นาเคียน",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ท่างิ้ว",
    postcode: 80280,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "โพธิ์เสด็จ",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "บางจาก",
    postcode: 80330,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ปากพูน",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ท่าซัก",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เมืองนครศรีธรรมราช",
    "sub-district": "ท่าเรือ",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พรหมคีรี",
    "sub-district": "พรหมโลก",
    postcode: 80320,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พรหมคีรี",
    "sub-district": "บ้านเกาะ",
    postcode: 80320,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พรหมคีรี",
    "sub-district": "อินคีรี",
    postcode: 80320,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พรหมคีรี",
    "sub-district": "ทอนหงส์",
    postcode: 80320,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พรหมคีรี",
    "sub-district": "นาเรียง",
    postcode: 80320,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ลานสกา",
    "sub-district": "เขาแก้ว",
    postcode: 80230,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ลานสกา",
    "sub-district": "ลานสกา",
    postcode: 80230,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ลานสกา",
    "sub-district": "ท่าดี",
    postcode: 80230,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ลานสกา",
    "sub-district": "กำโลน",
    postcode: 80230,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ลานสกา",
    "sub-district": "ขุนทะเล",
    postcode: 80230,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "ฉวาง",
    postcode: 80150,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "ละอาย",
    postcode: 80250,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "นาแว",
    postcode: 80150,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "ไม้เรียง",
    postcode: 80150,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "กะเปียด",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "นากะชะ",
    postcode: 80150,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "ห้วยปริก",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "ไสหร้า",
    postcode: 80150,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "นาเขลียง",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ฉวาง",
    "sub-district": "จันดี",
    postcode: 80250,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พิปูน",
    "sub-district": "พิปูน",
    postcode: 80270,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พิปูน",
    "sub-district": "กะทูน",
    postcode: 80270,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พิปูน",
    "sub-district": "เขาพระ",
    postcode: 80270,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พิปูน",
    "sub-district": "ยางค้อม",
    postcode: 80270,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พิปูน",
    "sub-district": "ควนกลาง",
    postcode: 80270,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "เชียรใหญ่",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "ท่าขนาน",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "บ้านกลาง",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "บ้านเนิน",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "ไสหมาก",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "ท้องลำเจียก",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "เสือหึง",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "การะเกด",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "เขาพระบาท",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เชียรใหญ่",
    "sub-district": "แม่เจ้าอยู่หัว",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "ชะอวด",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "ท่าเสม็ด",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "ท่าประจะ",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "เคร็ง",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "วังอ่าง",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "บ้านตูล",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "ขอนหาด",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "เกาะขันธ์",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "ควนหนองหงษ์",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "เขาพระทอง",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ชะอวด",
    "sub-district": "นางหลง",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "ท่าศาลา",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "กลาย",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "ท่าขึ้น",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "หัวตะพาน",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "สระแก้ว",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "โมคลาน",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "ไทยบุรี",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "ดอนตะโก",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "ตลิ่งชัน",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ท่าศาลา",
    "sub-district": "โพธิ์ทอง",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "ปากแพรก",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "ชะมาย",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "หนองหงส์",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "ควนกรด",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "นาไม้ไผ่",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "นาหลวงเสน",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "เขาโร",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "กะปาง",
    postcode: 80310,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "ที่วัง",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "น้ำตก",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "ถ้ำใหญ่",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "นาโพธิ์",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งสง",
    "sub-district": "เขาขาว",
    postcode: 80110,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นาบอน",
    "sub-district": "นาบอน",
    postcode: 80220,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นาบอน",
    "sub-district": "ทุ่งสง",
    postcode: 80220,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นาบอน",
    "sub-district": "แก้วแสน",
    postcode: 80220,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "ท่ายาง",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "ทุ่งสัง",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "ทุ่งใหญ่",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "กุแหระ",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "ปริก",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "บางรูป",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ทุ่งใหญ่",
    "sub-district": "กรุงหยัน",
    postcode: 80240,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ปากพนัง",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "คลองน้อย",
    postcode: 80330,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ป่าระกำ",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ชะเมา",
    postcode: 80330,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "คลองกระบือ",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "เกาะทวด",
    postcode: 80330,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "บ้านใหม่",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "หูล่อง",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "แหลมตะลุมพุก",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ปากพนังฝั่งตะวันตก",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "บางศาลา",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "บางพระ",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "บางตะพง",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ปากพนังฝั่งตะวันออก",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "บ้านเพิง",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ท่าพยา",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ปากแพรก",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ปากพนัง",
    "sub-district": "ขนาบนาก",
    postcode: 80140,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "ร่อนพิบูลย์",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "หินตก",
    postcode: 80350,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "เสาธง",
    postcode: 80350,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "ควนเกย",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "ควนพัง",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ร่อนพิบูลย์",
    "sub-district": "ควนชุม",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "สิชล",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "ทุ่งปรัง",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "ฉลอง",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "เสาเภา",
    postcode: 80340,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "เปลี่ยน",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "สี่ขีด",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "เทพราช",
    postcode: 80340,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "เขาน้อย",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "สิชล",
    "sub-district": "ทุ่งใส",
    postcode: 80120,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ขนอม",
    "sub-district": "ขนอม",
    postcode: 80210,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ขนอม",
    "sub-district": "ควนทอง",
    postcode: 80210,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ขนอม",
    "sub-district": "ท้องเนียน",
    postcode: 80210,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "หัวไทร",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "หน้าสตน",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "ทรายขาว",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "แหลม",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "เขาพังไกร",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "บ้านราม",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "บางนบ",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "ท่าซอม",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "ควนชะลิก",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "รามแก้ว",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "หัวไทร",
    "sub-district": "เกาะเพชร",
    postcode: 80170,
  },
  {
    province: "นครศรีธรรมราช",
    district: "บางขัน",
    "sub-district": "บางขัน",
    postcode: 80360,
  },
  {
    province: "นครศรีธรรมราช",
    district: "บางขัน",
    "sub-district": "บ้านลำนาว",
    postcode: 80360,
  },
  {
    province: "นครศรีธรรมราช",
    district: "บางขัน",
    "sub-district": "วังหิน",
    postcode: 80360,
  },
  {
    province: "นครศรีธรรมราช",
    district: "บางขัน",
    "sub-district": "บ้านนิคม",
    postcode: 80360,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ถ้ำพรรณรา",
    "sub-district": "ถ้ำพรรณรา",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ถ้ำพรรณรา",
    "sub-district": "คลองเส",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ถ้ำพรรณรา",
    "sub-district": "ดุสิต",
    postcode: 80260,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "บ้านควนมุด",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "บ้านชะอวด",
    postcode: 80180,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "ควนหนองคว้า",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "ทุ่งโพธิ์",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "นาหมอบุญ",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "จุฬาภรณ์",
    "sub-district": "สามตำบล",
    postcode: 80130,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พระพรหม",
    "sub-district": "นาพรุ",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พระพรหม",
    "sub-district": "นาสาร",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พระพรหม",
    "sub-district": "ท้ายสำเภา",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "พระพรหม",
    "sub-district": "ช้างซ้าย",
    postcode: 80000,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นบพิตำ",
    "sub-district": "นบพิตำ",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นบพิตำ",
    "sub-district": "กรุงชิง",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นบพิตำ",
    "sub-district": "กะหรอ",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "นบพิตำ",
    "sub-district": "นาเหรง",
    postcode: 80160,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ช้างกลาง",
    "sub-district": "ช้างกลาง",
    postcode: 80250,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ช้างกลาง",
    "sub-district": "หลักช้าง",
    postcode: 80250,
  },
  {
    province: "นครศรีธรรมราช",
    district: "ช้างกลาง",
    "sub-district": "สวนขัน",
    postcode: 80250,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "เชียรเขา",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ดอนตรอ",
    postcode: 80290,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "สวนหลวง",
    postcode: 80190,
  },
  {
    province: "นครศรีธรรมราช",
    district: "เฉลิมพระเกียรติ",
    "sub-district": "ทางพูน",
    postcode: 80290,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "ปากน้ำ",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "กระบี่ใหญ่",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "กระบี่น้อย",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "เขาคราม",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "เขาทอง",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "ทับปริก",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "ไสไทย",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "อ่าวนาง",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "หนองทะเล",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เมืองกระบี่",
    "sub-district": "คลองประสงค์",
    postcode: 81000,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "เขาพนม",
    postcode: 81140,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "เขาดิน",
    postcode: 81140,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "สินปุน",
    postcode: 80240,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "พรุเตียว",
    postcode: 81140,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "หน้าเขา",
    postcode: 81140,
  },
  {
    province: "กระบี่",
    district: "เขาพนม",
    "sub-district": "โคกหาร",
    postcode: 80240,
  },
  {
    province: "กระบี่",
    district: "เกาะลันตา",
    "sub-district": "เกาะลันตาใหญ่",
    postcode: 81150,
  },
  {
    province: "กระบี่",
    district: "เกาะลันตา",
    "sub-district": "เกาะลันตาน้อย",
    postcode: 81150,
  },
  {
    province: "กระบี่",
    district: "เกาะลันตา",
    "sub-district": "เกาะกลาง",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "เกาะลันตา",
    "sub-district": "คลองยาง",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "เกาะลันตา",
    "sub-district": "ศาลาด่าน",
    postcode: 81150,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "คลองท่อมใต้",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "คลองท่อมเหนือ",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "คลองพน",
    postcode: 81170,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "ทรายขาว",
    postcode: 81170,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "ห้วยน้ำขาว",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "พรุดินนา",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "คลองท่อม",
    "sub-district": "เพหลา",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "อ่าวลึกใต้",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "แหลมสัก",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "นาเหนือ",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "คลองหิน",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "อ่าวลึกน้อย",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "อ่าวลึกเหนือ",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "เขาใหญ่",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "คลองยา",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "อ่าวลึก",
    "sub-district": "บ้านกลาง",
    postcode: 81110,
  },
  {
    province: "กระบี่",
    district: "ปลายพระยา",
    "sub-district": "ปลายพระยา",
    postcode: 81160,
  },
  {
    province: "กระบี่",
    district: "ปลายพระยา",
    "sub-district": "เขาเขน",
    postcode: 81160,
  },
  {
    province: "กระบี่",
    district: "ปลายพระยา",
    "sub-district": "เขาต่อ",
    postcode: 81160,
  },
  {
    province: "กระบี่",
    district: "ปลายพระยา",
    "sub-district": "คีรีวง",
    postcode: 81160,
  },
  {
    province: "กระบี่",
    district: "ลำทับ",
    "sub-district": "ลำทับ",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "ลำทับ",
    "sub-district": "ลำทับ",
    postcode: 81190,
  },
  {
    province: "กระบี่",
    district: "ลำทับ",
    "sub-district": "ดินอุดม",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "ลำทับ",
    "sub-district": "ทุ่งไทรทอง",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "ลำทับ",
    "sub-district": "ดินแดง",
    postcode: 81120,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "เหนือคลอง",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "เกาะศรีบอยา",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "คลองขนาน",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "คลองเขม้า",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "โคกยาง",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "ตลิ่งชัน",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "ปกาสัย",
    postcode: 81130,
  },
  {
    province: "กระบี่",
    district: "เหนือคลอง",
    "sub-district": "ห้วยยูง",
    postcode: 81130,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "ท้ายช้าง",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "นบปริง",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "ถ้ำน้ำผุด",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "บางเตย",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "ตากแดด",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "สองแพรก",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "ทุ่งคาโงก",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "เกาะปันหยี",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เมืองพังงา",
    "sub-district": "ป่ากอ",
    postcode: 82000,
  },
  {
    province: "พังงา",
    district: "เกาะยาว",
    "sub-district": "เกาะยาวน้อย",
    postcode: 82160,
  },
  {
    province: "พังงา",
    district: "เกาะยาว",
    "sub-district": "เกาะยาวใหญ่",
    postcode: 82160,
  },
  {
    province: "พังงา",
    district: "เกาะยาว",
    "sub-district": "พรุใน",
    postcode: 83000,
  },
  {
    province: "พังงา",
    district: "กะปง",
    "sub-district": "กะปง",
    postcode: 82170,
  },
  {
    province: "พังงา",
    district: "กะปง",
    "sub-district": "ท่านา",
    postcode: 82170,
  },
  {
    province: "พังงา",
    district: "กะปง",
    "sub-district": "เหมาะ",
    postcode: 82170,
  },
  {
    province: "พังงา",
    district: "กะปง",
    "sub-district": "เหล",
    postcode: 82170,
  },
  {
    province: "พังงา",
    district: "กะปง",
    "sub-district": "รมณีย์",
    postcode: 82170,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "ถ้ำ",
    postcode: 82130,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "กระโสม",
    postcode: 82130,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "กะไหล",
    postcode: 82130,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "ท่าอยู่",
    postcode: 82130,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "หล่อยูง",
    postcode: 82140,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "โคกกลอย",
    postcode: 82140,
  },
  {
    province: "พังงา",
    district: "ตะกั่วทุ่ง",
    "sub-district": "คลองเคียน",
    postcode: 82130,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "ตะกั่วป่า",
    postcode: 82110,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "บางนายสี",
    postcode: 82110,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "บางไทร",
    postcode: 82110,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "บางม่วง",
    postcode: 82190,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "ตำตัว",
    postcode: 82110,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "โคกเคียน",
    postcode: 82110,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "คึกคัก",
    postcode: 82190,
  },
  {
    province: "พังงา",
    district: "ตะกั่วป่า",
    "sub-district": "เกาะคอเขา",
    postcode: 82190,
  },
  {
    province: "พังงา",
    district: "คุระบุรี",
    "sub-district": "คุระ",
    postcode: 82150,
  },
  {
    province: "พังงา",
    district: "คุระบุรี",
    "sub-district": "บางวัน",
    postcode: 82150,
  },
  {
    province: "พังงา",
    district: "คุระบุรี",
    "sub-district": "เกาะพระทอง",
    postcode: 82150,
  },
  {
    province: "พังงา",
    district: "คุระบุรี",
    "sub-district": "แม่นางขาว",
    postcode: 82150,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "ทับปุด",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "มะรุ่ย",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "บ่อแสน",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "ถ้ำทองหลาง",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "โคกเจริญ",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ทับปุด",
    "sub-district": "บางเหรียง",
    postcode: 82180,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "ท้ายเหมือง",
    postcode: 82120,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "นาเตย",
    postcode: 82120,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "บางทอง",
    postcode: 82120,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "ทุ่งมะพร้าว",
    postcode: 82120,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "ลำภี",
    postcode: 82120,
  },
  {
    province: "พังงา",
    district: "ท้ายเหมือง",
    "sub-district": "ลำแก่น",
    postcode: 82120,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "ตลาดใหญ่",
    postcode: 83000,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "ตลาดเหนือ",
    postcode: 83000,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "เกาะแก้ว",
    postcode: 83000,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "รัษฎา",
    postcode: 83000,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "วิชิต",
    postcode: 83000,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "ฉลอง",
    postcode: 83130,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "ราไวย์",
    postcode: 83130,
  },
  {
    province: "ภูเก็ต",
    district: "เมืองภูเก็ต",
    "sub-district": "กะรน",
    postcode: 83100,
  },
  {
    province: "ภูเก็ต",
    district: "กะทู้",
    "sub-district": "กะทู้",
    postcode: 83120,
  },
  {
    province: "ภูเก็ต",
    district: "กะทู้",
    "sub-district": "ป่าตอง",
    postcode: 83150,
  },
  {
    province: "ภูเก็ต",
    district: "กะทู้",
    "sub-district": "กมลา",
    postcode: 83150,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "เทพกระษัตรี",
    postcode: 83110,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "ศรีสุนทร",
    postcode: 83110,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "เชิงทะเล",
    postcode: 83110,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "ป่าคลอก",
    postcode: 83110,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "ไม้ขาว",
    postcode: 83110,
  },
  {
    province: "ภูเก็ต",
    district: "ถลาง",
    "sub-district": "สาคู",
    postcode: 83110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "ตลาด",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "มะขามเตี้ย",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "วัดประดู่",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "ขุนทะเล",
    postcode: 84100,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "บางใบไม้",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "บางชนะ",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "คลองน้อย",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "บางไทร",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "บางโพธิ์",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "บางกุ้ง",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เมืองสุราษฎร์ธานี",
    "sub-district": "คลองฉนาก",
    postcode: 84000,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ท่าทองใหม่",
    postcode: 84290,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ท่าทอง",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "กะแดะ",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ทุ่งกง",
    postcode: 84290,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "กรูด",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ช้างซ้าย",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "พลายวาส",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ป่าร่อน",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ตะเคียนทอง",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ช้างขวา",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ท่าอุแท",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "ทุ่งรัง",
    postcode: 84290,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "กาญจนดิษฐ์",
    "sub-district": "คลองสระ",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ดอนสัก",
    "sub-district": "ดอนสัก",
    postcode: 84220,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ดอนสัก",
    "sub-district": "ชลคราม",
    postcode: 84160,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ดอนสัก",
    "sub-district": "ไชยคราม",
    postcode: 84220,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ดอนสัก",
    "sub-district": "ปากแพรก",
    postcode: 84340,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "อ่างทอง",
    postcode: 84140,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "ลิปะน้อย",
    postcode: 84140,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "ตลิ่งงาม",
    postcode: 84140,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "หน้าเมือง",
    postcode: 84140,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "มะเร็ต",
    postcode: 84310,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "บ่อผุด",
    postcode: 84320,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะสมุย",
    "sub-district": "แม่น้ำ",
    postcode: 84330,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะพะงัน",
    "sub-district": "เกาะพะงัน",
    postcode: 84280,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะพะงัน",
    "sub-district": "บ้านใต้",
    postcode: 84280,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เกาะพะงัน",
    "sub-district": "เกาะเต่า",
    postcode: 84360,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "ตลาดไชยา",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "พุมเรียง",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "เลม็ด",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "เวียง",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "ทุ่ง",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "ป่าเว",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "ตะกรบ",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "โมถ่าย",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ไชยา",
    "sub-district": "ปากหมาก",
    postcode: 84110,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "ท่าชนะ",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "สมอทอง",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "ประสงค์",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "คันธุลี",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "วัง",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าชนะ",
    "sub-district": "คลองพา",
    postcode: 84170,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "ท่าขนอน",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "บ้านยาง",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "น้ำหัก",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "กะเปา",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "ท่ากระดาน",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "ย่านยาว",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "ถ้ำสิงขร",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "คีรีรัฐนิคม",
    "sub-district": "บ้านทำเนียบ",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านตาขุน",
    "sub-district": "เขาวง",
    postcode: 84230,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านตาขุน",
    "sub-district": "พะแสง",
    postcode: 84230,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านตาขุน",
    "sub-district": "พรุไทย",
    postcode: 84230,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านตาขุน",
    "sub-district": "เขาพัง",
    postcode: 84230,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "พนม",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "ต้นยวน",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "คลองศก",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "พลูเถื่อน",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "พังกาญจน์",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พนม",
    "sub-district": "คลองชะอุ่น",
    postcode: 84250,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "ท่าฉาง",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "ท่าเคย",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "คลองไทร",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "เขาถ่าน",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "เสวียด",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ท่าฉาง",
    "sub-district": "ปากฉลุย",
    postcode: 84150,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "นาสาร",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "พรุพี",
    postcode: 84270,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ทุ่งเตา",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ลำพูน",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ท่าชี",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ควนศรี",
    postcode: 84270,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ควนสุบรรณ",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "คลองปราบ",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "น้ำพุ",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "ทุ่งเตาใหม่",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาสาร",
    "sub-district": "เพิ่มพูนทรัพย์",
    postcode: 84120,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาเดิม",
    "sub-district": "บ้านนา",
    postcode: 84240,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาเดิม",
    "sub-district": "ท่าเรือ",
    postcode: 84240,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาเดิม",
    "sub-district": "ทรัพย์ทวี",
    postcode: 84240,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "บ้านนาเดิม",
    "sub-district": "นาใต้",
    postcode: 84240,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เคียนซา",
    "sub-district": "เคียนซา",
    postcode: 84260,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เคียนซา",
    "sub-district": "พ่วงพรมคร",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เคียนซา",
    "sub-district": "เขาตอก",
    postcode: 84260,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เคียนซา",
    "sub-district": "อรัญคามวารี",
    postcode: 84260,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เคียนซา",
    "sub-district": "บ้านเสด็จ",
    postcode: 84260,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เวียงสระ",
    "sub-district": "เวียงสระ",
    postcode: 84190,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เวียงสระ",
    "sub-district": "บ้านส้อง",
    postcode: 84190,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เวียงสระ",
    "sub-district": "คลองฉนวน",
    postcode: 84190,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เวียงสระ",
    "sub-district": "ทุ่งหลวง",
    postcode: 84190,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "เวียงสระ",
    "sub-district": "เขานิพันธ์",
    postcode: 84190,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "อิปัน",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "สินปุน",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "บางสวรรค์",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "ไทรขึง",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "สินเจริญ",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "ไทรโสภา",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พระแสง",
    "sub-district": "สาคู",
    postcode: 84210,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ท่าข้าม",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ท่าสะท้อน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ลีเล็ด",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "บางมะเดื่อ",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "บางเดือน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ท่าโรงช้าง",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "กรูด",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "พุนพิน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "บางงอน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ศรีวิชัย",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "น้ำรอบ",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "มะลวน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "หัวเตย",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "หนองไทร",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "เขาหัวควาย",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "พุนพิน",
    "sub-district": "ตะปาน",
    postcode: 84130,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ชัยบุรี",
    "sub-district": "สองแพรก",
    postcode: 84350,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ชัยบุรี",
    "sub-district": "ชัยบุรี",
    postcode: 84350,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ชัยบุรี",
    "sub-district": "คลองน้อย",
    postcode: 84350,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "ชัยบุรี",
    "sub-district": "ไทรทอง",
    postcode: 84350,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "วิภาวดี",
    "sub-district": "ตะกุกใต้",
    postcode: 84180,
  },
  {
    province: "สุราษฎร์ธานี",
    district: "วิภาวดี",
    "sub-district": "ตะกุกเหนือ",
    postcode: 84180,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "เขานิเวศน์",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "ราชกรูด",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "หงาว",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "บางริ้น",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "ปากน้ำ",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "บางนอน",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "หาดส้มแป้น",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "ทรายแดง",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "เมืองระนอง",
    "sub-district": "เกาะพยาม",
    postcode: 85000,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "ละอุ่นใต้",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "ละอุ่นเหนือ",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "บางพระใต้",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "บางพระเหนือ",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "บางแก้ว",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "ในวงเหนือ",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "ละอุ่น",
    "sub-district": "ในวงใต้",
    postcode: 85130,
  },
  {
    province: "ระนอง",
    district: "กะเปอร์",
    "sub-district": "ม่วงกลวง",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "กะเปอร์",
    "sub-district": "กะเปอร์",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "กะเปอร์",
    "sub-district": "เชี่ยวเหลียง",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "กะเปอร์",
    "sub-district": "บ้านนา",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "กะเปอร์",
    "sub-district": "บางหิน",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "น้ำจืด",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "น้ำจืดน้อย",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "มะมุ",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "ปากจั่น",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "ลำเลียง",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "จ.ป.ร.",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "กระบุรี",
    "sub-district": "บางใหญ่",
    postcode: 85110,
  },
  {
    province: "ระนอง",
    district: "สุขสำราญ",
    "sub-district": "นาคา",
    postcode: 85120,
  },
  {
    province: "ระนอง",
    district: "สุขสำราญ",
    "sub-district": "กำพวน",
    postcode: 85120,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ท่าตะเภา",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ปากน้ำ",
    postcode: 86120,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ท่ายาง",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "บางหมาก",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "นาทุ่ง",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "นาชะอัง",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ตากแดด",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "บางลึก",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "หาดพันไกร",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "วังไผ่",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "วังใหม่",
    postcode: 86190,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "บ้านนา",
    postcode: 86190,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ขุนกระทิง",
    postcode: 86000,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ทุ่งคา",
    postcode: 86100,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "วิสัยเหนือ",
    postcode: 86100,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "หาดทรายรี",
    postcode: 86120,
  },
  {
    province: "ชุมพร",
    district: "เมืองชุมพร",
    "sub-district": "ถ้ำสิงห์",
    postcode: 86100,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "ท่าแซะ",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "คุริง",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "สลุย",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "นากระตาม",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "รับร่อ",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "ท่าข้าม",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "หงษ์เจริญ",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "หินแก้ว",
    postcode: 86190,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "ทรัพย์อนันต์",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ท่าแซะ",
    "sub-district": "สองพี่น้อง",
    postcode: 86140,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "บางสน",
    postcode: 86160,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "ทะเลทรัพย์",
    postcode: 86160,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "สะพลี",
    postcode: 86230,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "ชุมโค",
    postcode: 86160,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "ดอนยาง",
    postcode: 86210,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "ปากคลอง",
    postcode: 86210,
  },
  {
    province: "ชุมพร",
    district: "ปะทิว",
    "sub-district": "เขาไชยราช",
    postcode: 86210,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "หลังสวน",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "ขันเงิน",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "ท่ามะพลา",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "นาขา",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "นาพญา",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "บ้านควน",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "บางมะพร้าว",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "บางน้ำจืด",
    postcode: 86150,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "ปากน้ำ",
    postcode: 86150,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "พ้อแดง",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "แหลมทราย",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "วังตะกอ",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "หลังสวน",
    "sub-district": "หาดยาย",
    postcode: 86110,
  },
  {
    province: "ชุมพร",
    district: "ละแม",
    "sub-district": "ละแม",
    postcode: 86170,
  },
  {
    province: "ชุมพร",
    district: "ละแม",
    "sub-district": "ทุ่งหลวง",
    postcode: 86170,
  },
  {
    province: "ชุมพร",
    district: "ละแม",
    "sub-district": "สวนแตง",
    postcode: 86170,
  },
  {
    province: "ชุมพร",
    district: "ละแม",
    "sub-district": "ทุ่งคาวัด",
    postcode: 86170,
  },
  {
    province: "ชุมพร",
    district: "พะโต๊ะ",
    "sub-district": "พะโต๊ะ",
    postcode: 86180,
  },
  {
    province: "ชุมพร",
    district: "พะโต๊ะ",
    "sub-district": "ปากทรง",
    postcode: 86180,
  },
  {
    province: "ชุมพร",
    district: "พะโต๊ะ",
    "sub-district": "ปังหวาน",
    postcode: 86180,
  },
  {
    province: "ชุมพร",
    district: "พะโต๊ะ",
    "sub-district": "พระรักษ์",
    postcode: 86180,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "นาโพธิ์",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "สวี",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "ทุ่งระยะ",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "ท่าหิน",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "ปากแพรก",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "ด่านสวี",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "ครน",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "วิสัยใต้",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "นาสัก",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "เขาทะลุ",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "สวี",
    "sub-district": "เขาค่าย",
    postcode: 86130,
  },
  {
    province: "ชุมพร",
    district: "ทุ่งตะโก",
    "sub-district": "ปากตะโก",
    postcode: 86220,
  },
  {
    province: "ชุมพร",
    district: "ทุ่งตะโก",
    "sub-district": "ทุ่งตะไคร",
    postcode: 86220,
  },
  {
    province: "ชุมพร",
    district: "ทุ่งตะโก",
    "sub-district": "ตะโก",
    postcode: 86220,
  },
  {
    province: "ชุมพร",
    district: "ทุ่งตะโก",
    "sub-district": "ช่องไม้แก้ว",
    postcode: 86220,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "บ่อยาง",
    postcode: 90000,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "เขารูปช้าง",
    postcode: 90000,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "เกาะแต้ว",
    postcode: 90000,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "พะวง",
    postcode: 90100,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "ทุ่งหวัง",
    postcode: 90000,
  },
  {
    province: "สงขลา",
    district: "เมืองสงขลา",
    "sub-district": "เกาะยอ",
    postcode: 90100,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "จะทิ้งพระ",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "กระดังงา",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "สนามชัย",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "ดีหลวง",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "ชุมพล",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "คลองรี",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "คูขุด",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "ท่าหิน",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "วัดจันทร์",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "บ่อแดง",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "สทิงพระ",
    "sub-district": "บ่อดาน",
    postcode: 90190,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "บ้านนา",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "ป่าชิง",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "สะพานไม้แก่น",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "สะกอม",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "นาหว้า",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "นาทับ",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "น้ำขาว",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "ขุนตัดหวาย",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "ท่าหมอไทร",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "จะโหนง",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "คู",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "แค",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "คลองเปียะ",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "จะนะ",
    "sub-district": "ตลิ่งชัน",
    postcode: 90130,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "นาทวี",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "ฉาง",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "นาหมอศรี",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "คลองทราย",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "ปลักหนู",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "ท่าประดู่",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "สะท้อน",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "ทับช้าง",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "ประกอบ",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "นาทวี",
    "sub-district": "คลองกวาง",
    postcode: 90160,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "เทพา",
    postcode: 90150,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "ปากบาง",
    postcode: 90150,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "เกาะสะบ้า",
    postcode: 90150,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "ลำไพล",
    postcode: 90260,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "ท่าม่วง",
    postcode: 90150,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "วังใหญ่",
    postcode: 90260,
  },
  {
    province: "สงขลา",
    district: "เทพา",
    "sub-district": "สะกอม",
    postcode: 90150,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "สะบ้าย้อย",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "ทุ่งพอ",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "เปียน",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "บ้านโหนด",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "จะแหน",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "คูหา",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "เขาแดง",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "บาโหย",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "สะบ้าย้อย",
    "sub-district": "ธารคีรี",
    postcode: 90210,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "ระโนด",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "คลองแดน",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "ตะเครียะ",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "ท่าบอน",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "บ้านใหม่",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "บ่อตรุ",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "ปากแตระ",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "พังยาง",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "ระวะ",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "วัดสน",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "บ้านขาว",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "ระโนด",
    "sub-district": "แดนสงวน",
    postcode: 90140,
  },
  {
    province: "สงขลา",
    district: "กระแสสินธุ์",
    "sub-district": "เกาะใหญ่",
    postcode: 90270,
  },
  {
    province: "สงขลา",
    district: "กระแสสินธุ์",
    "sub-district": "โรง",
    postcode: 90270,
  },
  {
    province: "สงขลา",
    district: "กระแสสินธุ์",
    "sub-district": "เชิงแส",
    postcode: 90270,
  },
  {
    province: "สงขลา",
    district: "กระแสสินธุ์",
    "sub-district": "กระแสสินธุ์",
    postcode: 90270,
  },
  {
    province: "สงขลา",
    district: "รัตภูมิ",
    "sub-district": "กำแพงเพชร",
    postcode: 90180,
  },
  {
    province: "สงขลา",
    district: "รัตภูมิ",
    "sub-district": "ท่าชะมวง",
    postcode: 90180,
  },
  {
    province: "สงขลา",
    district: "รัตภูมิ",
    "sub-district": "คูหาใต้",
    postcode: 90180,
  },
  {
    province: "สงขลา",
    district: "รัตภูมิ",
    "sub-district": "ควนรู",
    postcode: 90180,
  },
  {
    province: "สงขลา",
    district: "รัตภูมิ",
    "sub-district": "เขาพระ",
    postcode: 90180,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "สะเดา",
    postcode: 90120,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "ปริก",
    postcode: 90120,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "พังลา",
    postcode: 90170,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "สำนักแต้ว",
    postcode: 90120,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "ทุ่งหมอ",
    postcode: 90240,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "ท่าโพธิ์",
    postcode: 90170,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "ปาดังเบซาร์",
    postcode: 90240,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "สำนักขาม",
    postcode: 90120,
  },
  {
    province: "สงขลา",
    district: "สะเดา",
    "sub-district": "เขามีเกียรติ",
    postcode: 90170,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "หาดใหญ่",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "ควนลัง",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "คูเต่า",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "คอหงส์",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "คลองแห",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "คลองอู่ตะเภา",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "ฉลุง",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "ทุ่งใหญ่",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "ทุ่งตำเสา",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "ท่าข้าม",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "น้ำน้อย",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "บ้านพรุ",
    postcode: 90250,
  },
  {
    province: "สงขลา",
    district: "หาดใหญ่",
    "sub-district": "พะตง",
    postcode: 90230,
  },
  {
    province: "สงขลา",
    district: "นาหม่อม",
    "sub-district": "นาหม่อม",
    postcode: 90310,
  },
  {
    province: "สงขลา",
    district: "นาหม่อม",
    "sub-district": "พิจิตร",
    postcode: 90310,
  },
  {
    province: "สงขลา",
    district: "นาหม่อม",
    "sub-district": "ทุ่งขมิ้น",
    postcode: 90310,
  },
  {
    province: "สงขลา",
    district: "นาหม่อม",
    "sub-district": "คลองหรัง",
    postcode: 90310,
  },
  {
    province: "สงขลา",
    district: "ควนเนียง",
    "sub-district": "รัตภูมิ",
    postcode: 90220,
  },
  {
    province: "สงขลา",
    district: "ควนเนียง",
    "sub-district": "ควนโส",
    postcode: 90220,
  },
  {
    province: "สงขลา",
    district: "ควนเนียง",
    "sub-district": "ห้วยลึก",
    postcode: 90220,
  },
  {
    province: "สงขลา",
    district: "ควนเนียง",
    "sub-district": "บางเหรียง",
    postcode: 90220,
  },
  {
    province: "สงขลา",
    district: "บางกล่ำ",
    "sub-district": "บางกล่ำ",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "บางกล่ำ",
    "sub-district": "ท่าช้าง",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "บางกล่ำ",
    "sub-district": "แม่ทอม",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "บางกล่ำ",
    "sub-district": "บ้านหาร",
    postcode: 90110,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ชิงโค",
    postcode: 90280,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "สทิงหม้อ",
    postcode: 90280,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ทำนบ",
    postcode: 90280,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "รำแดง",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "วัดขนุน",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ชะแล้",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ปากรอ",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ป่าขาด",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "หัวเขา",
    postcode: 90280,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "บางเขียด",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "สิงหนคร",
    "sub-district": "ม่วงงาม",
    postcode: 90330,
  },
  {
    province: "สงขลา",
    district: "คลองหอยโข่ง",
    "sub-district": "คลองหอยโข่ง",
    postcode: 90230,
  },
  {
    province: "สงขลา",
    district: "คลองหอยโข่ง",
    "sub-district": "ทุ่งลาน",
    postcode: 90230,
  },
  {
    province: "สงขลา",
    district: "คลองหอยโข่ง",
    "sub-district": "โคกม่วง",
    postcode: 90230,
  },
  {
    province: "สงขลา",
    district: "คลองหอยโข่ง",
    "sub-district": "คลองหลา",
    postcode: 90115,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "พิมาน",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "คลองขุด",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ควนขัน",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "บ้านควน",
    postcode: 91140,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ฉลุง",
    postcode: 91140,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "เกาะสาหร่าย",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ตันหยงโป",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "เจ๊ะบิลัง",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ตำมะลัง",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ปูยู",
    postcode: 91000,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "ควนโพธิ์",
    postcode: 91140,
  },
  {
    province: "สตูล",
    district: "เมืองสตูล",
    "sub-district": "เกตรี",
    postcode: 91140,
  },
  {
    province: "สตูล",
    district: "ควนโดน",
    "sub-district": "ควนโดน",
    postcode: 91160,
  },
  {
    province: "สตูล",
    district: "ควนโดน",
    "sub-district": "ควนสตอ",
    postcode: 91160,
  },
  {
    province: "สตูล",
    district: "ควนโดน",
    "sub-district": "ย่านซื่อ",
    postcode: 91160,
  },
  {
    province: "สตูล",
    district: "ควนโดน",
    "sub-district": "วังประจัน",
    postcode: 91160,
  },
  {
    province: "สตูล",
    district: "ควนกาหลง",
    "sub-district": "ทุ่งนุ้ย",
    postcode: 91130,
  },
  {
    province: "สตูล",
    district: "ควนกาหลง",
    "sub-district": "ควนกาหลง",
    postcode: 91130,
  },
  {
    province: "สตูล",
    district: "ควนกาหลง",
    "sub-district": "อุใดเจริญ",
    postcode: 91130,
  },
  {
    province: "สตูล",
    district: "ท่าแพ",
    "sub-district": "ท่าแพ",
    postcode: 91150,
  },
  {
    province: "สตูล",
    district: "ท่าแพ",
    "sub-district": "แป-ระ",
    postcode: 91150,
  },
  {
    province: "สตูล",
    district: "ท่าแพ",
    "sub-district": "สาคร",
    postcode: 91150,
  },
  {
    province: "สตูล",
    district: "ท่าแพ",
    "sub-district": "ท่าเรือ",
    postcode: 91150,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "กำแพง",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "ละงู",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "เขาขาว",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "ปากน้ำ",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "น้ำผุด",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ละงู",
    "sub-district": "แหลมสน",
    postcode: 91110,
  },
  {
    province: "สตูล",
    district: "ทุ่งหว้า",
    "sub-district": "ทุ่งหว้า",
    postcode: 91120,
  },
  {
    province: "สตูล",
    district: "ทุ่งหว้า",
    "sub-district": "นาทอน",
    postcode: 91120,
  },
  {
    province: "สตูล",
    district: "ทุ่งหว้า",
    "sub-district": "ขอนคลาน",
    postcode: 91120,
  },
  {
    province: "สตูล",
    district: "ทุ่งหว้า",
    "sub-district": "ทุ่งบุหลัง",
    postcode: 91120,
  },
  {
    province: "สตูล",
    district: "ทุ่งหว้า",
    "sub-district": "ป่าแก่บ่อหิน",
    postcode: 91120,
  },
  {
    province: "สตูล",
    district: "มะนัง",
    "sub-district": "ปาล์มพัฒนา",
    postcode: 91130,
  },
  {
    province: "สตูล",
    district: "มะนัง",
    "sub-district": "นิคมพัฒนา",
    postcode: 91130,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "ทับเที่ยง",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาพละ",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "บ้านควน",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาบินหลา",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "ควนปริง",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาโยงใต้",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "บางรัก",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "โคกหล่อ",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาโต๊ะหมิง",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "หนองตรุด",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "น้ำผุด",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาตาล่วง",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "บ้านโพธิ์",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาท่ามเหนือ",
    postcode: 92190,
  },
  {
    province: "ตรัง",
    district: "เมืองตรัง",
    "sub-district": "นาท่ามใต้",
    postcode: 92190,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "กันตัง",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "ควนธานี",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "บางหมาก",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "บางเป้า",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "วังวน",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "กันตังใต้",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "โคกยาง",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "คลองลุ",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "ย่านซื่อ",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "บ่อน้ำร้อน",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "บางสัก",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "นาเกลือ",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "เกาะลิบง",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "กันตัง",
    "sub-district": "คลองชีล้อม",
    postcode: 92110,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "ย่านตาขาว",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "หนองบ่อ",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "นาชุมเห็ด",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "ในควน",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "โพรงจระเข้",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "ทุ่งกระบือ",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "ทุ่งค่าย",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ย่านตาขาว",
    "sub-district": "เกาะเปียะ",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "ท่าข้าม",
    postcode: 92120,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "ทุ่งยาว",
    postcode: 92180,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "ปะเหลียน",
    postcode: 92180,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "บางด้วน",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "บ้านนา",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "สุโสะ",
    postcode: 92120,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "ลิพัง",
    postcode: 92180,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "เกาะสุกร",
    postcode: 92120,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "ท่าพญา",
    postcode: 92140,
  },
  {
    province: "ตรัง",
    district: "ปะเหลียน",
    "sub-district": "แหลมสอม",
    postcode: 92180,
  },
  {
    province: "ตรัง",
    district: "สิเกา",
    "sub-district": "บ่อหิน",
    postcode: 92150,
  },
  {
    province: "ตรัง",
    district: "สิเกา",
    "sub-district": "เขาไม้แก้ว",
    postcode: 92150,
  },
  {
    province: "ตรัง",
    district: "สิเกา",
    "sub-district": "กะลาเส",
    postcode: 92150,
  },
  {
    province: "ตรัง",
    district: "สิเกา",
    "sub-district": "ไม้ฝาด",
    postcode: 92150,
  },
  {
    province: "ตรัง",
    district: "สิเกา",
    "sub-district": "นาเมืองเพชร",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ห้วยยอด",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "หนองช้างแล่น",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "บางดี",
    postcode: 92210,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "บางกุ้ง",
    postcode: 92210,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "เขากอบ",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "เขาขาว",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "เขาปูน",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ปากแจ่ม",
    postcode: 92190,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ปากคม",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ท่างิ้ว",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ลำภูรา",
    postcode: 92190,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "นาวง",
    postcode: 92210,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ห้วยนาง",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ในเตา",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "ทุ่งต่อ",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "ห้วยยอด",
    "sub-district": "วังคีรี",
    postcode: 92210,
  },
  {
    province: "ตรัง",
    district: "วังวิเศษ",
    "sub-district": "เขาวิเศษ",
    postcode: 92220,
  },
  {
    province: "ตรัง",
    district: "วังวิเศษ",
    "sub-district": "วังมะปราง",
    postcode: 92220,
  },
  {
    province: "ตรัง",
    district: "วังวิเศษ",
    "sub-district": "อ่าวตง",
    postcode: 92220,
  },
  {
    province: "ตรัง",
    district: "วังวิเศษ",
    "sub-district": "ท่าสะบ้า",
    postcode: 92000,
  },
  {
    province: "ตรัง",
    district: "วังวิเศษ",
    "sub-district": "วังมะปรางเหนือ",
    postcode: 92220,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "นาโยงเหนือ",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "ช่อง",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "ละมอ",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "โคกสะบ้า",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "นาหมื่นศรี",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "นาโยง",
    "sub-district": "นาข้าวเสีย",
    postcode: 92170,
  },
  {
    province: "ตรัง",
    district: "รัษฎา",
    "sub-district": "ควนเมา",
    postcode: 92160,
  },
  {
    province: "ตรัง",
    district: "รัษฎา",
    "sub-district": "คลองปาง",
    postcode: 92160,
  },
  {
    province: "ตรัง",
    district: "รัษฎา",
    "sub-district": "หนองบัว",
    postcode: 92160,
  },
  {
    province: "ตรัง",
    district: "รัษฎา",
    "sub-district": "หนองปรือ",
    postcode: 92130,
  },
  {
    province: "ตรัง",
    district: "รัษฎา",
    "sub-district": "เขาไพร",
    postcode: 92160,
  },
  {
    province: "ตรัง",
    district: "หาดสำราญ",
    "sub-district": "หาดสำราญ",
    postcode: 92120,
  },
  {
    province: "ตรัง",
    district: "หาดสำราญ",
    "sub-district": "บ้าหวี",
    postcode: 92120,
  },
  {
    province: "ตรัง",
    district: "หาดสำราญ",
    "sub-district": "ตะเสะ",
    postcode: 92120,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "คูหาสวรรค์",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "เขาเจียก",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ท่ามิหรำ",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "โคกชะงาย",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "นาท่อม",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ปรางหมู่",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ท่าแค",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ลำปำ",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ตำนาน",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ควนมะพร้าว",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ร่มเมือง",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "ชัยบุรี",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "นาโหนด",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เมืองพัทลุง",
    "sub-district": "พญาขัน",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "กงหรา",
    "sub-district": "กงหรา",
    postcode: 93180,
  },
  {
    province: "พัทลุง",
    district: "กงหรา",
    "sub-district": "ชะรัด",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "กงหรา",
    "sub-district": "คลองเฉลิม",
    postcode: 93180,
  },
  {
    province: "พัทลุง",
    district: "กงหรา",
    "sub-district": "คลองทรายขาว",
    postcode: 93180,
  },
  {
    province: "พัทลุง",
    district: "กงหรา",
    "sub-district": "สมหวัง",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "เขาชัยสน",
    "sub-district": "เขาชัยสน",
    postcode: 93130,
  },
  {
    province: "พัทลุง",
    district: "เขาชัยสน",
    "sub-district": "ควนขนุน",
    postcode: 93130,
  },
  {
    province: "พัทลุง",
    district: "เขาชัยสน",
    "sub-district": "จองถนน",
    postcode: 93130,
  },
  {
    province: "พัทลุง",
    district: "เขาชัยสน",
    "sub-district": "หานโพธิ์",
    postcode: 93130,
  },
  {
    province: "พัทลุง",
    district: "เขาชัยสน",
    "sub-district": "โคกม่วง",
    postcode: 93130,
  },
  {
    province: "พัทลุง",
    district: "ตะโหมด",
    "sub-district": "แม่ขรี",
    postcode: 93160,
  },
  {
    province: "พัทลุง",
    district: "ตะโหมด",
    "sub-district": "ตะโหมด",
    postcode: 93160,
  },
  {
    province: "พัทลุง",
    district: "ตะโหมด",
    "sub-district": "คลองใหญ่",
    postcode: 93160,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "ควนขนุน",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "ทะเลน้อย",
    postcode: 93150,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "นาขยาด",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "พนมวังก์",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "แหลมโตนด",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "ปันแต",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "โตนดด้วน",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "ดอนทราย",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "มะกอกเหนือ",
    postcode: 93150,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "พนางตุง",
    postcode: 93150,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "ชะมวง",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ควนขนุน",
    "sub-district": "แพรกหา",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "ปากพะยูน",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "ดอนประดู่",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "เกาะนางคำ",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "เกาะหมาก",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "ฝาละมี",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "หารเทา",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ปากพะยูน",
    "sub-district": "ดอนทราย",
    postcode: 93120,
  },
  {
    province: "พัทลุง",
    district: "ศรีบรรพต",
    "sub-district": "เขาย่า",
    postcode: 93190,
  },
  {
    province: "พัทลุง",
    district: "ศรีบรรพต",
    "sub-district": "เขาปู่",
    postcode: 93190,
  },
  {
    province: "พัทลุง",
    district: "ศรีบรรพต",
    "sub-district": "ตะแพน",
    postcode: 93190,
  },
  {
    province: "พัทลุง",
    district: "ป่าบอน",
    "sub-district": "ป่าบอน",
    postcode: 93170,
  },
  {
    province: "พัทลุง",
    district: "ป่าบอน",
    "sub-district": "โคกทราย",
    postcode: 93170,
  },
  {
    province: "พัทลุง",
    district: "ป่าบอน",
    "sub-district": "หนองธง",
    postcode: 93170,
  },
  {
    province: "พัทลุง",
    district: "ป่าบอน",
    "sub-district": "ทุ่งนารี",
    postcode: 93170,
  },
  {
    province: "พัทลุง",
    district: "ป่าบอน",
    "sub-district": "วังใหม่",
    postcode: 93170,
  },
  {
    province: "พัทลุง",
    district: "บางแก้ว",
    "sub-district": "ท่ามะเดื่อ",
    postcode: 93140,
  },
  {
    province: "พัทลุง",
    district: "บางแก้ว",
    "sub-district": "นาปะขอ",
    postcode: 93140,
  },
  {
    province: "พัทลุง",
    district: "บางแก้ว",
    "sub-district": "โคกสัก",
    postcode: 93140,
  },
  {
    province: "พัทลุง",
    district: "ป่าพะยอม",
    "sub-district": "ป่าพะยอม",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ป่าพะยอม",
    "sub-district": "ลานข่อย",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ป่าพะยอม",
    "sub-district": "เกาะเต่า",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ป่าพะยอม",
    "sub-district": "บ้านพร้าว",
    postcode: 93110,
  },
  {
    province: "พัทลุง",
    district: "ศรีนครินทร์",
    "sub-district": "ชุมพล",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "ศรีนครินทร์",
    "sub-district": "บ้านนา",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "ศรีนครินทร์",
    "sub-district": "อ่างทอง",
    postcode: 93000,
  },
  {
    province: "พัทลุง",
    district: "ศรีนครินทร์",
    "sub-district": "ลำสินธุ์",
    postcode: 93000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "สะบารัง",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "อาเนาะรู",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "จะบังติกอ",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "บานา",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "ตันหยงลุโละ",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "คลองมานิง",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "กะมิยอ",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "บาราโหม",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "ปะกาฮะรัง",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "รูสะมิแล",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "ตะลุโบะ",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "บาราเฮาะ",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "เมืองปัตตานี",
    "sub-district": "ปุยุด",
    postcode: 94000,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "โคกโพธิ์",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "มะกรูด",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "บางโกระ",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ป่าบอน",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ทรายขาว",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "นาประดู่",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ปากล่อ",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ทุ่งพลา",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ท่าเรือ",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "นาเกตุ",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ควนโนรี",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "โคกโพธิ์",
    "sub-district": "ช้างให้ตก",
    postcode: 94120,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "เกาะเปาะ",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "คอลอตันหยง",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ดอนรัก",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ดาโต๊ะ",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ตุยง",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ท่ากำชำ",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "บ่อทอง",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "บางเขา",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "บางตาวา",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ปุโละปุโย",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ยาบี",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "หนองจิก",
    "sub-district": "ลิปะสะโง",
    postcode: 94170,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "ปะนาเระ",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "ท่าข้าม",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "บ้านนอก",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "ดอน",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "ควน",
    postcode: 94190,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "ท่าน้ำ",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "คอกกระบือ",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "พ่อมิ่ง",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "บ้านกลาง",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "ปะนาเระ",
    "sub-district": "บ้านน้ำบ่อ",
    postcode: 94130,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "มายอ",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ถนน",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ตรัง",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "กระหวะ",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ลุโบะยิไร",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ลางา",
    postcode: 94190,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "กระเสาะ",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "เกาะจัน",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ปะโด",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "สาคอบน",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "สาคอใต้",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "สะกำ",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "มายอ",
    "sub-district": "ปานัน",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "ทุ่งยางแดง",
    "sub-district": "ตะโละแมะนา",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "ทุ่งยางแดง",
    "sub-district": "พิเทน",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "ทุ่งยางแดง",
    "sub-district": "น้ำดำ",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "ทุ่งยางแดง",
    "sub-district": "ปากู",
    postcode: 94140,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "ตะลุบัน",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "ตะบิ้ง",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "ปะเสยะวอ",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "บางเก่า",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "บือเระ",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "เตราะบอน",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "กะดุนง",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "ละหาร",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "มะนังดาลำ",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "แป้น",
    postcode: 94110,
  },
  {
    province: "ปัตตานี",
    district: "สายบุรี",
    "sub-district": "ทุ่งคล้า",
    postcode: 94190,
  },
  {
    province: "ปัตตานี",
    district: "ไม้แก่น",
    "sub-district": "ไทรทอง",
    postcode: 94220,
  },
  {
    province: "ปัตตานี",
    district: "ไม้แก่น",
    "sub-district": "ไม้แก่น",
    postcode: 94220,
  },
  {
    province: "ปัตตานี",
    district: "ไม้แก่น",
    "sub-district": "ตะโละไกรทอง",
    postcode: 94220,
  },
  {
    province: "ปัตตานี",
    district: "ไม้แก่น",
    "sub-district": "ดอนทราย",
    postcode: 94220,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตะโละ",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตะโละกาโปร์",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตันหยงดาลอ",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตันหยงจึงงา",
    postcode: 94190,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตอหลัง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตาแกะ",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ตาลีอายร์",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ยามู",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "บางปู",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "หนองแรต",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ปิยามุมัง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ปุลากง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "บาโลย",
    postcode: 94190,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "สาบัน",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "มะนังยง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "ราตาปันยัง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "จะรัง",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะหริ่ง",
    "sub-district": "แหลมโพธิ์",
    postcode: 94150,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "ยะรัง",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "สะดาวา",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "ประจัน",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "สะนอ",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "ระแว้ง",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "ปิตูมุดี",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "วัด",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "กระโด",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "คลองใหม่",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "เมาะมาวี",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "กอลำ",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "ยะรัง",
    "sub-district": "เขาตูม",
    postcode: 94160,
  },
  {
    province: "ปัตตานี",
    district: "กะพ้อ",
    "sub-district": "กะรุบี",
    postcode: 94230,
  },
  {
    province: "ปัตตานี",
    district: "กะพ้อ",
    "sub-district": "ตะโละดือรามัน",
    postcode: 94230,
  },
  {
    province: "ปัตตานี",
    district: "กะพ้อ",
    "sub-district": "ปล่องหอย",
    postcode: 94230,
  },
  {
    province: "ปัตตานี",
    district: "แม่ลาน",
    "sub-district": "แม่ลาน",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "แม่ลาน",
    "sub-district": "ม่วงเตี้ย",
    postcode: 94180,
  },
  {
    province: "ปัตตานี",
    district: "แม่ลาน",
    "sub-district": "ป่าไร่",
    postcode: 94180,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "สะเตง",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "บุดี",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ยุโป",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ลิดล",
    postcode: 95160,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ยะลา",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ท่าสาป",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ลำใหม่",
    postcode: 95160,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "หน้าถ้ำ",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ลำพะยา",
    postcode: 95160,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "เปาะเส้ง",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "พร่อน",
    postcode: 95160,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "บันนังสาเรง",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "สะเตงนอก",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เมืองยะลา",
    "sub-district": "ตาเซะ",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "เบตง",
    "sub-district": "เบตง",
    postcode: 95110,
  },
  {
    province: "ยะลา",
    district: "เบตง",
    "sub-district": "ยะรม",
    postcode: 95110,
  },
  {
    province: "ยะลา",
    district: "เบตง",
    "sub-district": "ตาเนาะแมเราะ",
    postcode: 95110,
  },
  {
    province: "ยะลา",
    district: "เบตง",
    "sub-district": "อัยเยอร์เวง",
    postcode: 95110,
  },
  {
    province: "ยะลา",
    district: "เบตง",
    "sub-district": "ธารน้ำทิพย์",
    postcode: 95110,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "บันนังสตา",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "บาเจาะ",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "ตาเนาะปูเต๊ะ",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "ถ้ำทะลุ",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "ตลิ่งชัน",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "บันนังสตา",
    "sub-district": "เขื่อนบางลาง",
    postcode: 95130,
  },
  {
    province: "ยะลา",
    district: "ธารโต",
    "sub-district": "ธารโต",
    postcode: 95150,
  },
  {
    province: "ยะลา",
    district: "ธารโต",
    "sub-district": "บ้านแหร",
    postcode: 95150,
  },
  {
    province: "ยะลา",
    district: "ธารโต",
    "sub-district": "แม่หวาด",
    postcode: 95170,
  },
  {
    province: "ยะลา",
    district: "ธารโต",
    "sub-district": "คีรีเขต",
    postcode: 95150,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "ยะหา",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "ละแอ",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "ปะแต",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "บาโร๊ะ",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "ตาชี",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "บาโงยซิแน",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "ยะหา",
    "sub-district": "กาตอง",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "กายูบอเกาะ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "กาลูปัง",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "กาลอ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "กอตอตือร๊ะ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "โกตาบารู",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "เกะรอ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "จะกว๊ะ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "ท่าธง",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "เนินงาม",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "บาลอ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "บาโงย",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "บือมัง",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "ยะต๊ะ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "วังพญา",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "อาซ่อง",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "รามัน",
    "sub-district": "ตะโล๊ะหะลอ",
    postcode: 95140,
  },
  {
    province: "ยะลา",
    district: "กาบัง",
    "sub-district": "กาบัง",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "กาบัง",
    "sub-district": "บาละ",
    postcode: 95120,
  },
  {
    province: "ยะลา",
    district: "กรงปินัง",
    "sub-district": "กรงปินัง",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "กรงปินัง",
    "sub-district": "สะเอะ",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "กรงปินัง",
    "sub-district": "ห้วยกระทิง",
    postcode: 95000,
  },
  {
    province: "ยะลา",
    district: "กรงปินัง",
    "sub-district": "ปุโรง",
    postcode: 95000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "บางนาค",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "ลำภู",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "มะนังตายอ",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "บางปอ",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "กะลุวอ",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "กะลุวอเหนือ",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "เมืองนราธิวาส",
    "sub-district": "โคกเคียน",
    postcode: 96000,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "เจ๊ะเห",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "ไพรวัน",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "พร่อน",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "ศาลาใหม่",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "บางขุนทอง",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "เกาะสะท้อน",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "นานาค",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "ตากใบ",
    "sub-district": "โฆษิต",
    postcode: 96110,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "บาเจาะ",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "ลุโบะสาวอ",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "กาเยาะมาตี",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "ปะลุกาสาเมาะ",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "บาเระเหนือ",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "บาเจาะ",
    "sub-district": "บาเระใต้",
    postcode: 96170,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "ยี่งอ",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "ละหาร",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "จอเบาะ",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "ลุโบะบายะ",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "ลุโบะบือซา",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ยี่งอ",
    "sub-district": "ตะปอเยาะ",
    postcode: 96180,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "ตันหยงมัส",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "ตันหยงลิมอ",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "บองอ",
    postcode: 96220,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "กาลิซา",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "บาโงสะโต",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "เฉลิม",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "ระแงะ",
    "sub-district": "มะรือโบตก",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "รือเสาะ",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "สาวอ",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "เรียง",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "สามัคคี",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "บาตง",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "ลาโละ",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "รือเสาะออก",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "โคกสะตอ",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "รือเสาะ",
    "sub-district": "สุวารี",
    postcode: 96150,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "ซากอ",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "ตะมะยูง",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "ศรีสาคร",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "เชิงคีรี",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "กาหลง",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "ศรีสาคร",
    "sub-district": "ศรีบรรพต",
    postcode: 96210,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "แว้ง",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "กายูคละ",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "ฆอเลาะ",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "โละจูด",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "แม่ดง",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "แว้ง",
    "sub-district": "เอราวัณ",
    postcode: 96160,
  },
  {
    province: "นราธิวาส",
    district: "สุคิริน",
    "sub-district": "มาโมง",
    postcode: 96190,
  },
  {
    province: "นราธิวาส",
    district: "สุคิริน",
    "sub-district": "สุคิริน",
    postcode: 96190,
  },
  {
    province: "นราธิวาส",
    district: "สุคิริน",
    "sub-district": "เกียร์",
    postcode: 96190,
  },
  {
    province: "นราธิวาส",
    district: "สุคิริน",
    "sub-district": "ภูเขาทอง",
    postcode: 96190,
  },
  {
    province: "นราธิวาส",
    district: "สุคิริน",
    "sub-district": "ร่มไทร",
    postcode: 96190,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงโกลก",
    "sub-district": "สุไหงโก-ลก",
    postcode: 96120,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงโกลก",
    "sub-district": "ปาเสมัส",
    postcode: 96120,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงโกลก",
    "sub-district": "มูโนะ",
    postcode: 96120,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงโกลก",
    "sub-district": "ปูโยะ",
    postcode: 96120,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "ปะลุรู",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "สุไหงปาดี",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "โต๊ะเด็ง",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "สากอ",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "ริโก๋",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "สุไหงปาดี",
    "sub-district": "กาวะ",
    postcode: 96140,
  },
  {
    province: "นราธิวาส",
    district: "จะแนะ",
    "sub-district": "จะแนะ",
    postcode: 96220,
  },
  {
    province: "นราธิวาส",
    district: "จะแนะ",
    "sub-district": "ดุซงญอ",
    postcode: 96220,
  },
  {
    province: "นราธิวาส",
    district: "จะแนะ",
    "sub-district": "ผดุงมาตร",
    postcode: 96220,
  },
  {
    province: "นราธิวาส",
    district: "จะแนะ",
    "sub-district": "ช้างเผือก",
    postcode: 96220,
  },
  {
    province: "นราธิวาส",
    district: "เจาะไอร้อง",
    "sub-district": "จวบ",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "เจาะไอร้อง",
    "sub-district": "บูกิต",
    postcode: 96130,
  },
  {
    province: "นราธิวาส",
    district: "เจาะไอร้อง",
    "sub-district": "มะรือโบออก",
    postcode: 96130,
  },
];
export default addressTH;
